import { useSelector } from "react-redux";
import "./icons.scss";
/////////////////////////////////////////////////
export const SecureSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} className={`icons ${className}`} x="0" y="0" viewBox="0 0 229.5 229.5">
		<path d="M214.419,32.12c-0.412-2.959-2.541-5.393-5.419-6.193L116.76,0.275c-1.315-0.366-2.704-0.366-4.02,0L20.5,25.927
	c-2.878,0.8-5.007,3.233-5.419,6.193c-0.535,3.847-12.74,94.743,18.565,139.961c31.268,45.164,77.395,56.738,79.343,57.209
	c0.579,0.14,1.169,0.209,1.761,0.209s1.182-0.07,1.761-0.209c1.949-0.471,48.076-12.045,79.343-57.209
	C227.159,126.864,214.954,35.968,214.419,32.12z M174.233,85.186l-62.917,62.917c-1.464,1.464-3.384,2.197-5.303,2.197
	s-3.839-0.732-5.303-2.197l-38.901-38.901c-1.407-1.406-2.197-3.314-2.197-5.303s0.791-3.897,2.197-5.303l7.724-7.724
	c2.929-2.928,7.678-2.929,10.606,0l25.874,25.874l49.89-49.891c1.406-1.407,3.314-2.197,5.303-2.197s3.897,0.79,5.303,2.197
	l7.724,7.724C177.162,77.508,177.162,82.257,174.233,85.186z"/>
	</svg>)
};

export const PhotoSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} className={`icons ${className}`} x="0" y="0" viewBox="0 0 307.308 307.308">
		<g xmlns="http://www.w3.org/2000/svg" id="_x31_1-DSLR_Camera">
			<path d="M284.909,66.146h-81.345l-16.426-27.595c-1.607-2.698-4.514-4.351-7.654-4.351h-51.662c-3.14,0-6.048,1.653-7.654,4.351   l-16.426,27.595H77.049v-6.082c0-4.919-3.988-8.907-8.907-8.907H35.185c-4.92,0-8.907,3.988-8.907,8.907v6.082h-3.88   C10.027,66.146,0,76.174,0,88.543v162.166c0,12.37,10.027,22.398,22.397,22.398h262.512c12.37,0,22.398-10.028,22.398-22.398   V88.543C307.308,76.174,297.279,66.146,284.909,66.146z M153.653,233.379c-35.21,0-63.753-28.543-63.753-63.754   c0-35.209,28.543-63.753,63.753-63.753c35.21,0,63.753,28.544,63.753,63.753C217.406,204.836,188.863,233.379,153.653,233.379z    M270.935,112.322h-27.91c-4.919,0-8.907-3.988-8.907-8.908c0-4.92,3.988-8.908,8.907-8.908h27.91c4.921,0,8.908,3.988,8.908,8.908   C279.843,108.334,275.855,112.322,270.935,112.322z" />
			<circle cx="153.653" cy="169.625" r="44.538" />
		</g>
	</svg>)
};

export const CorrectSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 -46 417.81333 417">
		<path d="m159.988281 318.582031c-3.988281 4.011719-9.429687 6.25-15.082031 6.25s-11.09375-2.238281-15.082031-6.25l-120.449219-120.46875c-12.5-12.5-12.5-32.769531 0-45.246093l15.082031-15.085938c12.503907-12.5 32.75-12.5 45.25 0l75.199219 75.203125 203.199219-203.203125c12.503906-12.5 32.769531-12.5 45.25 0l15.082031 15.085938c12.5 12.5 12.5 32.765624 0 45.246093zm0 0" />
	</svg>)
};

export const InfoSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 45.818 45.818">
		<g>
			<path d="M22.909,0C10.258,0,0,10.257,0,22.908c0,12.652,10.258,22.91,22.909,22.91s22.909-10.258,22.909-22.91
		C45.818,10.257,35.561,0,22.909,0z M26.411,35.417c0,1.921-1.573,3.478-3.492,3.478c-1.92,0-3.492-1.557-3.492-3.478V20.201
		c0-1.92,1.572-3.477,3.492-3.477c1.919,0,3.492,1.556,3.492,3.477V35.417z M22.909,13.851c-2.119,0-3.837-1.718-3.837-3.836
		c0-2.12,1.718-3.836,3.837-3.836c2.118,0,3.837,1.716,3.837,3.836C26.746,12.133,25.027,13.851,22.909,13.851z"/>
		</g>
	</svg>)
};

export const ZoomInSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512">
		<g>
			<g>
				<path d="M496.64,424.96l-71.68-71.68c23.04-35.84,35.84-76.8,35.84-122.88C460.8,102.4,358.4,0,230.4,0S0,102.4,0,230.4
			s102.4,230.4,230.4,230.4c46.08,0,87.04-12.8,122.88-35.84l71.68,71.68c20.48,20.48,51.2,20.48,71.68,0
			C517.12,476.16,517.12,445.44,496.64,424.96z M230.4,409.6c-99.84,0-179.2-79.36-179.2-179.2S130.56,51.2,230.4,51.2
			s179.2,79.36,179.2,179.2S327.68,409.6,230.4,409.6z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M332.8,204.8H256V128c0-15.36-10.24-25.6-25.6-25.6c-15.36,0-25.6,12.8-25.6,25.6v76.8H128c-12.8,0-25.6,10.24-25.6,25.6
			c0,15.36,10.24,25.6,25.6,25.6h76.8v76.8c0,15.36,10.24,25.6,25.6,25.6c15.36,0,25.6-10.24,25.6-25.6V256h76.8
			c15.36,0,25.6-10.24,25.6-25.6C358.4,215.04,345.6,204.8,332.8,204.8z"/>
			</g>
		</g>
	</svg>)
};

export const BlockSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 439.963 439.963">
		<g>
			<path d="M421.836,134.33c-11.611-27.121-27.172-50.487-46.686-70.089c-19.502-19.604-42.824-35.215-69.948-46.825
		C278.088,5.806,249.674,0,219.985,0c-29.692,0-58.101,5.809-85.224,17.416c-27.124,11.61-50.441,27.218-69.949,46.825
		C45.303,83.843,29.74,107.209,18.13,134.33C6.521,161.453,0.715,189.958,0.715,219.838c0,29.881,5.806,58.432,17.415,85.648
		c11.613,27.223,27.172,50.627,46.682,70.236c19.508,19.605,42.825,35.217,69.949,46.818c27.123,11.615,55.531,17.422,85.224,17.422
		c29.693,0,58.103-5.807,85.217-17.422c27.124-11.607,50.446-27.213,69.948-46.818c19.514-19.609,35.074-43.014,46.686-70.236
		c11.611-27.217,17.412-55.768,17.412-85.648C439.244,189.958,433.447,161.453,421.836,134.33z M90.078,305.198
		c-16.94-26.066-25.41-54.532-25.406-85.364c0-28.167,6.949-54.243,20.843-78.227c13.891-23.982,32.738-42.919,56.527-56.818
		c23.791-13.894,49.772-20.839,77.943-20.839c31.411,0,59.952,8.661,85.652,25.981L90.078,305.198z M363.013,280.511
		c-8.187,19.318-19.219,35.927-33.113,49.823c-13.9,13.895-30.409,24.982-49.539,33.254c-19.13,8.277-39.259,12.422-60.382,12.422
		c-30.452,0-58.717-8.466-84.794-25.413l215.273-214.985c16.566,25.505,24.838,53.581,24.838,84.223
		C375.291,240.965,371.198,261.187,363.013,280.511z"/>
		</g>
	</svg>)
};

export const SearchSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 513.28 513.28">
		<g xmlns="http://www.w3.org/2000/svg">
			<g>
				<path d="M495.04,404.48L410.56,320c15.36-30.72,25.6-66.56,25.6-102.4C436.16,97.28,338.88,0,218.56,0S0.96,97.28,0.96,217.6    s97.28,217.6,217.6,217.6c35.84,0,71.68-10.24,102.4-25.6l84.48,84.48c25.6,25.6,64,25.6,89.6,0    C518.08,468.48,518.08,430.08,495.04,404.48z M218.56,384c-92.16,0-166.4-74.24-166.4-166.4S126.4,51.2,218.56,51.2    s166.4,74.24,166.4,166.4S310.72,384,218.56,384z" />
			</g>
		</g>
	</svg>)
};

export const FollowersSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512">
		<g>
			<path d="M234.071,471.132H60.391c-6.453,0-12.333-2.991-16.135-8.207c-3.803-5.218-4.85-11.736-2.874-17.883
				c19.732-61.346,79.908-104.191,146.336-104.191c30.909,0,60.591,9.308,85.838,26.916c9.043,6.307,21.485,4.09,27.795-4.953
				c6.306-9.043,4.089-21.486-4.954-27.794c-12.498-8.717-25.85-15.828-39.817-21.257c18.583-16.896,30.911-40.555,33.053-67.048
				c28.177-27.448,65.111-42.488,104.704-42.488c30.909,0,60.591,9.308,85.838,26.916c9.043,6.307,21.486,4.09,27.795-4.953
				c6.306-9.043,4.089-21.486-4.954-27.794c-12.498-8.717-25.85-15.828-39.817-21.257c20.499-18.638,33.386-45.506,33.386-75.328
				C496.586,45.673,450.913,0,394.774,0c-56.14,0-101.812,45.673-101.812,101.813c0,29.701,12.784,56.473,33.139,75.102
				c-2.785,1.072-5.55,2.212-8.295,3.42c-12.492,5.497-24.241,12.245-35.162,20.183c-15.068-37.415-51.746-63.893-94.49-63.893
				c-56.14,0-101.812,45.673-101.812,101.813c0,29.614,12.71,56.316,32.96,74.938c-54.148,20.292-98.053,63.87-115.927,119.444
				c-5.928,18.431-2.788,37.976,8.616,53.623c11.402,15.645,29.042,24.618,48.401,24.618h173.68
				c11.026,0,19.963-8.938,19.963-19.963S245.096,471.132,234.071,471.132z M394.775,39.926c34.124,0,61.886,27.762,61.886,61.886
				s-27.762,61.886-61.886,61.886c-34.124,0-61.886-27.762-61.886-61.886S360.651,39.926,394.775,39.926z M188.155,176.55
				c34.124,0,61.886,27.762,61.886,61.886s-27.762,61.886-61.886,61.886s-61.886-27.762-61.886-61.886
				S154.031,176.55,188.155,176.55z"/>
			<path d="M503.217,326.082c-8.965-6.418-21.436-4.354-27.853,4.612l-98.4,137.447c-2.687,3.116-6.055,3.789-7.859,3.909
				c-1.857,0.127-5.463-0.114-8.555-3.057l-63.703-61.168c-7.954-7.638-20.593-7.379-28.226,0.573
				c-7.637,7.952-7.38,20.59,0.572,28.226l63.767,61.228c9.55,9.091,22.298,14.149,35.414,14.149c1.127,0,2.257-0.037,3.387-0.113
				c14.288-0.952,27.628-7.9,36.599-19.062c0.233-0.289,0.455-0.584,0.672-0.885l98.799-138.006
				C514.247,344.97,512.183,332.5,503.217,326.082z"/>
		</g>
	</svg>)
};

export const InboxSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 384 384">
		<g>
			<g>
				<g>
					<polygon points="277.333,149.333 234.667,149.333 234.667,85.333 149.333,85.333 149.333,149.333 106.667,149.333 192,234.667 
							"/>
					<path d="M341.333,0H42.453C18.88,0,0.213,19.093,0.213,42.667L0,341.333C0,364.907,18.88,384,42.453,384h298.88
				C364.907,384,384,364.907,384,341.333V42.667C384,19.093,364.907,0,341.333,0z M341.333,256H256c0,35.307-28.693,64-64,64
				s-64-28.693-64-64H42.453V42.667h298.88V256z"/>
				</g>
			</g>
		</g>
	</svg>)
};

export const ReloadSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512">
		<g>
			<path d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M102.667,264.135
			c-1.84,1.506-4.1,2.531-6.667,2.531c-5.896,0-10.667-4.771-10.667-10.667c0-12.348,1.682-24.526,4.292-36.483
			c0,0,2.1-9.458,2.188-9.703c20.47-72.668,87.898-124.48,164.188-124.48c61.859,0,119.253,34.085,149.172,87.702
			c2.954,5.296,0.534,12.059-4.944,14.658l-19.316,9.168c-5.141,2.44-11.065,0.277-13.91-4.652C344.315,152.897,301.79,128,256,128
			c-44.453,0-84.882,23.462-107.936,59.448l15.311,5.104c3.667,1.219,6.385,4.333,7.104,8.135s-0.677,7.698-3.646,10.177l-64,53.333
			C102.78,264.242,102.72,264.107,102.667,264.135z M423.484,292.483c0,0-2.1,9.458-2.188,9.703
			c-20.47,72.668-87.898,124.48-164.188,124.48c-61.859,0-119.253-34.085-149.172-87.702c-2.954-5.296-0.534-12.059,4.944-14.658
			l19.316-9.168c5.141-2.44,11.065-0.277,13.91,4.652C168.794,359.103,211.319,384,257.109,384
			c44.453,0,84.882-23.462,107.936-59.448l-15.311-5.104c-3.667-1.219-6.385-4.333-7.104-8.135s0.677-7.698,3.646-10.177l64-53.333
			c0.053-0.044,0.113,0.091,0.167,0.063c1.84-1.506,4.1-2.531,6.667-2.531c5.896,0,10.667,4.771,10.667,10.667
			C427.776,268.348,426.094,280.526,423.484,292.483z"/>
		</g>
	</svg>)
};

export const PublickSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 280 280">
		<path d="M258.919,213.897c-14.464-29.244-33.785-57.213-53.916-82.187c2.913-11.34,5.439-22.108,7.635-32.194
	c9.816-0.903,17.828-8.067,20.032-17.453c10.895-1.455,22.007-2.499,33.285-3.043C274.947,97.49,280,118.217,280,140.102
	C280,167.167,272.272,192.457,258.919,213.897z M210.939,19.452c-0.633,6.155-2.052,18.339-4.798,35.098
	c-9.919,1.95-17.524,10.363-18.274,20.655c-9.219,2.139-18.202,4.503-26.911,7.037c-3.934-4.034-7.78-7.895-11.496-11.553
	c-7.995-7.869-15.755-15.184-23.078-21.875c1.223-2.789,1.911-5.862,1.911-9.098c0-3.859-0.972-7.494-2.676-10.682
	c7.804-10.228,16.523-19.81,26.234-28.424C173.273,2.414,193.335,9.061,210.939,19.452z M114.698,18.903
	c-2.806-1.24-5.9-1.941-9.159-1.941c-4.359,0-8.422,1.254-11.886,3.388c-3.915-3.233-7.361-6.018-10.224-8.295
	c14.59-6.472,30.482-10.517,47.166-11.629C124.933,6.302,119.648,12.49,114.698,18.903z M105.539,62.471
	c3.874,0,7.521-0.977,10.717-2.692c8.968,8.21,18.636,17.402,28.609,27.422c-23.364,7.604-44.398,16.191-62.249,24.4
	c5.726-16.266,12.822-33.014,21.587-49.198C104.647,62.429,105.087,62.471,105.539,62.471z M54.778,154.401
	c-0.871,3.743-1.685,7.433-2.447,11.064c-2.936-6.116-5.543-12.018-7.866-17.658c4.348-2.461,8.962-5.004,13.849-7.601
	C57.024,145.068,55.846,149.815,54.778,154.401z M59.514,212.894c0.8-0.072,1.59-0.182,2.365-0.335
	c14.313,21.876,32.603,44.494,55.921,65.776c-22.839-3.654-43.853-12.845-61.611-26.159
	C56.434,245.801,57.198,231.655,59.514,212.894z M74.706,205.043c3.423-3.982,5.506-9.147,5.506-14.798
	c0-9.268-5.577-17.245-13.544-20.789c0.817-3.936,1.695-7.939,2.643-11.999c1.949-8.351,4.272-17.238,7.008-26.434
	c1.108-0.542,2.216-1.084,3.344-1.627c20.844-10.032,47.032-21.08,76.788-30.307c10.762,11.277,21.683,23.408,32.285,36.206
	c-11.116,41.772-27.46,90.688-51.298,140.512C110.692,253.248,90.259,228.701,74.706,205.043z M172.548,94.392
	c6.243-1.712,12.62-3.329,19.114-4.83c1.727,2.562,3.972,4.739,6.569,6.417c-1.493,6.878-3.145,14.085-4.975,21.585
	C186.302,109.425,179.347,101.677,172.548,94.392z M257.858,64.615c-9.026,0.605-17.938,1.51-26.71,2.673
	c-2.151-4.608-5.792-8.377-10.311-10.684c1.886-11.533,3.159-20.947,3.987-27.8C237.802,38.72,249.006,50.842,257.858,64.615z
	 M68.917,19.536c3.294,2.563,8.565,6.739,15.299,12.315c-0.909,2.455-1.431,5.097-1.431,7.864c0,6.745,2.966,12.796,7.644,16.967
	c-11.34,21.188-19.93,43.174-26.427,63.869c-9.062,4.547-17.399,9.009-24.951,13.243c-12.46-34.568-15.879-61.591-16.667-69.547
	C34.205,45.982,50.162,30.637,68.917,19.536z M10.667,86.521c2.616,13.849,7.243,32.885,15.333,54.808
	c-10.636,6.325-19.058,11.797-24.962,15.795C0.357,151.543,0,145.864,0,140.102C0,121.132,3.8,103.035,10.667,86.521z
	 M3.955,173.167c4.912-3.456,14.371-9.878,27.566-17.81c2.64,6.306,5.627,12.917,8.994,19.752c-3.6,4.026-5.811,9.321-5.811,15.136
	c0,7.937,4.091,14.927,10.268,19.001c-1.57,12.343-2.484,22.82-3.014,30.691C23.625,221.93,10.217,198.932,3.955,173.167z
	 M152.09,279.574c21.642-45.704,37.12-90.583,48.122-129.988c19,24.447,36.295,50.906,48.87,78.165
	C225.773,256.7,191.206,276.212,152.09,279.574z"/>
	</svg>)
};

export const LockSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 486.733 486.733">
		<g>
			<path d="M403.88,196.563h-9.484v-44.388c0-82.099-65.151-150.681-146.582-152.145c-2.225-0.04-6.671-0.04-8.895,0
		C157.486,1.494,92.336,70.076,92.336,152.175v44.388h-9.485c-14.616,0-26.538,15.082-26.538,33.709v222.632
		c0,18.606,11.922,33.829,26.539,33.829h321.028c14.616,0,26.539-15.223,26.539-33.829V230.272
		C430.419,211.646,418.497,196.563,403.88,196.563z M273.442,341.362v67.271c0,7.703-6.449,14.222-14.158,14.222H227.45
		c-7.71,0-14.159-6.519-14.159-14.222v-67.271c-7.477-7.36-11.83-17.537-11.83-28.795c0-21.334,16.491-39.666,37.459-40.513
		c2.222-0.09,6.673-0.09,8.895,0c20.968,0.847,37.459,19.179,37.459,40.513C285.272,323.825,280.919,334.002,273.442,341.362z
		 M331.886,196.563h-84.072h-8.895h-84.072v-44.388c0-48.905,39.744-89.342,88.519-89.342c48.775,0,88.521,40.437,88.521,89.342
		V196.563z"/>
		</g>
	</svg>)
};

export const UnlockSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 486.866 486.866">
		<g>
			<path d="M393.904,214.852h-8.891v-72.198c0-76.962-61.075-141.253-137.411-142.625c-2.084-0.038-6.254-0.038-8.338,0
		C162.927,1.4,101.853,65.691,101.853,142.653v1.603c0,16.182,13.118,29.3,29.3,29.3c16.182,0,29.299-13.118,29.299-29.3v-1.603
		c0-45.845,37.257-83.752,82.98-83.752s82.981,37.907,82.981,83.752v72.198H92.963c-13.702,0-24.878,14.139-24.878,31.602v208.701
		c0,17.44,11.176,31.712,24.878,31.712h300.941c13.703,0,24.878-14.271,24.878-31.712V246.452
		C418.783,228.989,407.607,214.852,393.904,214.852z M271.627,350.591v63.062c0,7.222-6.046,13.332-13.273,13.332h-29.841
		c-7.228,0-13.273-6.11-13.273-13.332v-63.062c-7.009-6.9-11.09-16.44-11.09-26.993c0-19.999,15.459-37.185,35.115-37.977
		c2.083-0.085,6.255-0.085,8.337,0c19.656,0.792,35.115,17.978,35.115,37.977C282.717,334.149,278.637,343.69,271.627,350.591z"/>
		</g>
	</svg>)
};

export const PaintSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 431.985 431.985">
		<g>
			<path d="M423.257,51.829c-0.808-2.045-2.67-3.484-4.853-3.751c-2.177-0.266-4.335,0.682-5.612,2.472
		c-7.581,10.629-17.529,14.172-29.053,18.275c-9.292,3.31-18.901,6.73-29.286,14.186c-14.687,10.544-21.405,24.917-18.055,38.54
		l-0.358,0.459c-6.133-8.897-12.806-17.126-19.848-24.474c-32.947-34.378-78.984-55.046-126.311-56.703
		c-2.085-0.073-4.204-0.11-6.298-0.11c-52.846,0-103.428,23.624-138.775,64.813C9.646,146.512-5.939,199.853,2.051,251.882
		c0.668,4.349,1.504,8.743,2.487,13.063c12.996,57.202,46.189,100.717,91.069,119.383c11.063,4.602,22.222,6.934,33.163,6.934
		c27.183,0,50.926-14.539,65.143-39.889c5.404-9.646,8.891-19.621,10.36-29.651c0.866-5.92,0.274-11.835-0.3-17.567
		c-0.591-5.9-1.149-11.476-0.256-17.09c2.047-12.869,11.036-20.553,24.047-20.553c3.701,0,7.483,0.609,11.26,1.812
		c-4.422,8.11-8.438,15.854-11.947,23.032c-7.437,15.212-12.567,27.81-15.252,37.44c-1.655,5.939-6.052,21.722,4.67,29.164
		c3.405,2.363,7.722,3.197,12.215,2.361c4.049-0.752,16.369-3.041,51.378-42.896c9.396-10.695,19.521-23.072,30.104-36.794
		c27.168-9.15,48.31-31.921,53.903-58.087c1.4-6.541,1.984-13.541,1.735-20.812c10.172-15.72,19.094-30.388,28.072-46.156
		c0.172-0.304,0.342-0.628,0.51-0.96c13.031-3.569,24.254-13.71,30.842-27.891C434.872,106.028,434.163,79.428,423.257,51.829z
		 M276.385,149.834c-4.713,7.485-12.814,11.954-21.673,11.954c-4.81,0-9.515-1.361-13.605-3.937
		c-5.782-3.642-9.803-9.317-11.316-15.98s-0.345-13.518,3.298-19.301c4.714-7.485,12.816-11.954,21.675-11.954
		c4.811,0,9.515,1.361,13.604,3.938c5.782,3.64,9.802,9.315,11.316,15.979C281.197,137.197,280.026,144.051,276.385,149.834z
		 M309.592,196.187c12.934-19.057,26.612-38,39.604-54.85c2.106,1.902,4.461,3.76,7.012,5.53c4.227,2.933,8.648,5.201,13.164,6.754
		c-10.969,18.758-22.763,37.342-37.043,58.375c-23.463,34.571-47.859,66.684-68.695,90.424
		c-11.638,13.26-21.823,23.498-29.671,29.839c3.029-9.69,8.818-22.989,16.875-38.746
		C265.245,265.336,286.111,230.772,309.592,196.187z M82.506,196.023c-4.811,0-9.516-1.361-13.607-3.938
		c-5.782-3.641-9.801-9.314-11.315-15.979c-1.514-6.664-0.342-13.519,3.301-19.302c4.711-7.484,12.813-11.953,21.671-11.953
		c4.812,0,9.517,1.361,13.607,3.938c11.936,7.518,15.532,23.345,8.019,35.279C99.466,191.554,91.363,196.023,82.506,196.023z
		 M55.688,252.358c4.713-7.486,12.814-11.955,21.673-11.955c4.81,0,9.514,1.362,13.606,3.938c5.782,3.641,9.801,9.315,11.315,15.979
		c1.515,6.662,0.343,13.516-3.301,19.301c-4.711,7.483-12.813,11.953-21.671,11.953c-4.811,0-9.517-1.361-13.609-3.938
		c-5.782-3.642-9.8-9.315-11.313-15.979C50.876,264.995,52.049,258.14,55.688,252.358z M137.62,100.414
		c4.713-7.485,12.815-11.954,21.673-11.954c4.809,0,9.514,1.361,13.604,3.937c11.937,7.516,15.533,23.344,8.019,35.28
		c-4.715,7.486-12.817,11.955-21.675,11.955c-4.81,0-9.515-1.361-13.605-3.938c-5.781-3.64-9.799-9.314-11.313-15.979
		C132.807,113.052,133.979,106.198,137.62,100.414z"/>
		</g>
	</svg>)
};

export const DarkModeSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} className={`icons ${className}`} x="0" y="0" viewBox="0 0 913.059 913.059">
		<g>
			<path d="M789.581,777.485c62.73-62.73,103.652-139.002,122.785-219.406c5.479-23.031-22.826-38.58-39.524-21.799
		c-0.205,0.207-0.41,0.412-0.615,0.617c-139.57,139.57-367.531,136.879-503.693-8.072
		c-128.37-136.658-126.685-348.817,3.673-483.579c1.644-1.699,3.3-3.378,4.97-5.037c16.744-16.635,1.094-44.811-21.869-39.354
		c-79.689,18.938-155.326,59.276-217.75,121.035c-182.518,180.576-183.546,473.345-2.245,655.14
		C315.821,958.032,608.883,958.182,789.581,777.485z"/>
		</g>
	</svg>)
};

export const EditPenSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} className={`icons ${className}`} x="0" y="0" viewBox="0 0 186 186">
		<path xmlns="http://www.w3.org/2000/svg" d="M186,24.333C186,10.894,175.106,0,161.667,0H24.333C10.894,0,0,10.894,0,24.333v137.333C0,175.106,10.894,186,24.333,186  h137.333C175.106,186,186,175.106,186,161.667V24.333z M41.751,151.882c-4.03,1.081-7.718-2.607-6.637-6.637l6.683-24.91  l24.863,24.863L41.751,151.882z M149.126,61.293l-73.584,73.585l-24.749-24.749l73.584-73.584c3.49-3.49,9.147-3.49,12.637,0  l12.112,12.112C152.615,52.146,152.615,57.803,149.126,61.293z" />
	</svg>)
};

export const ActivityStatusSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512">
		<g>
			<path d="m436.897 75.55c-48.43-48.432-112.674-75.103-180.898-75.103-68.381 0-132.668 26.629-181.02 74.98s-74.979 112.639-74.979 181.02c0 66.065 25.24 128.678 70.102 176h-22.102c-8.837 0-16 7.164-16 16s7.163 16 16 16h64c8.837 0 16-7.164 16-16v-64c0-8.836-7.163-16-16-16s-16 7.164-16 16v28.765c-40.918-41.72-64-97.667-64-156.765 0-123.514 100.485-224 223.999-224 59.676 0 115.885 23.343 158.271 65.73s65.73 98.595 65.73 158.271c0 116.747-87.56 212.655-203.67 223.09-1.431.12-2.431-.487-3.021-1.025-.598-.546-1.31-1.505-1.31-2.969v-92.438c45.345-7.64 80-47.176 80-94.659v-64c0-8.836-7.163-16-16-16h-16v-48c0-8.836-7.163-16-16-16s-16 7.164-16 16v48h-64v-48c0-8.836-7.163-16-16-16s-16 7.164-16 16v48h-16c-8.837 0-16 7.164-16 16v64c0 47.484 34.655 87.019 80 94.659v92.438c0 10.088 4.271 19.779 11.719 26.587 6.645 6.075 15.35 9.421 24.281 9.421 1.063 0 2.128-.047 3.194-.143 63.396-5.698 122.118-34.745 165.35-81.791 43.501-47.337 67.457-108.837 67.457-173.17 0-68.224-26.672-132.468-75.103-180.898zm-204.897 212.897c0-13.233 10.767-24 24-24s24 10.767 24 24-10.767 24-24 24-24-10.767-24-24z" />
		</g>
	</svg>)
};

export const LanguageSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512">
		<path d="m456.835938 208.867188h-192.800782c-30.417968 0-55.164062 24.746093-55.164062 55.164062v104.75l-49.953125 35.679688c-3.941407 2.8125-6.28125 7.359374-6.28125 12.203124 0 4.847657 2.339843 9.394532 6.28125 12.207032l50.554687 36.109375c3.949219 26.570312 26.914063 47.019531 54.5625 47.019531h192.800782c30.417968 0 55.164062-24.746094 55.164062-55.167969v-192.800781c0-30.417969-24.746094-55.164062-55.164062-55.164062zm-64.828126 210.773437c-3.535156 0-6.265624-1.121094-7.066406-4.175781l-6.109375-21.371094h-36.796875l-6.101562 21.371094c-.804688 3.054687-3.535156 4.175781-7.070313 4.175781-5.625 0-13.175781-3.53125-13.175781-8.671875 0-.324219.160156-.964844.320312-1.609375l31.011719-101.0625c1.445313-4.820313 7.390625-7.074219 13.335938-7.074219 6.105469 0 12.050781 2.253906 13.496093 7.074219l31.011719 101.0625c.160157.644531.320313 1.125.320313 1.609375 0 4.976562-7.550782 8.671875-13.175782 8.671875zm0 0" />
		<path d="m346.375 377.703125h27.960938l-13.984376-49.324219zm0 0" />
		<path d="m178.871094 264.03125c0-20.140625 7.042968-38.65625 18.773437-53.253906-17.113281 0-32.992187-5.355469-46.082031-14.453125-13.089844 9.101562-28.96875 14.453125-46.085938 14.453125-4.667968 0-8.457031-3.789063-8.457031-8.460938s3.789063-8.457031 8.457031-8.457031c11.988282 0 23.207032-3.320313 32.8125-9.070313-11.585937-12.503906-19.289062-28.648437-21.152343-46.515624h-11.65625c-4.671875 0-8.460938-3.785157-8.460938-8.457032s3.789063-8.460937 8.460938-8.460937h37.628906v-20.539063c0-4.675781 3.785156-8.460937 8.457031-8.460937s8.457032 3.785156 8.457032 8.460937v20.539063h37.628906c4.671875 0 8.460937 3.789062 8.460937 8.460937s-3.789062 8.457032-8.460937 8.457032h-11.65625c-1.863282 17.867187-9.566406 34.011718-21.152344 46.515624 9.601562 5.757813 20.824219 9.070313 32.808594 9.070313 4.464844 0 8.113281 3.460937 8.429687 7.847656 15.214844-14.15625 35.585938-22.839843 57.957031-22.839843h39.09375v-35.648438l49.953126-35.679688c3.9375-2.8125 6.277343-7.359374 6.277343-12.203124 0-4.847657-2.339843-9.394532-6.277343-12.207032l-50.554688-36.109375c-3.953125-26.570312-26.917969-47.019531-54.566406-47.019531h-192.796875c-30.421875 0-55.167969 24.746094-55.167969 55.164062v192.804688c0 30.417969 24.746094 55.164062 55.167969 55.164062h123.703125zm0 0" />
		<path d="m151.5625 174.21875c9.257812-9.605469 15.542969-22.078125 17.382812-35.941406h-34.761718c1.839844 13.863281 8.128906 26.335937 17.378906 35.941406zm0 0" />
	</svg>)
};

export const AccountSwitchSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} className={`icons ${className}`} x="0" y="0" viewBox="0 0 24 24">
		<path d="m20.25 11c-.414 0-.75-.336-.75-.75v-4.5c0-.689-.561-1.25-1.25-1.25h-7.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h7.5c1.517 0 2.75 1.233 2.75 2.75v4.5c0 .414-.336.75-.75.75z" />
		<path d="m20.25 11c-.192 0-.384-.073-.53-.22l-1.75-1.75c-.214-.214-.279-.537-.163-.817s.39-.463.693-.463h3.5c.303 0 .577.183.693.463s.052.603-.163.817l-1.75 1.75c-.146.147-.338.22-.53.22z" />
		<path d="m11.25 21h-5.5c-1.517 0-2.75-1.233-2.75-2.75v-4.5c0-.414.336-.75.75-.75s.75.336.75.75v4.5c0 .689.561 1.25 1.25 1.25h5.5c.414 0 .75.336.75.75s-.336.75-.75.75z" />
		<path d="m5.5 16.25h-3.5c-.303 0-.577-.183-.693-.463s-.052-.603.163-.817l1.75-1.75c.293-.293.768-.293 1.061 0l1.75 1.75c.214.214.279.537.163.817s-.391.463-.694.463z" />
		<circle cx="5" cy="2.5" r="2.5" />
		<path d="m7.25 6h-4.5c-1.517 0-2.75 1.233-2.75 2.75v.5c0 .414.336.75.75.75h8.5c.414 0 .75-.336.75-.75v-.5c0-1.517-1.233-2.75-2.75-2.75z" />
		<path d="m19 19c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5z" />
		<path d="m23.25 24h-8.5c-.414 0-.75-.336-.75-.75v-.5c0-1.517 1.233-2.75 2.75-2.75h4.5c1.517 0 2.75 1.233 2.75 2.75v.5c0 .414-.336.75-.75.75z" />
	</svg>)
};

export const SettingsSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512">
		<g>
			<path d="m151 256c0 57.897 47.103 105 105 105s105-47.103 105-105c0-34.988-17.1-66.832-45-86.187v86.187c0 5.015-2.507 9.699-6.68 12.481l-45 30c-5.039 3.359-11.602 3.359-16.641 0l-45-30c-4.173-2.782-6.68-7.465-6.68-12.481v-86.187c-27.899 19.355-44.999 51.199-44.999 86.187z" />
			<path d="m286 512v-124.365c-9.652 2.199-19.692 3.365-30 3.365s-20.348-1.166-30-3.365v124.365z" />
			<path d="m500.576 196.432-47.017-11.541c-2.221-6.091-4.78-12.189-7.66-18.245l24.488-40.815c3.541-5.902 2.611-13.457-2.256-18.324l-63.64-63.64c-4.866-4.867-12.422-5.797-18.324-2.256l-40.814 24.489c-6.057-2.88-12.154-5.44-18.246-7.661l-11.54-47.015c-1.646-6.707-7.66-11.424-14.567-11.424h-90c-6.907 0-12.921 4.717-14.567 11.424l-11.54 47.015c-6.092 2.221-12.189 4.781-18.246 7.661l-40.814-24.489c-5.901-3.541-13.457-2.611-18.324 2.256l-63.64 63.64c-4.867 4.867-5.797 12.422-2.256 18.324l24.488 40.815c-2.88 6.056-5.439 12.154-7.66 18.245l-47.017 11.541c-6.707 1.647-11.424 7.661-11.424 14.568v90c0 6.907 4.717 12.921 11.424 14.568l47.017 11.541c2.221 6.091 4.78 12.189 7.66 18.245l-24.488 40.815c-3.541 5.902-2.611 13.457 2.256 18.324l63.64 63.64c4.867 4.867 12.422 5.797 18.324 2.256l40.814-24.489c6.057 2.88 12.154 5.44 18.246 7.661l11.107 45.252v-121.904c-44.413-22.129-75-68.011-75-120.909 0-27.368 8.182-53.744 23.66-76.275 15.099-21.978 36.088-38.877 60.697-48.868 4.624-1.878 9.881-1.332 14.02 1.456 4.141 2.787 6.623 7.452 6.623 12.443v103.217l30 20 30-20v-103.218c0-4.991 2.482-9.655 6.623-12.443 4.14-2.787 9.396-3.333 14.02-1.456 24.609 9.991 45.599 26.89 60.697 48.868 15.478 22.532 23.66 48.908 23.66 76.276 0 52.898-30.587 98.78-75 120.909v121.904l11.107-45.253c6.092-2.221 12.189-4.781 18.246-7.661l40.814 24.489c5.901 3.542 13.457 2.612 18.324-2.256l63.64-63.64c4.867-4.867 5.797-12.422 2.256-18.324l-24.488-40.815c2.88-6.056 5.439-12.154 7.66-18.245l47.017-11.541c6.707-1.646 11.424-7.66 11.424-14.567v-90c0-6.907-4.717-12.921-11.424-14.568z" />
		</g>
	</svg>)
};

export const LogoutSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512">
		<g>
			<path d="m256 0c-141.159 0-256 114.841-256 256s114.841 256 256 256 256-114.841 256-256-114.841-256-256-256zm-15 86c0-8.284 6.716-15 15-15s15 6.716 15 15v120c0 8.284-6.716 15-15 15s-15-6.716-15-15zm15 335c-90.981 0-165-74.019-165-165 0-65.544 38.856-124.886 98.991-151.179 7.59-3.32 16.434.144 19.753 7.734s-.144 16.434-7.734 19.753c-49.212 21.518-81.01 70.069-81.01 123.692 0 74.439 60.561 135 135 135s135-60.561 135-135c0-53.623-31.798-102.174-81.009-123.691-7.59-3.319-11.053-12.163-7.734-19.753 3.318-7.591 12.162-11.056 19.753-7.734 60.134 26.292 98.99 85.634 98.99 151.178 0 90.981-74.019 165-165 165z" />
		</g>
	</svg>)
};

export const JobSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 -31 512 512">
		<path d="m211 240h90v30h-90zm0 0" />
		<path d="m415.378906 270h-84.378906v15c0 8.289062-6.710938 15-15 15h-120c-8.289062 0-15-6.710938-15-15v-15h-84.378906c-19.394532 0-36.546875-12.363281-42.6875-30.761719l-53.933594-161.828125v327.589844c0 24.8125 20.1875 45 45 45h422c24.8125 0 45-20.1875 45-45v-327.578125l-53.9375 161.816406c-6.136719 18.398438-23.289062 30.761719-42.683594 30.761719zm0 0" />
		<path d="m316 0h-120c-24.8125 0-45 20.1875-45 45v15h-125.191406l56.574218 169.746094c2.050782 6.136718 7.777344 10.253906 14.238282 10.253906h84.378906v-15c0-8.289062 6.710938-15 15-15h120c8.289062 0 15 6.710938 15 15v15h84.378906c6.460938 0 12.1875-4.117188 14.238282-10.253906l56.578124-169.746094h-125.195312v-15c0-24.8125-20.1875-45-45-45zm-135 60v-15c0-8.277344 6.722656-15 15-15h120c8.277344 0 15 6.722656 15 15v15zm0 0" />
	</svg>)
};

export const SkillSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 57 56">
		<g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
			<g id="001---Thinking" transform="translate(0.000000, -1.000000)" fillRule="nonzero">
				<path d="M35.9,8.577 L35.18,5 L32.82,5 L32.1,8.577 C32.0252418,8.94857024 31.7468426,9.24594237 31.381,9.345 C30.5547759,9.56773445 29.7610951,9.89717418 29.02,10.325 C28.6897571,10.5165562 28.2792625,10.5033645 27.962,10.291 L24.933,8.261 L23.266,9.937 L25.29,12.963 C25.5023645,13.2802625 25.5155562,13.6907571 25.324,14.021 C24.8961742,14.7620951 24.5667344,15.5557759 24.344,16.382 C24.2449424,16.7478426 23.9475702,17.0262418 23.576,17.101 L20,17.82 L20,20.18 L23.577,20.899 C23.9485702,20.9737582 24.2459424,21.2521574 24.345,21.618 C24.5677344,22.4442241 24.8971742,23.2379049 25.325,23.979 C25.5165562,24.3092429 25.5033645,24.7197375 25.291,25.037 L23.261,28.066 L24.937,29.733 L27.963,27.709 C28.2802625,27.4966355 28.6907571,27.4834438 29.021,27.675 C29.7620951,28.1028258 30.5557759,28.4322656 31.382,28.655 C31.7478426,28.7540576 32.0262418,29.0514298 32.101,29.423 L32.82,33 L35.18,33 L35.899,29.423 C35.9737582,29.0514298 36.2521574,28.7540576 36.618,28.655 C37.4442241,28.4322656 38.2379049,28.1028258 38.979,27.675 C39.3092429,27.4834438 39.7197375,27.4966355 40.037,27.709 L43.066,29.739 L44.733,28.063 L42.709,25.037 C42.4966355,24.7197375 42.4834438,24.3092429 42.675,23.979 C43.1028258,23.2379049 43.4322656,22.4442241 43.655,21.618 C43.7540576,21.2521574 44.0514298,20.9737582 44.423,20.899 L48,20.18 L48,17.819 L44.423,17.1 C44.0514298,17.0252418 43.7540576,16.7468426 43.655,16.381 C43.4322656,15.5547759 43.1028258,14.7610951 42.675,14.02 C42.4834438,13.6897571 42.4966355,13.2792625 42.709,12.962 L44.739,9.933 L43.063,8.267 L40.037,10.291 C39.7197375,10.5033645 39.3092429,10.5165562 38.979,10.325 C38.2379049,9.89717418 37.4442241,9.56773445 36.618,9.345 C36.2525454,9.24561741 35.9745924,8.94830842 35.9,8.577 Z M41,19 C41,22.8659932 37.8659932,26 34,26 C30.1340068,26 27,22.8659932 27,19 C27,15.1340068 30.1340068,12 34,12 C37.8641657,12.0044086 40.9955914,15.1358343 41,19 Z" id="Shape" />
				<path d="M44.708,13.574 C44.9840443,14.1166112 45.218064,14.6795956 45.408,15.258 L46.926,15.558 C48.4876438,14.7771754 49.3578288,13.0695165 49.0717608,11.3471392 C48.7856928,9.62476188 47.410209,8.29008387 45.68,8.056 L46.147,8.523 C46.8185306,9.19256726 46.9275347,10.2416795 46.408,11.035 L44.708,13.574 Z" id="Shape" />
				<path d="M29,19 C29,21.7614237 31.2385763,24 34,24 C36.7614237,24 39,21.7614237 39,19 C39,16.2385763 36.7614237,14 34,14 C31.2399468,14.0033061 29.0033061,16.2399468 29,19 Z M35,19 C35,19.5522847 34.5522847,20 34,20 C33.4477153,20 33,19.5522847 33,19 C33,18.4477153 33.4477153,18 34,18 C34.5522847,18 35,18.4477153 35,19 Z" id="Shape" />
				<path d="M0.636,34.735 C0.897016404,34.9170713 1.17261917,35.0772821 1.46,35.214 C2.313,35.65 3.481,36.248 3.722,37.467 C3.86518406,38.2227094 3.77195159,39.0041861 3.455,39.705 C3.281,40.076 3.101,40.396 2.944,40.672 C2.896,40.758 2.844,40.854 2.793,40.941 C3.208,41.275 3.774,41.699 4.014,41.875 C4.23229562,42.0357032 4.37599946,42.2781415 4.41219539,42.5467831 C4.44839132,42.8154248 4.37397793,43.0872516 4.206,43.3 C4.05732702,43.493163 3.92803652,43.7004967 3.82,43.919 C3.891,43.961 3.963,44.002 4.035,44.043 C4.91597603,44.4232101 5.5884572,45.1672085 5.878,46.082 C6.02631071,46.7960297 5.99365282,47.5358168 5.783,48.234 C5.736,48.439 5.689,48.644 5.66,48.849 C5.60643127,49.4507664 5.69090962,50.0568216 5.907,50.621 C6.12881207,51.543052 7.03525382,52.128719 7.967,51.952 C10.8811971,51.2511285 13.7526167,50.3830249 16.567,49.352 L16.573,49.352 C17.614,48.998 18.558,48.668 19.301,48.409 C19.994,48.166 20.517,47.984 20.789,47.897 C24.946,46.572 25.789,45.075 25.765,44.052 C25.752146,43.5000397 26.1890455,43.042101 26.741,43.029 C27.0071266,43.0189946 27.2659833,43.1170667 27.4586705,43.3009012 C27.6513577,43.4847357 27.7614871,43.7386973 27.764,44.005 C27.823,46.487 25.681,48.437 21.399,49.805 C21.137,49.889 20.631,50.065 19.961,50.305 L19.061,50.619 C20.7094382,52.4462123 21.9125104,54.6302247 22.576,57 L45.258,56.937 L45.191,56.837 C44.9033067,56.4218577 44.6443682,55.9875092 44.416,55.537 C43.9186739,54.5263955 43.5036619,53.4773282 43.175,52.4 C42.5682684,50.3530291 42.1472324,48.2555471 41.917,46.133 C41.5226514,42.7875258 42.0287491,39.3974307 43.383,36.313 C44.181408,34.6438155 45.1688779,33.0718493 46.326,31.628 C46.906,30.846 47.506,30.038 48.026,29.217 C49.4111468,27.0779657 50.1554304,24.5873047 50.171,22.039 C50.177,21.813 50.171,21.588 50.166,21.363 L49.773,21.1 C49.4965057,21.6402002 48.9888461,22.0249024 48.394,22.145 L45.406,22.745 C45.216064,23.3234044 44.9820443,23.8863888 44.706,24.429 L46.4,26.953 C46.9315268,27.7519165 46.8207373,28.8157476 46.136,29.488 L44.477,31.147 C43.8074327,31.8185306 42.7583205,31.9275347 41.965,31.408 L39.426,29.708 C38.8833888,29.9840443 38.3204044,30.218064 37.742,30.408 L37.142,33.4 C36.9517429,34.3320693 36.1312884,35.0011453 35.18,35 L32.82,35 C31.8665593,35.0004731 31.045351,34.3278524 30.858,33.393 L30.258,30.405 C29.6795956,30.215064 29.1166112,29.9810443 28.574,29.705 L26.047,31.4 C25.247926,31.9287833 24.1864487,31.8186142 23.513,31.137 L21.853,29.477 C21.1814694,28.8074327 21.0724653,27.7583205 21.592,26.965 L23.292,24.426 C23.0159557,23.8833888 22.781936,23.3204044 22.592,22.742 L19.6,22.142 C18.6679307,21.9517429 17.9988547,21.1312884 18,20.18 L18,17.82 C17.9995269,16.8665593 18.6721476,16.045351 19.607,15.858 L22.595,15.258 C22.784936,14.6795956 23.0189557,14.1166112 23.295,13.574 L21.6,11.047 C21.0684732,10.2480835 21.1792627,9.18425235 21.864,8.512 L23.523,6.853 C24.1925673,6.18146939 25.2416795,6.07246529 26.035,6.592 L28.574,8.292 C29.1166112,8.01595569 29.6795956,7.78193603 30.258,7.592 L30.858,4.6 C31.0482571,3.66793067 31.8687116,2.99885469 32.82,3 L35.18,3 C35.3123818,3.00123879 35.4443319,3.01530454 35.574,3.042 L36.394,2.222 C33.7584309,1.27082389 30.9571892,0.864620045 28.16,1.028 C25.0046074,1.24988685 21.8696146,1.70175362 18.78,2.38 C14.744,3.18 11.729,4.615 9.816,6.637 C8.23716519,8.32960767 7.01673014,10.3238693 6.228,12.5 C5.85776635,13.5823467 5.55715248,14.6872697 5.328,15.808 C5.08464372,16.7423575 4.74968773,17.6504232 4.328,18.519 C4.14,18.94 3.951,19.36 3.788,19.788 C3.69044363,20.0122238 3.6355067,20.2526577 3.626,20.497 C3.669,20.797 4.052,21.145 4.458,21.516 C5.28572805,22.0976377 5.82053472,23.0096546 5.924,24.016 C5.90563342,24.491103 5.7732421,24.9548156 5.538,25.368 C4.28652654,28.0034228 2.75289097,30.4953291 0.964,32.8 C0.203,33.727 0.044,34.094 0.04,34.246 C0.22347897,34.4266783 0.422962279,34.5903483 0.636,34.735 Z M7.471,15.25 C7.62815969,14.5552533 7.82515171,13.8701218 8.061,13.198 C8.75614575,11.2732275 9.83379397,9.50912284 11.229,8.012 C12.853,6.3 15.516,5.06 19.145,4.338 C19.6867913,4.23058063 20.2130806,4.58270867 20.3205,5.1245 C20.4279194,5.66629134 20.0757913,6.19258061 19.534,6.3 C16.32,6.939 14.015,7.978 12.682,9.386 C11.4735494,10.6858491 10.5402067,12.2164768 9.938,13.886 C9.72855738,14.4871971 9.5536061,15.0998605 9.414,15.721 C9.33059085,16.0694534 9.06713053,16.3466533 8.7233635,16.4476536 C8.37959646,16.5486538 8.00806424,16.4580176 7.74942662,16.2100591 C7.49078901,15.9621006 7.38457631,15.594718 7.471,15.247 L7.471,15.25 Z M7,19 C7.55228475,19 8,19.4477153 8,20 C8,20.5522847 7.55228475,21 7,21 C6.44771525,21 6,20.5522847 6,20 C6,19.4477153 6.44771525,19 7,19 Z" id="Shape" />
				<path d="M37.742,7.6 C38.3204044,7.78993603 38.8833888,8.02395569 39.426,8.3 L41.953,6.6 C42.3666116,6.33032695 42.8643993,6.22081366 43.353,6.292 C43.9264672,6.10253554 44.5260585,6.00400954 45.13,6 C47.5759151,5.99176913 49.7807939,7.47244829 50.6986688,9.73962145 C51.6165438,12.0067946 51.0627498,14.6043345 49.3,16.3 C49.743618,16.6805022 49.9992335,17.2355531 50,17.82 L50,18.842 L52.223,20.333 L53.333,19.223 L51.8,16.937 C51.5850329,16.6164292 51.5737461,16.2007641 51.771,15.869 C52.1079017,15.2965611 52.365267,14.6809029 52.536,14.039 C52.6350543,13.6722153 52.9333999,13.3932427 53.306,13.319 L56.006,12.782 L56.006,11.218 L53.311,10.681 C52.9383999,10.6067573 52.6400543,10.3277847 52.541,9.961 C52.370267,9.31909713 52.1129017,8.70343892 51.776,8.131 C51.5772476,7.80019329 51.586588,7.38454458 51.8,7.063 L53.334,4.777 L52.224,3.667 L49.937,5.2 C49.6164292,5.41496713 49.2007641,5.42625392 48.869,5.229 C48.2965611,4.89209833 47.6809029,4.63473301 47.039,4.464 C46.6722153,4.36494573 46.3932427,4.06660008 46.319,3.694 L45.782,1 L44.218,1 L43.681,3.7 C43.6067573,4.07260008 43.3277847,4.37094573 42.961,4.47 C42.3190971,4.64073301 41.7034389,4.89809833 41.131,5.235 C40.7980885,5.43046291 40.3823997,5.41684015 40.063,5.2 L37.777,3.667 L37.077,4.367 C37.1052534,4.44403458 37.1283052,4.52287839 37.146,4.603 L37.742,7.6 Z" id="Shape" />
			</g>
		</g>
	</svg>)
};

export const PhoneSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 513.64 513.64">
		<g transform="matrix(0.8,0,0,0.8,51.36399078369132,51.36406440734862)">
			<g>
				<g>
					<path d="M499.66,376.96l-71.68-71.68c-25.6-25.6-69.12-15.359-79.36,17.92c-7.68,23.041-33.28,35.841-56.32,30.72    c-51.2-12.8-120.32-79.36-133.12-133.12c-7.68-23.041,7.68-48.641,30.72-56.32c33.28-10.24,43.52-53.76,17.92-79.36l-71.68-71.68    c-20.48-17.92-51.2-17.92-69.12,0l-48.64,48.64c-48.64,51.2,5.12,186.88,125.44,307.2c120.32,120.32,256,176.641,307.2,125.44    l48.64-48.64C517.581,425.6,517.581,394.88,499.66,376.96z" />
				</g>
			</g>
		</g>
	</svg>)
};

export const CallCancelSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512.193 512.193">
		<g>
			<rect x="35.67" y="241.096" transform="matrix(0.6832 -0.7302 0.7302 0.6832 -94.8599 293.547)" width="510.408" height="30.001" />
			<path d="M512.193,267.842l-0.012-0.592c-1.36-34.435-30.119-65.718-80.978-88.089c-1.584-0.697-3.189-1.379-4.806-2.055   l-89.846,96.035c1.453,0.269,2.899,0.549,4.343,0.833h171.299V267.842z" />
			<polygon points="170.341,319.063 170.341,303.975 0,303.975 0,355.262 136.474,355.262  " />
			<path d="M170.341,273.975v-0.104c15.605-3.05,31.77-5.22,48.37-6.508l108.345-115.807c-22.788-3.035-46.63-4.617-70.959-4.617   c-66.464,0-129.184,11.682-176.605,32.893C28.23,202.758,0,234.703,0,269.777v4.198H170.341z" />
			<rect x="341.853" y="303.975" width="170.341" height="51.287" />
		</g>
	</svg>)
};

export const AddressSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512">
		<g id="_01-home" data-name="01-home">
			<g id="glyph">
				<path d="m256 4c-108.075 0-196 87.925-196 196 0 52.5 31.807 119.92 94.537 200.378a1065.816 1065.816 0 0 0 93.169 104.294 12 12 0 0 0 16.588 0 1065.816 1065.816 0 0 0 93.169-104.294c62.73-80.458 94.537-147.878 94.537-200.378 0-108.075-87.925-196-196-196zm0 336c-77.2 0-140-62.8-140-140s62.8-140 140-140 140 62.8 140 140-62.8 140-140 140z" />
				<path d="m352.072 183.121-88-80a12 12 0 0 0 -16.144 0l-88 80a12.006 12.006 0 0 0 -2.23 15.039 12.331 12.331 0 0 0 10.66 5.84h11.642v76a12 12 0 0 0 12 12h28a12 12 0 0 0 12-12v-44a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v44a12 12 0 0 0 12 12h28a12 12 0 0 0 12-12v-76h11.642a12.331 12.331 0 0 0 10.66-5.84 12.006 12.006 0 0 0 -2.23-15.039z" />
			</g>
		</g>
	</svg>)
};

export const CountrySvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 43.643 43.643">
		<g>
			<g>
				<polygon points="31.865,30.307 31.417,30.219 31.096,30.672 31.25,31.086 31.803,30.879 		" />
				<polygon points="23.591,36.971 23.591,37.616 24.007,38.018 24.384,37.412 25.126,36.325 25.482,34.619 25.031,34.619 
			24.591,35.497 23.835,35.399 23.835,35.984 24.105,36.301 23.898,36.617 		"/>
				<path d="M9.926,17.22c1.748,1.903,3.574,4.595,3.593,4.622l0.883,1.305l0,0l0.096,0.141l0.075-0.135l0,0l0.519-0.936l0,0
			l0.045-0.082l0,0l0.129-0.232l0.407-0.039l0.291-0.348l-0.309-0.121l-0.063-0.073c0.176-0.312,0.432-0.764,0.731-1.284l0,0
			c0.052-0.091,0.107-0.187,0.162-0.281c0.568-0.981,1.246-2.125,1.79-2.956c2.895-1.706,4.628-4.933,4.434-8.3
			c-0.285-4.941-4.521-8.763-9.529-8.486C8.214,0.302,4.408,4.576,4.694,9.542C4.888,12.9,6.886,15.821,9.926,17.22z M13.304,2.156
			c0.135-0.008,0.27-0.012,0.404-0.012c3.637,0,6.649,2.847,6.859,6.481c0.152,2.636-1.246,5.161-3.563,6.432l-0.229,0.126
			l-0.146,0.218c-0.703,1.051-1.65,2.666-2.324,3.842c-0.765-1.045-1.871-2.485-2.962-3.647l-0.153-0.163l-0.205-0.088
			c-2.409-1.036-4-3.307-4.151-5.925C6.616,5.634,9.517,2.375,13.304,2.156z"/>
				<path d="M24.359,11.715c-0.113,0.441-0.252,0.873-0.416,1.295c3.59,0.238,6.834,1.759,9.264,4.126
			c0.172,0.167,0.338,0.343,0.502,0.52h-2.074l-1.043-0.622l-2.088,0.132l-1.584,0.708l0.012,0.823l-0.488,0.146l-0.109-0.823
			l-0.182-0.286l-0.55-0.135l-0.129,0.494l0.164,0.401l-1.948-0.127l-0.931,0.432l-0.143-0.407l-0.23,0.061l-0.17,0.451
			l-0.486,0.381l-1.189-0.033l-0.055-0.262l1.244-0.055l0.254-0.219l-1.498-0.695l-0.469,0.014
			c-0.104,0.073-0.195,0.159-0.302,0.228c-0.095,0.15-0.194,0.31-0.294,0.472l0.055-0.038l-1.068,0.745l-0.005,1
			c-0.054,0.092-0.107,0.184-0.16,0.274l0.159-0.081l-0.629,0.318l0.063,0.21l1.006,0.009l-0.857-0.008
			c-0.354,0.615-0.662,1.16-0.859,1.512l-0.031,0.056l0,0l-0.289,0.522l0.287-0.26l0.088,0.328l1.143,0.771l-0.139,0.188
			l-0.516-0.028l0.197,0.282l0.318,0.069l0.371-0.155l-0.006-0.448l0.164-0.082l-0.131-0.142l-0.764-0.425l-0.201-0.566h0.635
			l0.203,0.202l0.547,0.47l0.023,0.57l0.564,0.604l0.211-0.828l0.395-0.213l0.072,0.676l0.383,0.42l1.156-0.02l0.342,0.256v0.604
			l-0.418,0.384h-1.17l-0.713-0.53l-0.75,0.072v0.458H18.86l-0.256-0.183l-1.299-0.329v-0.841l-1.283,0.1l-1.354,2.443l-1.204-1.778
			l-0.082,0.045v0.829l-1.619,1.169l0.133,0.5h0.33l-0.086,0.476l-0.232,0.084l-0.012,1.242l1.4,1.596h0.611l0.037-0.098h1.096
			l0.316-0.292h0.621l0.342,0.341l0.926,0.098l-0.123,1.236l1.031,1.815L17.61,35.4l0.037,0.488l0.426,0.425v1.172l0.561,0.753
			v0.975h1.658l1.242-1.279l0.389-0.693l0.5-0.109v-0.584l0.328-0.392l0.695-0.95L23.3,33.758l-0.305-0.539l1.367-1.306l1.508-2.153
			l-0.293-0.135l-1.565,0.328l-0.401-0.201l-1.646-3.098l0.115-0.134l1.631,1.979l0.039,0.613l0.377,0.378l0.769-0.05l1.604-1.16
			l0.502-0.329l-0.01-0.402l-0.535-0.069c0,0-1.877-0.886-1.877-0.923c0-0.041,0.012-0.76,0.012-0.76h0.414l0.062,0.524l0.869,0.5
			l0.994,0.049l2.156,0.353l0.504,0.317v0.494l-0.064,0.671l1.105,1.818l0.357,0.082l0.354-0.516l0.197-1.472l0.366-0.792
			l0.597-0.222l1.047,0.1l1.313,1.169v1.682l1.738,1.662l0.09-0.291l-1.406-2.011l0.146-0.585l0.742,0.844l0.416,0.043l0.545-0.362
			l-0.092-0.548l-0.9-0.726l-0.035-0.657l0.256-0.348l0.457,0.146l-0.037,0.311l0.261,0.4l0.231-0.163l-0.127-0.476l0.496-0.178
			c0,0.008,0.002,0.018,0.002,0.025c0,8.097-6.588,14.684-14.684,14.684c-8.098,0-14.684-6.587-14.684-14.684
			c0-2.566,0.666-4.979,1.827-7.081c-0.278-0.361-0.57-0.729-0.874-1.092c-1.432,2.396-2.27,5.185-2.27,8.173
			c0,8.822,7.178,16,16,16c8.821,0,16-7.178,16-16C38.966,19.292,32.531,12.424,24.359,11.715z M18.983,19.432l0.021-0.013
			c-0.007,0.012-0.015,0.024-0.021,0.036V19.432z"/>
				<rect x="15.074" y="8.923" width="1.685" height="1.685" />
				<path d="M9.76,13.182h7.812V7.248h0.999l-4.905-4.156L9.763,6.447H9.761V6.45l-0.93,0.798h0.93L9.76,13.182L9.76,13.182z
			 M10.561,7.248h6.209v5.133h-3.104V8.9h-2.035v3.481h-1.069V7.248H10.561z"/>
			</g>
		</g>
	</svg>)
};

export const GanderSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 31.385 31.385">
		<g>
			<g>
				<path d="M13.684,24.416h-2.225v-2.102c4.412-0.796,7.753-4.655,7.753-9.282c0-1.251-0.239-2.445-0.685-3.538
			c-0.486-0.183-1.004-0.281-1.539-0.281c-0.849,0-1.657,0.241-2.354,0.689c0.585,0.903,0.925,1.977,0.925,3.13
			c0,3.184-2.587,5.773-5.771,5.773c-3.182,0-5.77-2.589-5.77-5.773c0-2.423,1.501-4.499,3.62-5.354
			C8.07,7.001,8.579,6.365,9.161,5.784c0.794-0.793,1.69-1.451,2.661-1.96c-0.654-0.144-1.334-0.222-2.03-0.222
			c-5.199,0-9.446,4.232-9.446,9.431c0,4.524,3.208,8.31,7.437,9.22v2.164H5.71c-1.011,0-1.831,0.829-1.831,1.838
			c0,1.012,0.82,1.84,1.831,1.84h2.073v1.462c0,1.009,0.828,1.828,1.838,1.828c1.011,0,1.838-0.819,1.838-1.828v-1.462h2.225
			c1.011,0,1.829-0.828,1.829-1.84C15.513,25.245,14.694,24.416,13.684,24.416z"/>
				<path d="M29.13,0c-0.084-0.004-5.847,0.062-5.847,0.062c-1.024,0.012-1.848,1.016-1.834,2.044
			c0.013,1.018,0.843,1.996,1.857,1.996c0.006,0,0.016,0,0.024,0l1.073-0.177l-1.955,1.877c-1.594-1.108-3.479-1.753-5.459-1.753
			c-2.559,0-4.965,0.977-6.775,2.786c-2.892,2.891-3.544,7.177-1.962,10.702c0.102,0.034,0.205,0.066,0.31,0.095
			c0.349,0.095,0.709,0.146,1.068,0.158c0.052,0.002,0.105,0.003,0.158,0.003c0.882,0,1.742-0.245,2.492-0.709
			c-1.703-2.294-1.517-5.558,0.564-7.64c1.106-1.107,2.579-1.718,4.146-1.718s3.039,0.61,4.146,1.718
			c2.289,2.288,2.289,6.01,0,8.296c-0.844,0.846-1.902,1.401-3.054,1.616c-0.079,0.104-0.16,0.208-0.242,0.309
			c-1.078,1.31-2.455,2.335-4.004,2.989c1.001,0.347,2.063,0.528,3.153,0.528c2.56,0,4.966-1.001,6.777-2.811
			c3.248-3.249,3.783-8.269,1.385-11.981l2.209-2.092v1.299c0,1.026,0.812,1.859,1.838,1.859c1.027,0,1.84-0.833,1.84-1.859V1.844
			C31.039,1.347,30.955,0.113,29.13,0z"/>
			</g>
		</g>
	</svg>)
};

export const JoinedSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 503.018 503.018">
		<g>
			<g>
				<g>
					<path d="M61.123,289.763H15.457l-1.668,5.004c-2.177,6.454-0.495,13.585,4.338,18.386l48.088,48.088
				c6.909,6.892,15.32,12.091,24.575,15.189l67.75,22.583c8.936,2.9,18.407,3.761,27.719,2.52L73.478,294.689
				C70.145,291.521,65.721,289.757,61.123,289.763z"/>
					<path d="M335.746,208.149c-0.953-1.616-2.151-3.074-3.553-4.321l-70.013-62.228c-3.286-2.927-7.534-4.542-11.934-4.539h-31.244
				l-26.374,21.018c-13.536,10.8-32.859,10.377-45.91-1.004c-13.051-11.382-16.098-30.467-7.239-45.346l5.048-8.381l-38.556,4.82
				c-10.869,1.364-21.882,1.057-32.658-0.908L10.592,95.855c-2.624-0.508-5.336,0.207-7.368,1.943
				c-2.057,1.697-3.24,4.229-3.224,6.895v158.123c0.006,4.958,4.024,8.976,8.982,8.982h52.14c9.196-0.014,18.045,3.512,24.71,9.846
				L230.82,419c8.69,8.259,20.943,11.61,32.627,8.925l-37.214-52.1c-1.865-2.612-2.194-6.021-0.864-8.941
				c1.33-2.921,4.117-4.91,7.311-5.219s6.311,1.11,8.176,3.722l41.357,57.899l38.542-9.638l-49.999-83.332
				c-2.553-4.254-1.175-9.771,3.079-12.325s9.771-1.175,12.325,3.079l52.402,87.336c8.155-3.128,15.805-7.437,22.708-12.788
				l16.432-12.781l-70.963-115.315c-1.688-2.733-1.788-6.159-0.262-8.986c1.526-2.827,4.446-4.623,7.657-4.711
				c3.211-0.088,6.225,1.546,7.903,4.285l69.928,113.634l2.541-1.976c14.21-11.107,18.018-31.01,8.912-46.578L335.746,208.149z"/>
					<path d="M503.017,156.732c0-2.524-1.062-4.931-2.927-6.633c-1.864-1.701-4.358-2.54-6.872-2.31l-45.697,4.154
				c-23.616,2.174-46.992-6.158-63.908-22.781l-27.289-19.145c-1.091-0.765-2.238-1.448-3.43-2.044l-1.004-0.588L327.698,91.07
				c-16.311-11.026-35.553-16.907-55.241-16.886H194.07c-6.008-0.005-11.619,2.999-14.947,8l-9.608,14.412
				c-0.035,0.06-0.031,0.129-0.067,0.189l-14.583,24.211c-4.72,7.807-2.725,17.924,4.605,23.355
				c6.544,4.898,15.568,4.765,21.965-0.325l25.443-20.276v-13.636c0-4.961,4.022-8.982,8.982-8.982s8.982,4.022,8.982,8.982v8.982
				h25.404c8.801-0.003,17.296,3.227,23.873,9.075l70.013,62.232c2.803,2.492,5.199,5.407,7.101,8.64l67.667,115.039l0.018,0.038
				l73.131-26.042c6.685-2.775,11.023-9.323,10.969-16.561L503.017,156.732z"/>
				</g>
			</g>
		</g>
	</svg>)
};

export const BirthdaySvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512">
		<g>
			<path id="XMLID_62_" d="m135.169 91.902c16.83 0 30.474-13.649 30.474-30.485 0-11.22-13.533-36.418-22.563-51.981-3.524-6.075-12.297-6.075-15.822 0-9.029 15.563-22.563 40.761-22.563 51.981 0 16.836 13.644 30.485 30.474 30.485z" />
			<path id="XMLID_123_" d="m256 91.902c16.83 0 30.474-13.649 30.474-30.485 0-11.22-13.533-36.418-22.563-51.981-3.524-6.075-12.297-6.075-15.822 0-9.029 15.563-22.563 40.761-22.563 51.981 0 16.836 13.643 30.485 30.474 30.485z" />
			<path id="XMLID_122_" d="m376.83 91.902c16.83 0 30.474-13.649 30.474-30.485 0-11.22-13.533-36.418-22.563-51.981-3.525-6.075-12.297-6.075-15.822 0-9.029 15.563-22.563 40.761-22.563 51.981 0 16.836 13.644 30.485 30.474 30.485z" />
			<path id="XMLID_121_" d="m118.391 116.951c-7.454 0-13.497 6.045-13.497 13.502v108.924h60.55v-108.923c0-7.457-6.042-13.502-13.497-13.502h-33.556z" />
			<path id="XMLID_120_" d="m239.221 116.951c-7.454 0-13.497 6.045-13.497 13.502v108.924h60.55v-108.923c0-7.457-6.043-13.502-13.497-13.502h-33.556z" />
			<path id="XMLID_61_" d="m360.052 116.951c-7.454 0-13.497 6.045-13.497 13.502v108.924h60.55v-108.923c0-7.457-6.043-13.502-13.497-13.502h-33.556z" />
			<path id="XMLID_52_" d="m66.25 356.095c2.442 0 4.941-.344 7.425-1.08l37.866-11.209c12.377-3.664 25.284-5.496 38.19-5.496s25.813 1.832 38.19 5.496l29.888 8.848c12.377 3.664 25.284 5.496 38.19 5.496s25.813-1.832 38.19-5.496l29.888-8.848c12.377-3.664 25.284-5.496 38.19-5.496s25.813 1.832 38.19 5.496l37.866 11.209c2.483.735 4.984 1.08 7.425 1.08 12.118 0 22.787-8.481 22.787-19.746v-38.672c0-12.82-12.02-23.213-26.848-23.213h-371.375c-14.828 0-26.848 10.393-26.848 23.213v38.672c0 11.265 10.67 19.746 22.786 19.746z" />
			<path id="XMLID_51_" d="m497 477.12h-40.946v-91.989c-3.371.631-6.819.964-10.305.964-5.392 0-10.756-.778-15.941-2.313l-37.866-11.209c-9.553-2.828-19.537-4.262-29.674-4.262s-20.121 1.434-29.674 4.262l-29.888 8.848c-15.086 4.466-30.799 6.73-46.705 6.73s-31.62-2.264-46.706-6.73l-29.888-8.848c-9.553-2.828-19.537-4.262-29.674-4.262s-20.121 1.434-29.674 4.262l-37.866 11.209c-5.186 1.535-10.549 2.314-15.941 2.314-3.487 0-6.935-.333-10.305-.964v91.989h-40.947c-8.284 0-15 6.716-15 15s6.716 15 15 15h482c8.284 0 15-6.716 15-15s-6.716-15.001-15-15.001z" />
		</g>
	</svg>)
};

export const LinkSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 511.771 511.771">
		<g>
			<path d="m189.547 128.897c-60.302 62.391-47.143 165.931 21.932 211.798 2.276 1.512 5.304 1.212 7.259-.698 14.542-14.209 26.844-27.972 37.616-45.476 1.648-2.678.623-6.153-2.142-7.651-10.536-5.708-21.02-16.411-26.922-27.717l-.007.004c-7.07-14.078-9.477-29.859-5.734-46.157.004.001.008.002.012.002 4.307-20.866 26.708-40.276 43.817-58.227-.036-.012-.071-.025-.107-.037l64.103-65.426c25.546-26.073 67.566-26.288 93.377-.477 26.072 25.545 26.503 67.777.958 93.849l-38.828 39.928c-1.797 1.848-2.38 4.544-1.539 6.981 8.94 25.925 11.139 62.48 5.148 90.098-.168.773.786 1.279 1.339.714l82.638-84.344c52.791-53.88 52.343-141.604-.995-194.942-54.433-54.433-143.048-53.98-196.922 1.005l-84.672 86.419c-.112.118-.218.238-.331.354z" />
			<path d="m344.038 352.576c-.001.003-.003.006-.004.009.053-.022.102-.043.155-.066 16.865-30.839 20.185-66.208 12.281-100.687l-.036.037-.039-.017c-7.505-30.709-28.098-61.203-56.066-79.978-2.406-1.615-6.249-1.428-8.502.394-14.167 11.455-28.034 26.144-37.184 44.889-1.437 2.943-.361 6.478 2.471 8.122 10.619 6.165 20.209 15.191 26.63 27.174l.01-.007c5.004 8.465 9.935 24.527 6.741 41.785-.002 0-.005 0-.007 0-2.98 22.881-26.086 43.869-44.454 62.781l.009.009c-13.982 14.298-49.525 50.532-63.757 65.072-25.545 26.072-67.777 26.503-93.849.958-26.072-25.545-26.503-67.777-.958-93.849l38.943-40.048c1.765-1.815 2.365-4.453 1.58-6.86-8.647-26.531-11.016-62.262-5.558-89.849.152-.769-.794-1.26-1.343-.7l-81.395 83.075c-53.332 54.433-52.88 143.057 1.006 196.942 54.43 53.33 142.597 52.429 195.927-2.001 18.527-20.724 97.835-94.153 107.399-117.185z" />
		</g>
	</svg>)
};

export const HighFiveSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 -32 512 512">
		<path d="m271 15c0-8.285156-6.714844-15-15-15s-15 6.714844-15 15v64.265625c0 8.285156 6.714844 15 15 15s15-6.714844 15-15zm0 0" />
		<path d="m181.128906 105.941406c2.925782 2.925782 6.765625 4.394532 10.605469 4.394532 3.835937 0 7.675781-1.464844 10.605469-4.394532 5.855468-5.859375 5.855468-15.355468 0-21.214844l-32.136719-32.132812c-5.855469-5.859375-15.351563-5.859375-21.210937 0-5.859376 5.859375-5.859376 15.355469 0 21.214844zm0 0" />
		<path d="m320.265625 110.332031c3.839844 0 7.679687-1.464843 10.605469-4.394531l32.136718-32.132812c5.855469-5.855469 5.855469-15.355469 0-21.210938-5.859374-5.859375-15.355468-5.859375-21.214843 0l-32.132813 32.132812c-5.859375 5.859376-5.859375 15.355469 0 21.210938 2.929688 2.929688 6.769532 4.394531 10.605469 4.394531zm0 0" />
		<path d="m212.605469 144.914062c-.15625.128907-.304688.253907-.445313.371094l-64.851562 55.59375c-6.007813 5.148438-13.6875 7.988282-21.609375 7.988282h-46.449219c-43.769531 0-79.25 35.417968-79.25 79.25v144.621093c0 8.28125 6.714844 15 15 15h128.53125c8.289062 0 15-6.722656 15-15v-137.703125l76.328125-65.425781c3.898437-3.339844 6.140625-8.21875 6.140625-13.351563v-57.589843c0-14.648438-17.015625-22.980469-28.394531-13.753907zm0 0" />
		<path d="m432.75 208.867188h-46.449219c-7.921875 0-15.601562-2.839844-21.609375-7.992188l-64.851562-55.589844c-.140625-.117187-.289063-.242187-.445313-.371094-11.378906-9.226562-28.394531-.894531-28.394531 13.753907v57.589843c0 5.132813 2.242188 10.011719 6.140625 13.351563l76.328125 65.425781v137.699219c0 8.28125 6.710938 15 15 15h128.53125c8.285156 0 15-6.714844 15-15v-144.617187c0-43.832032-35.480469-79.25-79.25-79.25zm0 0" />
		<path d="m142.464844 145.664062c0-34.847656-28.351563-63.199218-63.199219-63.199218s-63.199219 28.351562-63.199219 63.199218c0 34.851563 28.351563 63.203126 63.199219 63.203126s63.199219-28.351563 63.199219-63.203126zm0 0" />
		<path d="m495.933594 145.664062c0-34.847656-28.351563-63.199218-63.199219-63.199218s-63.199219 28.351562-63.199219 63.199218c0 34.851563 28.351563 63.203126 63.199219 63.203126s63.199219-28.351563 63.199219-63.203126zm0 0" />
	</svg>)
};

export const ChatSvg = ({ className, size = 24, type = true }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 58 58">
		<g>
			<path d="M23.936,54.07c0.539-0.12,0.879-0.654,0.76-1.193c-0.121-0.539-0.663-0.874-1.193-0.759   l-7.252,1.614c-0.003-0.002-0.007-0.003-0.01-0.005l-0.171,0.045l-0.326,0.073c-0.027,0.006-0.047,0.024-0.073,0.032L0,58   l4.988-14.963C2.457,38.78,1,33.812,1,28.5C1,12.76,13.76,0,29.5,0S58,12.76,58,28.5S45.24,57,29.5,57   c-3.603,0-7.048-0.673-10.221-1.894L23.936,54.07z" />
			{type ? null : <line x1="0" y1="0" x2="58" y2="58" strokeWidth="4px" />}
		</g>
	</svg>)
};

export const NotifySvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="-43 0 512 512">
		<path d="m413.417969 360.8125c-32.253907-27.265625-50.75-67.117188-50.75-109.335938v-59.476562c0-75.070312-55.765625-137.214844-128-147.625v-23.042969c0-11.796875-9.558594-21.332031-21.335938-21.332031-11.773437 0-21.332031 9.535156-21.332031 21.332031v23.042969c-72.257812 10.410156-128 72.554688-128 147.625v59.476562c0 42.21875-18.496094 82.070313-50.945312 109.503907-8.296876 7.105469-13.054688 17.429687-13.054688 28.351562 0 20.589844 16.746094 37.335938 37.332031 37.335938h352c20.589844 0 37.335938-16.746094 37.335938-37.335938 0-10.921875-4.757813-21.246093-13.25-28.519531zm0 0" />
		<path d="m213.332031 512c38.636719 0 70.957031-27.542969 78.378907-64h-156.757813c7.425781 36.457031 39.746094 64 78.378906 64zm0 0" />
	</svg>)
};

export const PlusSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 459.325 459.325">
		<g>
			<path d="M459.319,229.668c0,22.201-17.992,40.193-40.205,40.193H269.85v149.271c0,22.207-17.998,40.199-40.196,40.193
		c-11.101,0-21.149-4.492-28.416-11.763c-7.276-7.281-11.774-17.324-11.769-28.419l-0.006-149.288H40.181
		c-11.094,0-21.134-4.492-28.416-11.774c-7.264-7.264-11.759-17.312-11.759-28.413C0,207.471,17.992,189.475,40.202,189.475h149.267
		V40.202C189.469,17.998,207.471,0,229.671,0c22.192,0.006,40.178,17.986,40.19,40.187v149.288h149.282
		C441.339,189.487,459.308,207.471,459.319,229.668z"/>
		</g>
	</svg>)
};

export const FriendsSvg = ({ className, size = 24, ...props }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512" {...props}>
		<g>
			<path d="m126 211c-46.869 0-85-38.131-85-85s38.131-85 85-85 85 38.131 85 85-38.131 85-85 85z" />
			<path d="m386 211c-46.869 0-85-38.131-85-85s38.131-85 85-85 85 38.131 85 85-38.131 85-85 85z" />
			<g>
				<g>
					<path d="m407 283.5c0-19.453 7.716-37.127 20.23-50.162-12.807 4.938-26.704 7.662-41.23 7.662-34.78 0-66.002-15.522-87.107-40h-84.685c34.507 26.53 56.792 68.208 56.792 115v155h145.001v-80c0-8.284 6.716-15 15-15s15 6.716 15 15v80h39.999c8.284 0 15-6.716 15-15v-100h-21.5c-39.977 0-72.5-32.523-72.5-72.5z" />
					<path d="m501 355.835v-.022c-.085.007-.079.014 0 .022z" />
				</g>
				<path d="m497 326h-17.5c-23.435 0-42.5-19.065-42.5-42.5s19.065-42.5 42.5-42.5c17.92 0 32.5 14.58 32.5 32.5v37.5c0 8.284-6.716 15-15 15z" />
				<g>
					<g>
						<path d="m190.731 221.001c-18.451 12.612-40.744 19.999-64.731 19.999-14.525 0-28.421-2.722-41.227-7.659 12.512 13.034 20.227 30.707 20.227 50.159 0 39.977-32.523 72.5-72.5 72.5h-21.5v100c0 8.284 6.716 15 15 15h40.001v-80c0-8.284 6.716-15 15-15s15 6.716 15 15v80h144.999v-155c0-39.423-19.945-74.271-50.269-94.999z" />
						<path d="m11 355.813v.032c.115-.011.124-.022 0-.032z" />
					</g>
					<path d="m0 311v-37.5c0-17.92 14.58-32.5 32.5-32.5 23.435 0 42.5 19.065 42.5 42.5s-19.065 42.5-42.5 42.5h-17.5c-8.284 0-15-6.716-15-15z" />
				</g>
			</g>
		</g>
	</svg>)
};

export const HomeSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 495.398 495.398">
		<g>
			<g>
				<g>
					<path d="M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391
				v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158
				c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747
				c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z"/>
					<path d="M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401
				c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79
				c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z"/>
				</g>
			</g>
		</g>
	</svg>)
};

export const ProfileSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 350 350">
		<g>
			<path d="M175,171.173c38.914,0,70.463-38.318,70.463-85.586C245.463,38.318,235.105,0,175,0s-70.465,38.318-70.465,85.587
		C104.535,132.855,136.084,171.173,175,171.173z"/>
			<path d="M41.909,301.853C41.897,298.971,41.885,301.041,41.909,301.853L41.909,301.853z" />
			<path d="M308.085,304.104C308.123,303.315,308.098,298.63,308.085,304.104L308.085,304.104z" />
			<path d="M307.935,298.397c-1.305-82.342-12.059-105.805-94.352-120.657c0,0-11.584,14.761-38.584,14.761
		s-38.586-14.761-38.586-14.761c-81.395,14.69-92.803,37.805-94.303,117.982c-0.123,6.547-0.18,6.891-0.202,6.131
		c0.005,1.424,0.011,4.058,0.011,8.651c0,0,19.592,39.496,133.08,39.496c113.486,0,133.08-39.496,133.08-39.496
		c0-2.951,0.002-5.003,0.005-6.399C308.062,304.575,308.018,303.664,307.935,298.397z"/>
		</g>
	</svg>)
};

export const TeamsSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512">
		<g>
			<g id="Team_Leader_1_">
				<g>
					<path d="m90 182c-33.091 0-60-26.909-60-60s26.909-60 60-60 60 26.909 60 60-26.909 60-60 60z" />
				</g>
				<g>
					<path d="m422 182c-33.091 0-60-26.909-60-60s26.909-60 60-60 60 26.909 60 60-26.909 60-60 60z" />
				</g>
				<g>
					<path d="m256 150c-41.353 0-75-33.647-75-75s33.647-75 75-75 75 33.647 75 75-33.647 75-75 75z" />
				</g>
				<path d="m271 151.516v103.484c0 8.291-6.709 15-15 15s-15-6.709-15-15v-103.484c-50.75 7.357-90 50.729-90 103.484v90c0 8.291 6.709 15 15 15h33.604l11.455 138.26c.644 7.763 7.148 13.74 14.941 13.74h60c7.793 0 14.297-5.977 14.941-13.74l11.455-138.26h33.604c8.291 0 15-6.709 15-15v-90c0-52.755-39.25-96.127-90-103.484z" />
			</g>
			<path d="m120 347v-90c0-22.484 6.05-43.378 15.811-62.042-13.469-8.04-29.017-12.958-45.811-12.958-49.629 0-90 40.371-90 90v75c0 8.291 6.709 15 15 15h16.421l13.652 136.494c.762 7.661 7.222 13.506 14.927 13.506h60c7.705 0 14.165-5.845 14.927-13.506l11.087-110.843c-15.315-7.187-26.014-22.644-26.014-40.651z" />
			<path d="m512 272c0-49.629-40.371-90-90-90-16.794 0-32.342 4.918-45.811 12.958 9.761 18.664 15.811 39.558 15.811 62.042v90c0 18.007-10.699 33.464-26.014 40.651l11.087 110.843c.762 7.661 7.222 13.506 14.927 13.506h60c7.705 0 14.165-5.845 14.927-13.506l13.652-136.494h16.421c8.291 0 15-6.709 15-15z" />
		</g>
	</svg>)
};

export const RoomsSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 35.487 35.487">
		<g>
			<path d="M31.847,25.534c0,1.94-1.379,4.056-3.08,4.056s-3.08-2.113-3.08-4.056s1.379-2.969,3.08-2.969S31.847,23.594,31.847,25.534
		z M3.643,25.534c0,1.94,1.379,4.056,3.08,4.056s3.08-2.113,3.08-4.056s-1.379-2.969-3.08-2.969S3.643,23.594,3.643,25.534z
		 M14.666,25.534c0,1.94,1.378,4.056,3.079,4.056c1.701,0,3.08-2.113,3.08-4.056s-1.379-2.969-3.08-2.969
		C16.044,22.565,14.666,23.594,14.666,25.534z M33.489,30.911c-0.256-0.256-0.602-0.399-0.961-0.399h-2.922H27.92h-2.916
		c-0.746,0-1.354,0.604-1.354,1.354l-0.002,3.621h10.188l0.043-3.609C33.884,31.516,33.743,31.169,33.489,30.911z M10.485,30.512
		H7.563H5.878H2.962c-0.747,0-1.354,0.604-1.354,1.354v3.621h10.187l0.043-3.609c0.003-0.358-0.138-0.707-0.393-0.965
		C11.192,30.655,10.847,30.512,10.485,30.512z M21.507,30.512h-2.921h-1.685h-2.916c-0.747,0-1.354,0.604-1.354,1.354l-0.002,3.621
		h10.186l0.043-3.609c0.004-0.358-0.137-0.707-0.391-0.965S21.868,30.512,21.507,30.512z M32.723,3.449v13.578
		c0,1.904-1.543,3.447-3.447,3.447H13.495v-9.296l1.991,2.7c0.325,0.443,0.938,0.566,1.409,0.283l2.377-1.426
		c0.508-0.306,0.672-0.962,0.367-1.468c-0.305-0.508-0.961-0.672-1.467-0.366l-1.543,0.926l-1.918-2.604
		C14.51,8.951,14.19,8.787,13.85,8.787h-2.305l-0.402,0.537l0.74,4.191l-1.002,0.944l-1.003-0.944l0.74-4.191l-0.403-0.537H7.909
		c-0.59,0-1.069,0.479-1.069,1.068v6.951c0,0.59,0.479,1.067,1.069,1.067c0.126,0,0.245-0.024,0.356-0.063v2.663H6.214
		c-1.904,0-3.447-1.543-3.447-3.447V3.447C2.767,1.543,4.31,0,6.214,0h23.062C31.181,0.001,32.723,1.544,32.723,3.449z
		 M13.313,4.857c0-1.533-1.09-2.346-2.434-2.346c-1.343,0-2.432,0.813-2.432,2.346c0,1.533,1.089,3.205,2.432,3.205
		C12.223,8.062,13.313,6.39,13.313,4.857z"/>
		</g>
	</svg>)
};

export const SuggestSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512.001 512.001">
		<g>
			<g>
				<path d="M406.296,90.17h-30.059c-8.307,0-15.03,6.722-15.03,15.03c0,8.307,6.722,15.03,15.03,15.03h30.059
			c8.307,0,15.03-6.722,15.03-15.03C421.325,96.892,414.603,90.17,406.296,90.17z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M254.416,38.359L239.387,8.3c-3.742-7.427-12.74-10.406-20.167-6.722c-7.427,3.713-10.436,12.74-6.722,20.167
			l15.03,30.059c3.708,7.397,12.69,10.436,20.167,6.722C255.12,54.813,258.129,45.786,254.416,38.359z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M352.9,1.578c-7.398-3.684-16.453-0.704-20.167,6.722l-15.03,30.059c-3.713,7.427-0.704,16.453,6.722,20.167
			c7.499,3.724,16.47,0.65,20.167-6.722l15.03-30.059C363.335,14.318,360.326,5.291,352.9,1.578z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M195.882,90.17h-30.059c-8.307,0-15.03,6.722-15.03,15.03c0,8.307,6.722,15.03,15.03,15.03h30.059
			c8.307,0,15.03-6.722,15.03-15.03C210.912,96.892,204.189,90.17,195.882,90.17z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M105.705,241.468H45.586c-8.3,0-15.03,6.729-15.03,15.03V496.97c0,8.3,6.729,15.03,15.03,15.03h60.118
			c8.3,0,15.03-6.729,15.03-15.03V256.497C120.734,248.197,114.006,241.468,105.705,241.468z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M481.145,281.308c-2.651-23.315-24.43-39.84-47.895-39.84H316.075c9.958-17.831,15.303-68.264,15.066-88.866
			c-0.393-34.102-28.634-61.43-62.737-61.43h-12.402c-8.307,0-15.03,6.722-15.03,15.03c0,34.755-13.533,97.487-39.056,123.011
			c-17.179,17.179-31.865,23.404-51.122,33.028v225.518c29.483,9.827,66.917,24.242,123.974,24.242h98.316
			c32.395,0,57.625-30.003,45.072-61.703c19.125-5.21,33.229-22.75,33.229-43.504c0-5.857-1.13-11.463-3.17-16.615
			c32.229-8.781,44.092-48.576,21.723-73.563C478.156,307.435,482.688,294.877,481.145,281.308z"/>
			</g>
		</g>
	</svg>)
};

export const RequestSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512">
		<path d="m448.800781 0h-192.800781c-34.90625 0-63.199219 28.242188-63.199219 63.199219v289.199219c0 12.269531 14.070313 19.445312 24 12l60.265625-45.199219h171.734375c34.90625 0 63.199219-28.242188 63.199219-63.199219v-192.800781c0-34.90625-28.242188-63.199219-63.199219-63.199219zm-96.402343 246.898438c-8.277344 0-15-6.71875-15-15 0-8.277344 6.722656-15 15-15 8.28125 0 15 6.722656 15 15 0 8.28125-6.71875 15-15 15zm15-66.335938v3.136719c0 8.285156-6.714844 15-15 15-8.28125 0-15-6.714844-15-15v-16.066407c0-8.285156 6.71875-15 15-15 13.878906 0 25.167968-11.289062 25.167968-25.167968 0-13.875-11.289062-25.164063-25.167968-25.164063-13.949219 0-25.164063 11.28125-25.164063 25.148438 0 8.285156-6.71875 15.011719-15 15.011719-8.285156 0-15-6.710938-15-14.992188v-.019531c0-30.507813 24.695313-55.148438 55.148437-55.148438 30.4375 0 55.183594 24.746094 55.183594 55.167969 0 25.21875-17.011718 46.542969-40.167968 53.09375zm0 0" />
		<path d="m166.238281 311.898438c0 39.160156-31.746093 70.90625-70.90625 70.90625-39.160156 0-70.90625-31.746094-70.90625-70.90625 0-39.164063 31.746094-70.910157 70.90625-70.910157 39.160157 0 70.90625 31.746094 70.90625 70.910157zm0 0" />
		<path d="m95.332031 382.804688c-52.648437 0-95.332031 42.683593-95.332031 95.332031v18.863281c0 8.285156 6.714844 15 15 15h160.667969c8.28125 0 15-6.714844 15-15v-18.863281c0-52.648438-42.683594-95.332031-95.335938-95.332031zm0 0" />
	</svg>)
};

export const ArrowSvg = ({ className, size = 24, ...props }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 491.996 491.996" {...props}>
		<g>
			<g>
				<path d="M484.132,124.986l-16.116-16.228c-5.072-5.068-11.82-7.86-19.032-7.86c-7.208,0-13.964,2.792-19.036,7.86l-183.84,183.848
			L62.056,108.554c-5.064-5.068-11.82-7.856-19.028-7.856s-13.968,2.788-19.036,7.856l-16.12,16.128
			c-10.496,10.488-10.496,27.572,0,38.06l219.136,219.924c5.064,5.064,11.812,8.632,19.084,8.632h0.084
			c7.212,0,13.96-3.572,19.024-8.632l218.932-219.328c5.072-5.064,7.856-12.016,7.864-19.224
			C491.996,136.902,489.204,130.046,484.132,124.986z"/>
			</g>
		</g>
	</svg>)
};

export const LiveSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512" fill={fill ? fill : ""}>
		<g>
			<g>
				<g>
					<path d="M116,256c0-37.42,14.562-72.6,41.005-99.059c7.811-7.816,7.811-20.488,0-28.303c-7.81-7.817-20.473-7.817-28.284-0.001
				C94.723,162.657,76,207.888,76,256s18.723,93.343,52.721,127.363c7.81,7.815,20.473,7.815,28.284-0.001
				c7.811-7.815,7.811-20.487,0-28.303C130.562,328.6,116,293.42,116,256z"/>
					<path d="M40,256c0-57.734,22.468-112.012,63.264-152.835c7.811-7.816,7.811-20.488,0-28.304c-7.811-7.815-20.474-7.815-28.284,0
				C26.628,123.246,0,187.575,0,256s26.628,132.754,74.981,181.139c7.809,7.814,20.473,7.816,28.284,0
				c7.811-7.816,7.811-20.488,0-28.304C62.468,368.012,40,313.734,40,256z"/>
					<path d="M256,151.932c-57.346,0-104,46.685-104,104.068s46.654,104.068,104,104.068S360,313.383,360,256
				S313.346,151.932,256,151.932z M256,320.042c-35.29,0-64-28.729-64-64.042s28.71-64.042,64-64.042c35.29,0,64,28.729,64,64.042
				S291.29,320.042,256,320.042z"/>
					<path d="M437.018,74.861c-7.81-7.816-20.473-7.815-28.284,0.001c-7.811,7.816-7.81,20.487,0.001,28.303
				C449.532,143.988,472,198.266,472,256s-22.468,112.012-63.264,152.835c-7.811,7.816-7.812,20.487-0.001,28.303
				c7.808,7.814,20.471,7.819,28.284,0.001C485.371,388.754,512,324.425,512,256S485.371,123.246,437.018,74.861z"/>
					<path d="M383.278,128.637c-7.81-7.816-20.473-7.815-28.284,0.001c-7.811,7.816-7.81,20.487,0.001,28.303
				C381.437,183.4,396,218.58,396,256c0,37.42-14.562,72.6-41.005,99.059c-7.811,7.816-7.812,20.487-0.001,28.303
				c7.808,7.814,20.471,7.819,28.284,0.001C417.276,349.343,436,304.112,436,256S417.276,162.657,383.278,128.637z"/>
				</g>
			</g>
		</g>
	</svg>)
};

export const ReplySvg = ({ className, size = 24 }) => {
	const isRTL = useSelector(state => state.sign.isRTL);
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className} ${isRTL ? "rev" : ""}`} x="0" y="0" viewBox="0 0 511.633 511.633">
		<g transform="matrix(-1,-1.2246467991473547e-16,1.2246467991473532e-16,-1,511.6349487304684,511.6340065002439)">
			<g xmlns="http://www.w3.org/2000/svg">
				<g>
					<path d="M463.375,183.726c-35.782-36.735-92.789-57.764-171.02-63.094V45.83c0-7.994-3.713-13.608-11.136-16.846    c-7.803-3.23-14.466-1.902-19.985,3.999L115.06,179.161c-3.618,3.621-5.424,7.902-5.424,12.85c0,4.949,1.807,9.229,5.424,12.847    l146.178,146.177c3.432,3.617,7.71,5.425,12.85,5.425c2.283,0,4.661-0.476,7.136-1.427c7.423-3.238,11.139-8.847,11.139-16.845    v-71.663c30.642,2.475,56.097,7.471,76.376,14.989c20.27,7.519,36.494,18.034,48.677,31.549    c28.362,31.405,38.451,85.171,30.266,161.311c-0.376,4.951,1.807,8.186,6.567,9.708c0.571,0.192,1.427,0.284,2.569,0.284    c3.806,0,6.468-1.618,7.994-4.853l5.709-11.42c2.662-5.331,6.516-13.945,11.56-25.841c5.041-11.901,9.616-23.794,13.709-35.692    c4.093-11.893,7.755-25.026,10.992-39.396c3.234-14.376,4.853-27.079,4.853-38.116    C511.63,265.094,495.546,216.657,463.375,183.726z" />
					<path d="M63.953,192.011c0-4.952,1.809-9.233,5.424-12.85L182.725,65.531V45.83c0-7.994-3.715-13.608-11.138-16.846    c-7.804-3.23-14.465-1.902-19.983,3.999L5.424,179.161C1.809,182.781,0,187.062,0,192.011c0,4.949,1.809,9.229,5.424,12.847    l146.18,146.177c3.425,3.617,7.708,5.425,12.85,5.425c2.284,0,4.663-0.476,7.137-1.427c7.423-3.238,11.138-8.847,11.138-16.845    v-19.985L69.377,204.857C65.762,201.24,63.953,196.962,63.953,192.011z" />
				</g>
			</g>
		</g>
	</svg>)
};

export const SavedSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 431.972 431.972">
		<g>
			<path d="M393.146,14.279c-3.713-5.333-8.713-9.233-14.989-11.707c-3.997-1.711-8.186-2.568-12.565-2.568V0H66.378
		c-4.377,0-8.562,0.857-12.56,2.568c-6.28,2.472-11.278,6.377-14.989,11.707c-3.71,5.33-5.568,11.228-5.568,17.701v368.019
		c0,6.475,1.858,12.371,5.568,17.706c3.711,5.329,8.709,9.233,14.989,11.704c3.994,1.711,8.183,2.566,12.56,2.566
		c8.949,0,16.844-3.142,23.698-9.418l125.91-121.062l125.91,121.065c6.663,6.081,14.562,9.127,23.695,9.127
		c4.76,0,8.948-0.756,12.565-2.279c6.276-2.471,11.276-6.375,14.989-11.711c3.71-5.328,5.564-11.225,5.564-17.699V31.98
		C398.71,25.507,396.852,19.609,393.146,14.279z"/>
		</g>
	</svg>)
};

export const CommentSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 58 58">
		<g>
			<path d="M0,16.207c0-8.822,7.178-16,16-16h25c8.822,0,17,7.178,17,16v16c0,8.485-7.644,15.429-16,15.949
		v-3.949c0-0.553-0.448-1-1-1s-1,0.447-1,1v4v1v8.586l-1.359-1.359c-5.306-5.305-12.359-8.227-19.86-8.227H16
		c-8.822,0-16-7.178-16-16L0,16.207z"/>
		</g>
	</svg>)
};

export const TrendSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="-80 0 512 512.00071">
		<path d="m284.90625 132.957031c-3.484375-5.761719-10.378906-8.5-16.867188-6.691406-6.484374 1.808594-10.972656 7.71875-10.972656 14.449219 0 18.308594-14.894531 33.199218-33.199218 33.199218-18.304688 0-33.199219-14.890624-33.199219-33.199218v-125.714844c0-6.066406-3.65625-11.535156-9.261719-13.855469-5.605469-2.324219-12.054688-1.042969-16.34375 3.25-1.6875 1.683594-41.683594 41.917969-82.207031 102.703125-23.898438 35.84375-42.96875 71.398438-56.679688 105.675782-17.367187 43.425781-26.175781 84.996093-26.175781 123.5625 0 96.859374 78.804688 175.664062 175.667969 175.664062 96.859375 0 175.664062-78.804688 175.664062-175.664062.003907-62.003907-22.347656-130.429688-66.425781-203.378907zm-9.148438 199.476563c0 8.285156-6.714843 15-15 15-8.28125 0-15-6.714844-15-15v-28.050782l-74.6875 74.691407c-2.816406 2.8125-6.628906 4.390625-10.609374 4.390625-3.976563 0-7.792969-1.578125-10.605469-4.390625l-34.835938-34.839844-23.476562 23.476563c-5.859375 5.859374-15.355469 5.859374-21.214844 0-5.859375-5.859376-5.859375-15.355469 0-21.214844l34.085937-34.082032c5.859376-5.855468 15.355469-5.855468 21.214844.003907l34.832032 34.835937 64.085937-64.085937h-28.054687c-8.285157 0-15-6.714844-15-15 0-8.285157 6.714843-15 15-15h64.269531c8.28125 0 15 6.71875 15 15v64.265625zm0 0" />
	</svg>)
};

export const PostSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 24 24">
		<path d="m24 17.5v.75c0 .2-.08.39-.22.53l-5 5c-.14.14-.33.22-.53.22h-.75v-5.75c0-.41.34-.75.75-.75z" />
		<path d="m21.25 5h-7.5v2.25c0 .965-.785 1.75-1.75 1.75s-1.75-.785-1.75-1.75v-2.25h-7.5c-1.52 0-2.75 1.23-2.75 2.75v13.5c0 1.52 1.23 2.75 2.75 2.75h13.75v-5.75c0-.965.785-1.75 1.75-1.75h5.75v-8.75c0-1.52-1.23-2.75-2.75-2.75zm-7.25 14.5h-9.25c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h9.25c.414 0 .75.336.75.75s-.336.75-.75.75zm5.25-4h-14.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h14.5c.414 0 .75.336.75.75s-.336.75-.75.75zm0-4h-14.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h14.5c.414 0 .75.336.75.75s-.336.75-.75.75z" />
		<path d="m12 8c-.414 0-.75-.336-.75-.75v-3.75c0-.414.336-.75.75-.75s.75.336.75.75v3.75c0 .414-.336.75-.75.75z" />
		<path d="m12 4c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2z" />
	</svg>)
};

export const LoveHeartSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 391.837 391.837" fill={fill ? fill : ""}>
		<g>
			<path d="M285.257,35.528c58.743,0.286,106.294,47.836,106.58,106.58
		c0,107.624-195.918,214.204-195.918,214.204S0,248.165,0,142.108c0-58.862,47.717-106.58,106.58-106.58l0,0
		c36.032-0.281,69.718,17.842,89.339,48.065C215.674,53.517,249.273,35.441,285.257,35.528z"/>
		</g>
	</svg>)
};

export const ShareSvg = ({ className, size = 24, fill, type = true }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="-21 0 512 512" fill={fill ? fill : ""}>
		{type ?
			<>
				<path d="m453.332031 85.332031c0 38.292969-31.039062 69.335938-69.332031 69.335938s-69.332031-31.042969-69.332031-69.335938c0-38.289062 31.039062-69.332031 69.332031-69.332031s69.332031 31.042969 69.332031 69.332031zm0 0" />
				<path d="m384 170.667969c-47.0625 0-85.332031-38.273438-85.332031-85.335938 0-47.058593 38.269531-85.332031 85.332031-85.332031s85.332031 38.273438 85.332031 85.332031c0 47.0625-38.269531 85.335938-85.332031 85.335938zm0-138.667969c-29.417969 0-53.332031 23.9375-53.332031 53.332031 0 29.398438 23.914062 53.335938 53.332031 53.335938s53.332031-23.9375 53.332031-53.335938c0-29.394531-23.914062-53.332031-53.332031-53.332031zm0 0" />
				<path d="m453.332031 426.667969c0 38.289062-31.039062 69.332031-69.332031 69.332031s-69.332031-31.042969-69.332031-69.332031c0-38.292969 31.039062-69.335938 69.332031-69.335938s69.332031 31.042969 69.332031 69.335938zm0 0" />
				<path d="m384 512c-47.0625 0-85.332031-38.273438-85.332031-85.332031 0-47.0625 38.269531-85.335938 85.332031-85.335938s85.332031 38.273438 85.332031 85.335938c0 47.058593-38.269531 85.332031-85.332031 85.332031zm0-138.667969c-29.417969 0-53.332031 23.9375-53.332031 53.335938 0 29.394531 23.914062 53.332031 53.332031 53.332031s53.332031-23.9375 53.332031-53.332031c0-29.398438-23.914062-53.335938-53.332031-53.335938zm0 0" />
				<path d="m154.667969 256c0 38.292969-31.042969 69.332031-69.335938 69.332031-38.289062 0-69.332031-31.039062-69.332031-69.332031s31.042969-69.332031 69.332031-69.332031c38.292969 0 69.335938 31.039062 69.335938 69.332031zm0 0" />
				<path d="m85.332031 341.332031c-47.058593 0-85.332031-38.269531-85.332031-85.332031s38.273438-85.332031 85.332031-85.332031c47.0625 0 85.335938 38.269531 85.335938 85.332031s-38.273438 85.332031-85.335938 85.332031zm0-138.664062c-29.417969 0-53.332031 23.933593-53.332031 53.332031s23.914062 53.332031 53.332031 53.332031c29.421875 0 53.335938-23.933593 53.335938-53.332031s-23.914063-53.332031-53.335938-53.332031zm0 0" />
				<path d="m135.703125 245.761719c-7.425781 0-14.636719-3.863281-18.5625-10.773438-5.824219-10.21875-2.238281-23.253906 7.980469-29.101562l197.949218-112.851563c10.21875-5.867187 23.253907-2.28125 29.101563 7.976563 5.824219 10.21875 2.238281 23.253906-7.980469 29.101562l-197.953125 112.851563c-3.328125 1.898437-6.953125 2.796875-10.535156 2.796875zm0 0" />
				<path d="m333.632812 421.761719c-3.585937 0-7.210937-.898438-10.539062-2.796875l-197.953125-112.851563c-10.21875-5.824219-13.800781-18.859375-7.976563-29.101562 5.800782-10.238281 18.855469-13.84375 29.097657-7.976563l197.953125 112.851563c10.21875 5.824219 13.800781 18.859375 7.976562 29.101562-3.945312 6.910157-11.15625 10.773438-18.558594 10.773438zm0 0" />
			</>
			:
			<>
				<path d="m389.332031 160c-44.09375 0-80-35.882812-80-80s35.90625-80 80-80c44.097657 0 80 35.882812 80 80s-35.902343 80-80 80zm0-128c-26.453125 0-48 21.523438-48 48s21.546875 48 48 48 48-21.523438 48-48-21.546875-48-48-48zm0 0" />
				<path d="m389.332031 512c-44.09375 0-80-35.882812-80-80s35.90625-80 80-80c44.097657 0 80 35.882812 80 80s-35.902343 80-80 80zm0-128c-26.453125 0-48 21.523438-48 48s21.546875 48 48 48 48-21.523438 48-48-21.546875-48-48-48zm0 0" />
				<path d="m80 336c-44.097656 0-80-35.882812-80-80s35.902344-80 80-80 80 35.882812 80 80-35.902344 80-80 80zm0-128c-26.453125 0-48 21.523438-48 48s21.546875 48 48 48 48-21.523438 48-48-21.546875-48-48-48zm0 0" />
				<path d="m135.703125 240.425781c-5.570313 0-10.988281-2.902343-13.910156-8.0625-4.375-7.679687-1.707031-17.453125 5.972656-21.824219l197.953125-112.855468c7.65625-4.414063 17.449219-1.726563 21.800781 5.976562 4.375 7.679688 1.707031 17.449219-5.972656 21.824219l-197.953125 112.851563c-2.496094 1.40625-5.203125 2.089843-7.890625 2.089843zm0 0" />
				<path d="m333.632812 416.425781c-2.6875 0-5.398437-.683593-7.894531-2.109375l-197.953125-112.855468c-7.679687-4.371094-10.34375-14.144532-5.972656-21.824219 4.351562-7.699219 14.125-10.367188 21.804688-5.972657l197.949218 112.851563c7.679688 4.375 10.347656 14.144531 5.976563 21.824219-2.945313 5.183594-8.363281 8.085937-13.910157 8.085937zm0 0" />
			</>
		}
	</svg>)
};

export const MicSvg = ({ className, size = 24, fill, type = true, anim = false }) => {
	/////////////////////////////////////////////
	if (type) return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 475.085 475.085" fill={fill ? fill : ""}>
		<g>
			<g>
				<path className={anim ? "anim" : null} d="M237.541,328.897c25.128,0,46.632-8.946,64.523-26.83c17.888-17.884,26.833-39.399,26.833-64.525V91.365
			c0-25.126-8.938-46.632-26.833-64.525C284.173,8.951,262.669,0,237.541,0c-25.125,0-46.632,8.951-64.524,26.84
			c-17.893,17.89-26.838,39.399-26.838,64.525v146.177c0,25.125,8.949,46.641,26.838,64.525
			C190.906,319.951,212.416,328.897,237.541,328.897z"/>
				<path d="M396.563,188.15c-3.606-3.617-7.898-5.426-12.847-5.426c-4.944,0-9.226,1.809-12.847,5.426
			c-3.613,3.616-5.421,7.898-5.421,12.845v36.547c0,35.214-12.518,65.333-37.548,90.362c-25.022,25.03-55.145,37.545-90.36,37.545
			c-35.214,0-65.334-12.515-90.365-37.545c-25.028-25.022-37.541-55.147-37.541-90.362v-36.547c0-4.947-1.809-9.229-5.424-12.845
			c-3.617-3.617-7.895-5.426-12.847-5.426c-4.952,0-9.235,1.809-12.85,5.426c-3.618,3.616-5.426,7.898-5.426,12.845v36.547
			c0,42.065,14.04,78.659,42.112,109.776c28.073,31.118,62.762,48.961,104.068,53.526v37.691h-73.089
			c-4.949,0-9.231,1.811-12.847,5.428c-3.617,3.614-5.426,7.898-5.426,12.847c0,4.941,1.809,9.233,5.426,12.847
			c3.616,3.614,7.898,5.428,12.847,5.428h182.719c4.948,0,9.236-1.813,12.847-5.428c3.621-3.613,5.431-7.905,5.431-12.847
			c0-4.948-1.81-9.232-5.431-12.847c-3.61-3.617-7.898-5.428-12.847-5.428h-73.08v-37.691
			c41.299-4.565,75.985-22.408,104.061-53.526c28.076-31.117,42.12-67.711,42.12-109.776v-36.547
			C401.998,196.049,400.185,191.77,396.563,188.15z"/>
			</g>
		</g>
	</svg>)
	else return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 565.512 565.512" fill={fill ? fill : ""}>
		<g>
			<g>
				<path d="M86.999,239.255v43.507c0,37.986,9.639,72.216,28.874,102.707l31.788-31.787c-11.432-21.311-17.161-44.945-17.161-70.914
			v-43.507c0-5.881-2.16-10.979-6.457-15.294c-4.309-4.302-9.406-6.45-15.294-6.45c-5.894,0-10.991,2.148-15.294,6.45
			C89.146,228.276,86.999,233.374,86.999,239.255z"/>
				<path d="M391.512,108.758c0-29.908-10.655-55.508-31.946-76.812C338.262,10.648,312.661,0,282.753,0s-55.515,10.648-76.806,31.94
			C184.649,53.25,174,78.844,174,108.752v174.01c0,13.537,2.295,26.138,6.659,37.914L391.505,109.83v-1.071H391.512z"/>
				<path d="M359.565,359.574c21.291-21.291,31.946-46.904,31.946-76.812v-43.103L245.923,385.242
			c11.469,4.1,23.709,6.266,36.83,6.266C312.661,391.514,338.262,380.879,359.565,359.574z"/>
				<path d="M456.763,217.511c-5.894,0-10.991,2.148-15.294,6.451c-4.309,4.314-6.456,9.412-6.456,15.293v43.507
			c0,41.921-14.902,77.779-44.688,107.572c-29.798,29.791-65.655,44.682-107.571,44.682c-25.576,0-48.88-5.576-69.939-16.664
			l-31.861,31.859c23.85,14.67,50.521,23.68,80.05,26.941v44.871H174c-5.894,0-10.992,2.137-15.294,6.451
			c-4.309,4.303-6.457,9.4-6.457,15.293c0,5.881,2.148,10.98,6.457,15.295c4.302,4.301,9.4,6.449,15.294,6.449h217.511
			c5.887,0,10.985-2.148,15.294-6.449c4.302-4.314,6.456-9.414,6.456-15.295c0-5.893-2.154-10.99-6.456-15.293
			c-4.309-4.314-9.407-6.451-15.294-6.451h-87.009v-44.871c49.162-5.43,90.454-26.672,123.882-63.723
			c33.415-37.037,50.129-80.594,50.129-130.673v-43.507c0-5.881-2.154-10.979-6.457-15.294
			C467.748,219.659,462.65,217.511,456.763,217.511z"/>
				<path d="M478.379,44.603l-86.867,86.867l-204.01,204.005l-31.659,31.658l-31.15,31.15l-80.833,80.84
			c-11.953,11.945-11.953,31.322,0,43.268c5.967,5.979,13.807,8.967,21.634,8.967c7.827,0,15.667-2.988,21.634-8.967l80.895-80.895
			l31.236-31.236l31.689-31.689l160.564-160.558L521.653,87.871c11.952-11.946,11.952-31.322,0-43.268
			C509.707,32.65,490.319,32.65,478.379,44.603z"/>
			</g>
		</g>
	</svg>)
};

export const PushButtonSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 465.614 465.614" fill={fill ? fill : ""}>
		<g>
			<path d="M422.348,418.263H43.266c-13.07,0-23.676,10.597-23.676,23.675c0,13.079,10.606,23.675,23.676,23.675h379.082
		c13.07,0,23.675-10.597,23.675-23.675C446.023,428.86,435.419,418.263,422.348,418.263z"/>
			<path d="M119.686,396.422h226.257c12.084,0,21.888-9.803,21.888-21.887V362.96c0-57.261-46.426-103.687-103.689-103.687h-62.656
		c-57.261,0-103.687,46.425-103.687,103.687v11.576C97.8,386.619,107.602,396.422,119.686,396.422z"/>
			<path d="M211.752,219.774c11.653,11.637,30.52,11.637,42.156-0.008l87.133-87.14c4.44-4.424,5.75-11.075,3.36-16.863
		c-2.39-5.78-8.03-9.549-14.289-9.549h-32.476V15.476C297.637,6.928,290.716,0,282.161,0h-98.709
		c-8.555,0-15.474,6.928-15.474,15.476v90.739h-32.446c-6.259,0-11.899,3.769-14.289,9.557c-2.404,5.78-1.078,12.431,3.345,16.862
		L211.752,219.774z"/>
		</g>
	</svg>)
};

export const CamSvg = ({ className, size = 24, fill, type = true, anim = false }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons cam ${className}`} x="0" y="0" viewBox="0 -98 462.001 462" fill={fill ? fill : ""}>
		<path d="m256.152344 0h-206.152344c-27.601562.03125-49.96875 22.398438-50 50v165.949219c.03125 27.601562 22.398438 49.96875 50 50h206.152344c27.601562-.03125 49.96875-22.398438 50-50v-165.949219c-.03125-27.601562-22.398438-49.96875-50-50zm0 0" />
		<path className={anim ? "animCam" : null} d="m456.957031 26.035156c-3.117187-1.777344-6.949219-1.75-10.042969.074219l-110.5625 65.28125c-3.046874 1.800781-4.914062 5.074219-4.914062 8.613281v60.304688c0 3.089844 1.425781 6.007812 3.867188 7.902344l110.5625 85.835937c3.015624 2.339844 7.101562 2.761719 10.53125 1.082031 3.429687-1.679687 5.601562-5.164062 5.601562-8.984375v-211.425781c0-3.589844-1.925781-6.902344-5.042969-8.683594zm0 0" />
		{type ? null : <line x1="15" y1="-80" x2="445" y2="350" strokeWidth="50px" />}
	</svg>)
};

export const ExpandSvg = ({ className, size = 24, fill, type = true }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 24 24" fill={fill ? fill : ""}>
		{type ?
			<g>
				<path d="m1 8c.553 0 1-.447 1-1v-4c0-.552.448-1 1-1h4c.553 0 1-.447 1-1s-.447-1-1-1h-4c-1.654 0-3 1.346-3 3v4c0 .553.447 1 1 1z" />
				<path d="m23 16c-.553 0-1 .447-1 1v4c0 .552-.448 1-1 1h-4c-.553 0-1 .447-1 1s.447 1 1 1h4c1.654 0 3-1.346 3-3v-4c0-.553-.447-1-1-1z" />
				<path d="m7 22h-4c-.552 0-1-.448-1-1v-4c0-.553-.447-1-1-1s-1 .447-1 1v4c0 1.654 1.346 3 3 3h4c.553 0 1-.447 1-1s-.447-1-1-1z" />
				<path d="m21 0h-4c-.553 0-1 .447-1 1s.447 1 1 1h4c.552 0 1 .448 1 1v4c0 .553.447 1 1 1s1-.447 1-1v-4c0-1.654-1.346-3-3-3z" />
				<path d="m5 7.75v8.5c0 1.517 1.233 2.75 2.75 2.75h8.5c1.517 0 2.75-1.233 2.75-2.75v-8.5c0-1.517-1.233-2.75-2.75-2.75h-8.5c-1.517 0-2.75 1.233-2.75 2.75z" />
			</g>
			:
			<>
				<g>
					<path d="m.5 8c-.276 0-.5-.224-.5-.5v-5c0-1.379 1.121-2.5 2.5-2.5h5c.276 0 .5.224.5.5s-.224.5-.5.5h-5c-.827 0-1.5.673-1.5 1.5v5c0 .276-.224.5-.5.5z" />
				</g>
				<g>
					<path d="m21.5 24h-5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h5c.827 0 1.5-.673 1.5-1.5v-5c0-.276.224-.5.5-.5s.5.224.5.5v5c0 1.379-1.121 2.5-2.5 2.5z" />
				</g>
				<g>
					<path d="m7.5 24h-5c-1.379 0-2.5-1.121-2.5-2.5v-5c0-.276.224-.5.5-.5s.5.224.5.5v5c0 .827.673 1.5 1.5 1.5h5c.276 0 .5.224.5.5s-.224.5-.5.5z" />
				</g>
				<g>
					<path d="m23.5 8c-.276 0-.5-.224-.5-.5v-5c0-.827-.673-1.5-1.5-1.5h-5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h5c1.379 0 2.5 1.121 2.5 2.5v5c0 .276-.224.5-.5.5z" />
				</g>
				<g>
					<path d="m18.5 21h-13c-1.379 0-2.5-1.121-2.5-2.5v-13c0-1.379 1.121-2.5 2.5-2.5h13c1.379 0 2.5 1.121 2.5 2.5v13c0 1.379-1.121 2.5-2.5 2.5zm-13-17c-.827 0-1.5.673-1.5 1.5v13c0 .827.673 1.5 1.5 1.5h13c.827 0 1.5-.673 1.5-1.5v-13c0-.827-.673-1.5-1.5-1.5z" />
				</g>
			</>
		}
	</svg>)
};


export const PenToolSvg = ({ className, size = 24, fill, type = true }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0"
		viewBox={type ? "0 0 512 512" : "0 0 511.998 511.998"} fill={fill ? fill : ""}>
		{type ?
			<>
				<g>
					<g>
						<path d="M507.604,131.729L380.271,4.396c-5.861-5.861-15.358-5.861-21.22,0l-67.661,67.661c-5.861,5.861-5.861,15.358,0,21.22
			L418.723,220.61c2.93,2.931,6.77,4.397,10.609,4.397s7.679-1.466,10.61-4.397l67.661-67.661
			C513.466,147.087,513.466,137.59,507.604,131.729z"/>
					</g>
				</g>
				<g>
					<g>
						<path d="M397.504,241.829L270.171,114.497c-0.187-0.187-0.313-0.416-0.496-0.604l-143.542,71.767
			c-3.282,1.642-5.861,4.44-7.225,7.855L0,490.78l182.374-182.374c-2.808-5.869-4.512-12.357-4.512-19.287
			c0-24.824,20.194-45.019,45.019-45.019s45.019,20.194,45.019,45.019c0,24.824-20.194,45.019-45.019,45.019
			c-6.93,0-13.418-1.704-19.287-4.512L21.22,512l297.267-118.906c3.414-1.363,6.214-3.942,7.855-7.225l71.767-143.542
			C397.92,242.144,397.691,242.017,397.504,241.829z"/>
					</g>
				</g>
				<g>
					<g>
						<path d="M222.88,274.114c-8.279,0-15.006,6.727-15.006,15.006c0,8.279,6.727,15.006,15.006,15.006
			c8.279,0,15.006-6.727,15.006-15.006C237.886,280.841,231.16,274.114,222.88,274.114z"/>
					</g>
				</g>
			</>
			:
			<g>
				<g>
					<path d="M507.602,131.672L380.323,4.393c-5.857-5.858-15.355-5.858-21.213,0l-65.64,65.64c-5.858,5.858-5.858,15.355,0,21.213
			l6.498,6.498l-171.68,85.84c-3.286,1.643-5.855,4.435-7.219,7.846L1.121,491.297c-0.018,0.044-0.035,0.087-0.052,0.131
			c-0.154,0.384-0.287,0.773-0.407,1.164c-0.26,0.848-0.465,1.831-0.568,2.769c-0.441,4.033,0.741,7.883,3.113,10.897
			c0.088,0.112,0.175,0.225,0.267,0.335c3.611,4.334,9.154,6.135,14.351,5.136c0.384-0.073,0.763-0.171,1.142-0.275
			c0.079-0.022,0.16-0.035,0.239-0.059c0.506-0.147,1.005-0.322,1.496-0.523l299.865-119.946c3.411-1.364,6.203-3.933,7.846-7.219
			l85.84-171.68l6.498,6.498c2.929,2.929,6.768,4.394,10.606,4.394c3.838,0,7.678-1.464,10.606-4.394l65.64-65.64
			C513.46,147.028,513.46,137.531,507.602,131.672z M304.13,365.19L77.276,455.932l128.33-128.33
			c5.875,2.817,12.451,4.398,19.389,4.398c24.813,0,45-20.187,45-45s-20.187-45-45-45c-24.813,0-45,20.187-45,45
			c0,6.938,1.581,13.515,4.398,19.389l-128.33,128.33l90.741-226.854l175.524-87.761l69.563,69.563L304.13,365.19z M209.995,287
			c0-8.271,6.729-15,15-15s15,6.729,15,15s-6.729,15-15,15S209.995,295.271,209.995,287z M431.356,186.705l-10.799-10.799
			c-0.009-0.009-0.018-0.018-0.027-0.027l-84.413-84.413c-0.011-0.011-0.022-0.022-0.033-0.033L325.29,80.64l44.426-44.426
			l106.066,106.066L431.356,186.705z"/>
				</g>
			</g>
		}
	</svg>)
};

export const AskFriendSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 612 612" fill={fill ? fill : ""}>
		<g>
			<g>
				<path d="M269.272,310.198c86.177-0.005,117.184-86.291,125.301-157.169C404.572,65.715,363.282,0,269.272,0
			C175.274,0,133.963,65.71,143.97,153.029C152.095,223.907,183.093,310.204,269.272,310.198z"/>
				<path d="M457.707,346.115c2.773,0,5.528,0.083,8.264,0.235c-4.101-5.85-8.848-11.01-14.403-15.158
			c-16.559-12.359-38.005-16.414-56.964-23.864c-9.229-3.625-17.493-7.226-25.251-11.326
			c-26.184,28.715-60.329,43.736-100.091,43.74c-39.749,0-73.891-15.021-100.072-43.74c-7.758,4.101-16.024,7.701-25.251,11.326
			c-18.959,7.451-40.404,11.505-56.964,23.864c-28.638,21.375-36.039,69.46-41.854,102.26c-4.799,27.076-8.023,54.707-8.964,82.209
			c-0.729,21.303,9.789,24.29,27.611,30.721c22.315,8.048,45.356,14.023,68.552,18.921c44.797,9.46,90.973,16.729,136.95,17.054
			c22.278-0.159,44.601-1.956,66.792-4.833c-16.431-23.807-26.068-52.645-26.068-83.695
			C309.995,412.378,376.258,346.115,457.707,346.115z"/>
				<path d="M457.707,375.658c-65.262,0-118.171,52.909-118.171,118.171S392.444,612,457.707,612s118.172-52.909,118.172-118.171
			C575.878,428.566,522.969,375.658,457.707,375.658z M509.407,514.103h-31.425v31.424c0,11.198-9.077,20.276-20.274,20.276
			c-11.198,0-20.276-9.078-20.276-20.276v-31.424h-31.424c-11.198,0-20.276-9.077-20.276-20.276
			c0-11.198,9.077-20.276,20.276-20.276h31.424v-31.424c0-11.198,9.078-20.276,20.276-20.276c11.198,0,20.274,9.078,20.274,20.276
			v31.424h31.425c11.198,0,20.276,9.078,20.276,20.276C529.682,505.027,520.606,514.103,509.407,514.103z"/>
			</g>
		</g>
	</svg>)
};

export const CloseSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className} close`} x="0" y="0" viewBox="0 0 311 311.09867" fill={fill ? fill : ""}>
		<path d="m16.042969 311.097656c-4.09375 0-8.191407-1.554687-11.304688-4.691406-6.25-6.25-6.25-16.386719 0-22.636719l279.058594-279.058593c6.253906-6.253907 16.386719-6.253907 22.636719 0 6.25 6.25 6.25 16.382812 0 22.632812l-279.0625 279.0625c-3.136719 3.136719-7.230469 4.691406-11.328125 4.691406zm0 0" />
		<path d="m295.125 311.097656c-4.09375 0-8.191406-1.554687-11.304688-4.691406l-279.082031-279.082031c-6.25-6.253907-6.25-16.386719 0-22.636719s16.382813-6.25 22.632813 0l279.0625 279.082031c6.25 6.25 6.25 16.386719 0 22.636719-3.136719 3.136719-7.230469 4.691406-11.308594 4.691406zm0 0" />
	</svg>)
};

export const StarSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0"
		viewBox="0 0 19.481 19.481" fill={fill ? fill : ""}>
		<g>
			<path d="m10.201,.758l2.478,5.865 6.344,.545c0.44,0.038 0.619,0.587 0.285,0.876l-4.812,4.169 1.442,6.202c0.1,0.431-0.367,0.77-0.745,0.541l-5.452-3.288-5.452,3.288c-0.379,0.228-0.845-0.111-0.745-0.541l1.442-6.202-4.813-4.17c-0.334-0.289-0.156-0.838 0.285-0.876l6.344-.545 2.478-5.864c0.172-0.408 0.749-0.408 0.921,0z" />
		</g>
	</svg>)
};

export const KickOutSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0"
		viewBox="0 0 18.74 18.74" fill={fill ? fill : ""}>
		<g>
			<g>
				<path d="M14.898,10.031l0.014-0.004c0,0-0.265-1.847-1.845-1.746c0,0-0.963,0.184-2.291,0.201v1.444H9.998
			V8.472C9.764,8.463,9.522,8.447,9.276,8.424v1.308H8.498V8.325c-0.23-0.037-0.462-0.083-0.694-0.137V9.37H7.027V7.969
			C6.663,7.848,6.306,7.702,5.965,7.524c-0.238-0.125-1.498-3.61-1.718-3.766L0,5.098l0.62,3.815
			c-1.271,1.539,1.27,4.992,1.27,4.992L1.903,13.9c-0.003,0.01-0.009,0.021-0.006,0.03l0.32,1.002
			c0.018,0.058,0.159,0.066,0.312,0.02l2.567-0.789c0,0-0.586-1.495,0.701-1.892c0.328-0.108,0.672-0.002,0.672-0.002
			c0.948,0.222,2.104,0.824,2.104,0.824l6.373-1.96c0.152-0.046,0.264-0.133,0.246-0.191l-0.274-0.89
			C14.916,10.044,14.906,10.038,14.898,10.031z"/>
				<path d="M17.479,8.726l1.261-0.388L17.446,8.08c-0.868-0.173-1.453-0.527-1.738-1.051
			c-0.427-0.783-0.063-1.728-0.06-1.736l0.386-0.96l-0.873,0.554c-0.669,0.424-1.288,0.554-1.84,0.385
			c-0.969-0.296-1.467-1.415-1.472-1.427L11.238,4.11c0.024,0.058,0.619,1.408,1.883,1.798c0.547,0.169,1.129,0.131,1.732-0.112
			c-0.049,0.438-0.025,1.008,0.266,1.547c0.277,0.513,0.74,0.899,1.382,1.155c-0.305,0.225-0.617,0.556-0.771,1.02
			c-0.25,0.75-0.016,1.62,0.693,2.589l0.537-0.394c-0.572-0.783-0.774-1.449-0.6-1.981C16.597,9.011,17.471,8.728,17.479,8.726z"/>
			</g>
		</g>
	</svg>)
};

export const LineToolSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 511.998 511.998" fill={fill ? fill : ""}>
		<g>
			<g>

				<rect x="-86.01" y="235.971" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -106.0382 255.9989)" width="684.019" height="40.056" />
			</g>
		</g>
	</svg>)
};

export const CleanToolSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512.022 512.022" fill={fill ? fill : ""}>
		<g>
			<g>
				<path d="m510.146 158.762c-3.757-14.022-12.75-25.743-25.323-33.001l-63.616-36.729c-4.782-2.76-10.898-1.123-13.66 3.66s-1.123 10.898 3.66 13.66l63.616 36.729c7.946 4.588 13.629 11.994 16.004 20.856 2.374 8.863 1.156 18.119-3.432 26.065l-50.485 87.443v-71.299c0-17.525-14.258-31.783-31.783-31.783-4.161 0-8.137.804-11.783 2.264v-27.154c0-17.525-14.258-31.783-31.783-31.783-4.344 0-8.486.875-12.261 2.46-2.616-14.909-15.659-26.274-31.306-26.274s-28.689 11.365-31.305 26.274c-3.775-1.584-7.918-2.46-12.261-2.46-17.525 0-31.783 14.258-31.783 31.783l-.002 121.015-11.099-17.326c-8.727-13.625-25.577-19.673-40.975-14.703-18.401 5.937-28.652 25.148-23.338 43.738l.832 2.909c4.367 15.278 10.322 30.008 17.688 43.962l-68.898-39.778c-16.403-9.471-22.043-30.52-12.573-46.923l118.455-205.166c4.588-7.946 11.995-13.63 20.857-16.005 8.862-2.376 18.119-1.156 26.065 3.432l63.62 36.73c4.784 2.763 10.899 1.124 13.66-3.66 2.762-4.783 1.123-10.898-3.66-13.66l-63.62-36.73c-12.573-7.258-27.22-9.188-41.242-5.43-14.022 3.757-25.743 12.751-33.001 25.323l-6.319 10.944c-24.434-7.057-49.698-10.901-75.223-11.415-.069-.001-.137-.002-.205-.002-5.429 0-9.884 4.346-9.994 9.799-.111 5.521 4.275 10.088 9.797 10.199 22.122.445 44.031 3.576 65.302 9.3l-66.23 114.713c-14.372-4.941-29.368-7.589-44.691-7.862-5.534-.111-10.078 4.298-10.177 9.819-.099 5.523 4.298 10.078 9.82 10.177 11.904.213 23.576 2.085 34.83 5.564l-25.362 43.929c-14.984 25.953-6.06 59.259 19.893 74.243l103.425 59.712c11.935 14.802 25.696 28.155 41.01 39.638v96.058c0 5.522 4.477 10 10 10s10-4.478 10-10v-101.127c0-3.228-1.559-6.259-4.185-8.136-38.47-27.496-66.814-67.679-79.811-113.145l-.832-2.909c-2.334-8.164 2.168-16.601 10.248-19.207 6.76-2.18 14.162.474 17.994 6.456l29.52 46.083c2.395 3.738 6.969 5.45 11.23 4.203 4.262-1.247 7.19-5.156 7.19-9.597v-41.418c.001-.066.002-.132.002-.198v-113.548c0-6.497 5.286-11.783 11.783-11.783s11.783 5.286 11.783 11.783v93.913c0 5.522 4.477 10 10 10s10-4.478 10-10v-117.728c0-6.497 5.286-11.783 11.783-11.783 6.498 0 11.783 5.286 11.783 11.783v117.728c0 5.522 4.477 10 10 10s10-4.478 10-10v-93.913c0-6.497 5.286-11.783 11.783-11.783s11.783 5.286 11.783 11.783v93.913c0 5.522 4.477 10 10 10s10-4.478 10-10v-37.239c0-6.497 5.286-11.783 11.783-11.783s11.783 5.286 11.783 11.783v81.97c0 39.279-15.952 77.713-43.766 105.447-1.881 1.876-2.939 4.424-2.939 7.081v101.373c0 5.522 4.477 10 10 10s10-4.478 10-10v-97.294c21.735-22.751 36.402-50.536 42.897-80.684l71.613-124.037c7.261-12.573 9.189-27.22 5.431-41.242z" />
				<path d="m10.009 68.122c1.276 0 2.574-.246 3.826-.766 20.114-8.338 41.26-14.241 62.851-17.546 5.46-.835 9.208-5.938 8.372-11.397-.835-5.46-5.936-9.202-11.397-8.372-23.181 3.547-45.886 9.886-67.485 18.841-5.102 2.115-7.523 7.965-5.408 13.067 1.595 3.85 5.317 6.173 9.241 6.173z" />
				<path d="m10.008 133.329c1.268 0 2.557-.243 3.802-.756 31.21-12.844 65.483-17.447 99.114-13.312 5.483.683 10.472-3.222 11.146-8.704.674-5.481-3.223-10.472-8.705-11.146-37.035-4.557-74.786.518-109.167 14.668-5.107 2.102-7.544 7.945-5.442 13.053 1.59 3.862 5.319 6.197 9.252 6.197z" />
				<path d="m24.862 171.828c-6.753 2.489-13.374 5.51-19.68 8.979-4.839 2.662-6.604 8.742-3.942 13.581 1.821 3.311 5.242 5.183 8.771 5.183 1.629 0 3.283-.4 4.811-1.24 5.433-2.988 11.138-5.591 16.957-7.736 5.182-1.91 7.835-7.659 5.924-12.842-1.91-5.181-7.66-7.836-12.841-5.925z" />
				<path d="m377.244 85.198c2.63 0 5.2-1.07 7.07-2.93 1.86-1.86 2.93-4.44 2.93-7.07 0-2.64-1.07-5.22-2.93-7.08-1.87-1.859-4.441-2.93-7.07-2.93-2.63 0-5.21 1.07-7.07 2.93-1.87 1.87-2.93 4.44-2.93 7.08 0 2.63 1.06 5.2 2.93 7.07 1.86 1.86 4.429 2.93 7.07 2.93z" />
			</g>
		</g>
	</svg>)
};

export const ArrowAngleSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 26.676 26.676" fill={fill ? fill : ""}>
		<g>
			<path d="M26.105,21.891c-0.229,0-0.439-0.131-0.529-0.346l0,0c-0.066-0.156-1.716-3.857-7.885-4.59
		c-1.285-0.156-2.824-0.236-4.693-0.25v4.613c0,0.213-0.115,0.406-0.304,0.508c-0.188,0.098-0.413,0.084-0.588-0.033L0.254,13.815
		C0.094,13.708,0,13.528,0,13.339c0-0.191,0.094-0.365,0.254-0.477l11.857-7.979c0.175-0.121,0.398-0.129,0.588-0.029
		c0.19,0.102,0.303,0.295,0.303,0.502v4.293c2.578,0.336,13.674,2.33,13.674,11.674c0,0.271-0.191,0.508-0.459,0.562
		C26.18,21.891,26.141,21.891,26.105,21.891z" />
		</g>
	</svg>)
};

export const DotSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512" fill={fill ? fill : ""}>
		<g>
			<g>
				<path d="M256,0C114.837,0,0,114.837,0,256s114.837,256,256,256s256-114.837,256-256S397.163,0,256,0z" />
			</g>
		</g>
	</svg>)
};

export const SwitchScreenSvg = ({ className, size = 24, fill, anim = false }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className} ${anim ? "animCam" : ""}`}
		x="0" y="0" viewBox="0 0 468 468" fill={fill ? fill : ""}>
		<g>
			<g>
				<rect x="16" y="163.999" width="175" height="110" />
			</g>
		</g>
		<g>
			<g>
				<rect x="277" y="163.999" width="175" height="110" />
			</g>
		</g>
		<g>
			<g>
				<path d="M423.944,303.999H397v-14h-65v14h-26.686c-4.418,0-8,3.582-8,8s3.582,8,8,8h118.63c4.418,0,8-3.582,8-8
			S428.362,303.999,423.944,303.999z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M326.356,73.344c-0.002-0.002-0.003-0.003-0.005-0.005l-27.963-27.961c-3.124-3.124-8.189-3.124-11.314,0c0,0,0,0,0,0
			c-3.078,3.013-3.131,7.952-0.118,11.03c0.039,0.04,0.078,0.079,0.118,0.118l14.639,14.473H8c-4.418,0-8,3.582-8,8s3.582,8,8,8
			h293.047l-13.973,14.139c-3.148,3.166-3.133,8.283,0.032,11.431c1.496,1.488,3.515,2.331,5.625,2.351
			c2.12,0.011,4.156-0.825,5.657-2.322l27.963-27.952C329.473,81.526,329.475,76.466,326.356,73.344z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M460,380.999H166.953l13.973-14.139c3.127-3.157,3.127-8.243,0-11.4c-3.112-3.136-8.178-3.155-11.314-0.042c0,0,0,0,0,0
			l-27.963,27.943c-3.12,3.113-3.126,8.166-0.013,11.287c0.004,0.004,0.009,0.009,0.013,0.013l27.963,27.961
			c3.124,3.124,8.189,3.124,11.314,0c0,0,0,0,0,0c3.079-3.013,3.132-7.952,0.119-11.03c-0.039-0.04-0.079-0.08-0.119-0.119
			l-14.639-14.474H460c4.418,0,8-3.582,8-8S464.418,380.999,460,380.999z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M162.686,303.999H136v-14H71v14H44.056c-4.418,0-8,3.582-8,8s3.582,8,8,8h118.63c4.418,0,8-3.582,8-8
			S167.104,303.999,162.686,303.999z"/>
			</g>
		</g>
	</svg>)
};

export const RectToolSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512" fill={fill ? fill : ""}>
		<g>
			<g>
				<path d="M497,51H15C6.716,51,0,57.716,0,66v380c0,8.284,6.716,15,15,15h482c8.284,0,15-6.716,15-15V66
			C512,57.716,505.284,51,497,51z M482,431H30V81h452V431z"/>
			</g>
		</g>
	</svg>)
};

export const CircleToolSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512" fill={fill ? fill : ""}>
		<g>
			<g>
				<path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z"/>
			</g>
		</g>
	</svg>)
};

export const EmojiSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512" fill={fill ? fill : ""}>
		<circle style={{ fill: "#FFD93B" }} cx="256" cy="256" r="256" />
		<path style={{ fill: "#F4C534" }} d="M512,256c0,141.44-114.64,256-256,256c-80.48,0-152.32-37.12-199.28-95.28
	c43.92,35.52,99.84,56.72,160.72,56.72c141.36,0,256-114.56,256-256c0-60.88-21.2-116.8-56.72-160.72
	C474.8,103.68,512,175.52,512,256z"/>
		<circle style={{ fill: "#3E4347" }} cx="350.176" cy="225.6" r="40.176" />
		<ellipse transform="matrix(-0.9141 -0.4054 0.4054 -0.9141 607.8411 544.3153)" style={{ fill: "#5A5F63" }} cx="361.564" cy="207.787" rx="12.16" ry="7.872" />
		<circle style={{ fill: "#3E4347" }} cx="161.824" cy="225.6" r="40.176" />
		<ellipse transform="matrix(-0.9141 -0.4054 0.4054 -0.9141 247.3004 467.9457)" style={{ fill: "#5A5F63" }} cx="173.206" cy="207.784" rx="12.16" ry="7.872" />
		<path style={{ fill: "#3E4347" }} d="M151.136,357.056c-4.832-4.544-5.056-12.144-0.512-16.96c4.544-4.816,12.128-5.056,16.96-0.512
	c49.584,46.672,127.248,46.672,176.832,0c4.832-4.544,12.416-4.304,16.96,0.512c4.544,4.832,4.32,12.416-0.512,16.96
	C302.064,412.416,209.936,412.416,151.136,357.056z"/>
	</svg>)
};

export const ChatBadegSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512" fill={fill ? fill : ""}>
		<g>
			<path d="m460.747 439.163c75.489-87.071 66.225-218.376-18.944-294.583 43.746 153.294-71.93 306.42-231.303 306.42-3.068 0 15.448.108-57.484-.342 39.889 39.703 93.017 61.342 148.48 61.342.144 0 195.446-.999 195.561-1 13.333-.064 19.975-16.29 10.464-25.677z" />
			<path d="m210.5 421c116.064 0 210.489-94.43 210.489-210.5s-94.424-210.5-210.489-210.5-210.488 94.43-210.488 210.5c0 51.099 18.088 99.427 51.237 137.663l-46.774 46.16c-9.48 9.357-2.913 25.612 10.465 25.677.103.001 195.458 1 195.56 1zm-89.495-285h179.99c8.284 0 14.999 6.716 14.999 15s-6.715 15-14.999 15h-179.99c-8.284 0-14.999-6.716-14.999-15s6.716-15 14.999-15zm0 60h179.99c8.284 0 14.999 6.716 14.999 15s-6.715 15-14.999 15h-179.99c-8.284 0-14.999-6.716-14.999-15s6.716-15 14.999-15zm-14.999 75c0-8.284 6.715-15 14.999-15h179.99c8.284 0 14.999 6.716 14.999 15s-6.715 15-14.999 15h-179.99c-8.283 0-14.999-6.716-14.999-15z" />
		</g>
	</svg>)
};

export const OpacitySvg = ({ className, size = 24, fill, type = false }) => {
	/////////////////////////////////////////////
	const viewBox = !type ? "0 0 512.001 512.001" : "0 0 512 512";
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox={viewBox} fill={fill ? fill : ""}>
		{(!type) ?
			<>
				<g>
					<g>
						<path d="M465.319,376.414c-6.904-4.575-16.213-2.686-20.789,4.215c-16.344,24.649-37.03,45.588-61.486,62.236
			c-6.847,4.661-8.618,13.988-3.955,20.833c4.664,6.846,13.998,8.612,20.842,3.953c27.686-18.847,51.105-42.552,69.606-70.457
			C474.113,390.292,472.225,380.988,465.319,376.414z" />
					</g>
				</g>
				<g>
					<g>
						<path d="M507.225,206.57c-1.592-8.127-9.476-13.424-17.603-11.834c-8.13,1.591-13.431,9.469-11.839,17.595
			c5.451,27.829,5.799,57.835-0.024,87.471c-1.597,8.126,3.699,16.006,11.828,17.602c8.156,1.598,16.018-3.721,17.609-11.823
			C513.402,274.001,513.787,240.071,507.225,206.57z" />
					</g>
				</g>
				<g>
					<g>
						<path d="M469.607,114.92c-18.484-27.913-41.891-51.629-69.567-70.49c-6.849-4.665-16.179-2.9-20.844,3.942
			c-4.667,6.843-2.901,16.17,3.943,20.835c24.448,16.661,45.124,37.61,61.452,62.266c4.568,6.898,13.87,8.801,20.788,4.226
			C472.286,131.128,474.18,121.825,469.607,114.92z" />
					</g>
				</g>
				<g>
					<g>
						<path d="M320.336,488.711c-1.698-8.105-9.649-13.293-17.757-11.602c-10.359,2.169-20.933,3.591-31.579,4.29V30.609
			c10.647,0.699,21.22,2.121,31.579,4.29c8.119,1.696,16.06-3.504,17.757-11.602c1.698-8.105-3.498-16.052-11.606-17.749
			C149.336-27.824,0,93.591,0,256.004C0,418.765,149.677,539.76,308.73,506.46C316.838,504.762,322.035,496.816,320.336,488.711z
			 M241,481.424C124.739,473.86,30,377.335,30,256.004c0-121.299,94.684-217.852,211-225.419V481.424z" />
					</g>
				</g>
			</>
			:
			<>
				<g>
					<g>
						<path d="M469.607,114.92c-18.484-27.913-41.891-51.628-69.567-70.49c-6.849-4.665-16.179-2.9-20.844,3.942
			c-4.667,6.843-2.901,16.17,3.943,20.835c24.448,16.661,45.124,37.61,61.452,62.266c4.568,6.898,13.87,8.801,20.788,4.226
			C472.286,131.128,474.18,121.825,469.607,114.92z"/>
					</g>
				</g>
				<g>
					<g>
						<path d="M465.319,376.414c-6.904-4.575-16.213-2.686-20.789,4.215c-16.344,24.649-37.03,45.588-61.486,62.236
			c-6.847,4.661-8.618,13.988-3.955,20.833c4.664,6.846,13.998,8.612,20.842,3.953c27.686-18.847,51.105-42.551,69.606-70.457
			C474.113,390.292,472.225,380.988,465.319,376.414z"/>
					</g>
				</g>
				<g>
					<g>
						<path d="M507.225,206.57c-1.592-8.127-9.476-13.424-17.603-11.834c-8.13,1.591-13.431,9.469-11.839,17.595
			c5.451,27.829,5.799,57.834-0.024,87.471c-1.597,8.125,3.699,16.006,11.828,17.602c8.156,1.598,16.018-3.721,17.609-11.823
			C513.402,274.001,513.787,240.071,507.225,206.57z"/>
					</g>
				</g>
				<g>
					<g>
						<path d="M320.336,488.71c-1.698-8.105-9.649-13.293-17.757-11.602c-10.359,2.169-20.933,3.591-31.579,4.29V30.609
			c10.647,0.699,21.22,2.121,31.579,4.29c8.119,1.696,16.06-3.504,17.757-11.602c1.698-8.105-3.498-16.052-11.606-17.749
			C149.322-27.826,0,93.604,0,256.004c0,162.749,149.665,283.758,308.73,250.455C316.838,504.761,322.035,496.815,320.336,488.71z"
						/>
					</g>
				</g>
			</>
		}
	</svg>)
};

export const PinControlSvg = ({ className, size = 24, fill, type = false }) => {
	/////////////////////////////////////////////
	const viewBox = !type ? "0 0 480.96641 480.96641" : "0 0 193.826 193.826";
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox={viewBox} fill={fill ? fill : ""}>
		{(!type) ?
			<path d="m353.652344 7.3125c-9.75-9.75-25.558594-9.75-35.3125 0-9.75 9.753906-9.75 25.5625 0 35.3125l6.34375 6.34375-136 136h-74.75c-8.484375.023438-16.613282 3.394531-22.625 9.375-12.492188 12.496094-12.492188 32.753906 0 45.25l57.375 57.375-115.023438 115.023438c-16.285156 16.289062-27.835937 36.695312-33.421875 59.042968-.679687 2.722656.121094 5.601563 2.105469 7.589844 1.984375 1.984375 4.863281 2.78125 7.589844 2.105469 22.34375-5.585938 42.75-17.140625 59.039062-33.425781l115.023438-115.023438 57.378906 57.375c12.492188 12.492188 32.75 12.492188 45.246094 0 5.984375-6.011719 9.351562-14.140625 9.375-22.621094v-74.753906l136-136 6.34375 6.34375c9.753906 9.75 25.5625 9.75 35.3125 0s9.75-25.558594 0-35.3125zm-296 428.679688c-10.625 10.628906-23.300782 18.992187-37.253906 24.578124 5.585937-13.957031 13.945312-26.636718 24.574218-37.265624l115.023438-115.023438 12.6875 12.6875zm404.6875-284.679688c-3.546875 3.390625-9.136719 3.390625-12.6875 0l-12-12c-3.125-3.121094-8.1875-3.121094-11.3125 0l-144 144c-1.5 1.5-2.34375 3.535156-2.34375 5.65625v78.066406c-.011719 4.238282-1.699219 8.304688-4.6875 11.308594-6.335938 6.03125-16.289063 6.03125-22.625 0l-150.0625-150.0625c-6.246094-6.246094-6.246094-16.375 0-22.625 3.007812-2.988281 7.070312-4.671875 11.3125-4.6875h78.0625c2.121094 0 4.15625-.84375 5.65625-2.34375l144-144c3.125-3.125 3.125-8.1875 0-11.3125l-12-12c-3.496094-3.503906-3.496094-9.179688 0-12.6875 3.550781-3.390625 9.140625-3.390625 12.6875 0l120 120c3.5 3.507812 3.5 9.183594 0 12.6875zm0 0" />
			:
			<path d="M191.495,55.511L137.449,1.465c-1.951-1.953-5.119-1.953-7.07,0l-0.229,0.229c-3.314,3.313-5.14,7.72-5.14,12.406
			c0,3.019,0.767,5.916,2.192,8.485l-56.55,48.533c-4.328-3.868-9.852-5.985-15.703-5.985c-6.305,0-12.232,2.455-16.689,6.913
			l-0.339,0.339c-1.953,1.952-1.953,5.118,0,7.07l32.378,32.378l-31.534,31.533c-0.631,0.649-15.557,16.03-25.37,28.27
			c-9.345,11.653-11.193,13.788-11.289,13.898c-1.735,1.976-1.639,4.956,0.218,6.822c0.973,0.977,2.256,1.471,3.543,1.471
			c1.173,0,2.349-0.41,3.295-1.237c0.083-0.072,2.169-1.885,13.898-11.289c12.238-9.813,27.619-24.74,28.318-25.421l31.483-31.483
			l30.644,30.644c0.976,0.977,2.256,1.465,3.535,1.465s2.56-0.488,3.535-1.465l0.339-0.339c4.458-4.457,6.913-10.385,6.913-16.689
			c0-5.851-2.118-11.375-5.985-15.703l48.533-56.55c2.569,1.425,5.466,2.192,8.485,2.192c4.687,0,9.093-1.825,12.406-5.14l0.229-0.229
			C193.448,60.629,193.448,57.463,191.495,55.511z"/>
		}
	</svg>)
};

export const PlayControlSvg = ({ className, size = 24, fill, type = false }) => {
	/////////////////////////////////////////////
	const viewBox = !type ? "0 0 163.861 163.861" : "0 0 47.607 47.607";
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox={viewBox} fill={fill ? fill : ""}>
		{(!type) ?
			<g>
				<path d="M34.857,3.613C20.084-4.861,8.107,2.081,8.107,19.106v125.637c0,17.042,11.977,23.975,26.75,15.509L144.67,97.275
		c14.778-8.477,14.778-22.211,0-30.686L34.857,3.613z"/>
			</g>
			:
			<g>
				<path d="M17.991,40.976c0,3.662-2.969,6.631-6.631,6.631l0,0c-3.662,0-6.631-2.969-6.631-6.631V6.631C4.729,2.969,7.698,0,11.36,0
		l0,0c3.662,0,6.631,2.969,6.631,6.631V40.976z"/>
				<path d="M42.877,40.976c0,3.662-2.969,6.631-6.631,6.631l0,0c-3.662,0-6.631-2.969-6.631-6.631V6.631
		C29.616,2.969,32.585,0,36.246,0l0,0c3.662,0,6.631,2.969,6.631,6.631V40.976z"/>
			</g>}
	</svg>)
};

export const TextToolSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512" fill={fill ? fill : ""}>
		<g>
			<path d="m15 114.235c8.284 0 15-6.716 15-15v-69.235h69.235c8.284 0 15-6.716 15-15s-6.716-15-15-15h-84.235c-8.284 0-15 6.716-15 15v84.235c0 8.285 6.716 15 15 15z" />
			<path d="m497 0h-84.235c-8.284 0-15 6.716-15 15s6.716 15 15 15h69.235v69.235c0 8.284 6.716 15 15 15s15-6.716 15-15v-84.235c0-8.284-6.716-15-15-15z" />
			<path d="m497 397.765c-8.284 0-15 6.716-15 15v69.235h-69.235c-8.284 0-15 6.716-15 15s6.716 15 15 15h84.235c8.284 0 15-6.716 15-15v-84.235c0-8.285-6.716-15-15-15z" />
			<path d="m99.235 482h-69.235v-69.235c0-8.284-6.716-15-15-15s-15 6.716-15 15v84.235c0 8.284 6.716 15 15 15h84.235c8.284 0 15-6.716 15-15s-6.715-15-15-15z" />
			<path d="m419.66 191.38v-94.73c0-4.7-3.81-8.51-8.52-8.51h-155.14-155.14c-4.71 0-8.52 3.81-8.52 8.51v94.73c0 4.71 3.81 8.52 8.52 8.52h45.24c4.7 0 8.51-3.81 8.51-8.52v-32.45c0-4.71 3.82-8.52 8.52-8.52h53.21c4.71 0 8.52 3.81 8.52 8.52v234.14c0 4.71-3.81 8.52-8.52 8.52h-23.27c-4.71 0-8.52 3.81-8.52 8.52v45.24c0 4.7 3.81 8.51 8.52 8.51h62.93 62.93c4.71 0 8.52-3.81 8.52-8.51v-45.24c0-4.71-3.81-8.52-8.52-8.52h-23.27c-4.71 0-8.52-3.81-8.52-8.52v-234.14c0-4.71 3.81-8.52 8.52-8.52h53.21c4.7 0 8.52 3.81 8.52 8.52v32.45c0 4.71 3.81 8.52 8.51 8.52h45.24c4.71 0 8.52-3.81 8.52-8.52z" />
		</g>
	</svg>)
};

export const AskJoinSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 912.1 912.1" fill={fill ? fill : ""}>
		<g>
			<g>
				<path d="M504.607,574.9c102.8,0,186.4-83.601,186.4-186.4s-83.601-186.4-186.4-186.4c-102.799,0-186.4,83.6-186.4,186.4
			S401.808,574.9,504.607,574.9z"/>
				<g>
					<path d="M346.108,611.9c-71.8,0-130,58.199-130,130V887.1c0,13.801,11.2,25,25,25h527c13.8,0,25-11.199,25-25V745.5
				c2.2-3.8,4.2-7.9,5.8-12.2l102-270c3.4-9,5.2-18.6,5.2-28.3V132c0-44.2-35.8-80-80-80s-80,35.8-80,80v288.4l-72.3,191.5H346.108z
				"/>
					<path d="M30.808,178.1h59c12.4,0,22.9-9,24.7-21.2c3.4-22.2,10.3-38.6,20.5-48.5c9.5-9.2,22.6-13.7,40.2-13.7
				c18.2,0,32.1,5,42.7,15.4c10.6,10.4,15.5,22.9,15.5,39.5c0,7.8-1.8,15-5.5,22c-1.9,3.5-9.3,14.3-37.5,38.2
				c-26.2,22.2-43.9,43.1-54.2,63.8c-10.5,21.1-15.6,51.8-15.6,93.6l0,0c0,13.8,11.2,25,25,25h53.3c13.8,0,25-11.2,25-25l0,0
				c0-32.3,3.9-45.5,6.2-50.5c1.8-4,9.3-15.8,39-40.4c27.6-22.9,46.2-43.8,56.8-63.8c10.9-20.5,16.4-43,16.4-66.8
				c0-42.5-16.101-78-48-105.6c-30.8-26.6-71-40.1-119.5-40.1c-46.2,0-85.3,13.8-116,40.9c-31,27.4-48.7,64.5-52.7,110.2l0,0
				C4.708,165.5,16.208,178.1,30.808,178.1z"/>
					<path d="M198.708,533.6c13.8,0,25-11.199,25-25V455.4c0-13.801-11.2-25-25-25h-53.2c-13.8,0-25,11.199-25,25V508.6
				c0,13.801,11.2,25,25,25H198.708z"/>
				</g>
			</g>
		</g>
	</svg>)
};

export const MoveAllSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 492.009 492.009" fill={fill ? fill : ""}>
		<g>
			<g>
				<path d="M314.343,62.977L255.399,4.033c-2.672-2.672-6.236-4.04-9.92-4.032c-3.752-0.036-7.396,1.36-10.068,4.032l-57.728,57.728
			c-5.408,5.408-5.408,14.2,0,19.604l7.444,7.444c5.22,5.22,14.332,5.22,19.556,0l22.1-22.148v81.388
			c0,0.248,0.144,0.452,0.188,0.684c0.6,7.092,6.548,12.704,13.8,12.704h10.52c7.644,0,13.928-6.208,13.928-13.852v-9.088
			c0-0.04,0-0.068,0-0.1V67.869l22.108,22.152c5.408,5.408,14.18,5.408,19.584,0l7.432-7.436
			C319.751,77.173,319.751,68.377,314.343,62.977z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M314.335,409.437l-7.44-7.456c-5.22-5.228-14.336-5.228-19.564,0l-22.108,22.152v-70.216c0-0.04,0-0.064,0-0.1v-9.088
			c0-7.648-6.288-14.16-13.924-14.16h-10.528c-7.244,0-13.192,5.756-13.796,12.856c-0.044,0.236-0.188,0.596-0.188,0.84v81.084
			l-22.1-22.148c-5.224-5.224-14.356-5.224-19.58,0l-7.44,7.444c-5.4,5.404-5.392,14.2,0.016,19.608l57.732,57.724
			c2.604,2.612,6.08,4.032,9.668,4.032h0.52c3.716,0,7.184-1.416,9.792-4.032l58.94-58.94
			C319.743,423.633,319.743,414.841,314.335,409.437z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M147.251,226.781l-1.184,0h-7.948c-0.028,0-0.056,0-0.088,0h-69.88l22.152-22.032c2.612-2.608,4.048-6.032,4.048-9.74
			c0-3.712-1.436-7.164-4.048-9.768l-7.444-7.428c-5.408-5.408-14.204-5.4-19.604,0.008l-58.944,58.94
			c-2.672,2.668-4.1,6.248-4.028,9.92c-0.076,3.82,1.356,7.396,4.028,10.068l57.728,57.732c2.704,2.704,6.252,4.056,9.804,4.056
			s7.1-1.352,9.804-4.056l7.44-7.44c2.612-2.608,4.052-6.092,4.052-9.8c0-3.712-1.436-7.232-4.052-9.836l-22.144-22.184h80.728
			c0.244,0,0.644-0.06,0.876-0.104c7.096-0.6,12.892-6.468,12.892-13.716v-10.536C161.439,233.229,154.895,226.781,147.251,226.781z
			"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M487.695,236.765l-58.944-58.936c-5.404-5.408-14.2-5.408-19.604,0l-7.436,7.444c-2.612,2.604-4.052,6.088-4.052,9.796
			c0,3.712,1.436,7.072,4.052,9.68l22.148,22.032h-70.328c-0.036,0-0.064,0-0.096,0h-9.084c-7.644,0-13.78,6.444-13.78,14.084
			v10.536c0,7.248,5.564,13.108,12.664,13.712c0.236,0.048,0.408,0.108,0.648,0.108h81.188l-22.156,22.18
			c-2.608,2.604-4.048,6.116-4.048,9.816c0,3.716,1.436,7.208,4.048,9.816l7.448,7.444c2.7,2.704,6.248,4.06,9.8,4.06
			s7.096-1.352,9.8-4.056l57.736-57.732c2.664-2.664,4.092-6.244,4.028-9.92C491.787,243.009,490.359,239.429,487.695,236.765z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M246.011,207.541c-21.204,0-38.456,17.252-38.456,38.46c0,21.204,17.252,38.46,38.456,38.46
			c21.204,0,38.46-17.256,38.46-38.46C284.471,224.793,267.215,207.541,246.011,207.541z"/>
			</g>
		</g>
	</svg>)
};

export const SelectionSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 24 24" fill={fill ? fill : ""}>
		<path d="m2 5c-.552 0-1-.448-1-1v-1c0-1.654 1.346-3 3-3h1c.552 0 1 .448 1 1s-.448 1-1 1h-1c-.551 0-1 .449-1 1v1c0 .552-.448 1-1 1z" />
		<path d="m20 5c-.552 0-1-.448-1-1v-1c0-.551-.449-1-1-1h-1c-.552 0-1-.448-1-1s.448-1 1-1h1c1.654 0 3 1.346 3 3v1c0 .552-.448 1-1 1z" />
		<path d="m13 2h-4c-.552 0-1-.448-1-1s.448-1 1-1h4c.552 0 1 .448 1 1s-.448 1-1 1z" />
		<path d="m11 20h-2c-.552 0-1-.448-1-1s.448-1 1-1h2c.552 0 1 .448 1 1s-.448 1-1 1z" />
		<path d="m5 20h-1c-1.654 0-3-1.346-3-3v-1c0-.552.448-1 1-1s1 .448 1 1v1c0 .551.449 1 1 1h1c.552 0 1 .448 1 1s-.448 1-1 1z" />
		<path d="m2 13c-.552 0-1-.448-1-1v-4c0-.552.448-1 1-1s1 .448 1 1v4c0 .552-.448 1-1 1z" />
		<path d="m20 11c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1s1 .448 1 1v2c0 .552-.448 1-1 1z" />
		<path d="m23.796 18.624-9.433-9.433c-.123-.123-.286-.191-.461-.191-.36 0-.652.292-.652.652v13.695c0 .36.292.652.652.652.176 0 .342-.069.469-.199l3.917-4.062h5.049c.36 0 .652-.292.652-.652 0-.172-.07-.34-.193-.462z" />
	</svg>)
};

export const UploadSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512" fill={fill ? fill : ""}>
		<g>
			<g>
				<path d="M402.617,22.138c-22.358,2.844-42.713,14.458-58.65,30.395L107.081,289.419c-10.441,10.441-18.426,23.557-20.823,38.128
			c-7.463,45.373,31.354,84.241,76.754,76.888c14.572-2.36,27.703-10.317,38.141-20.755l216.138-216.138
			c4.166-4.166,4.166-10.919,0-15.085l-15.082-15.082c-4.166-4.166-10.919-4.166-15.085,0L168.833,355.667
			c-4.521,4.51-10.531,7-16.938,7c-13.177,0-23.896-10.74-23.896-23.938c0-6.375,2.49-12.375,7-16.896l241.99-241.99
			C387.208,69.625,400.792,64,415.24,64c29.823,0,54.094,24.271,54.094,54.833c0,14.104-5.396,27.458-15.208,37.604L201.889,417.381
			c-15.268,15.794-35.076,27.287-56.884,29.931c-57.832,7.012-106.769-40.495-102.019-99.332
			c1.801-22.307,12.788-42.92,28.613-58.745l234.61-234.61c4.166-4.166,4.166-10.919,0-15.085l-15.082-15.082
			c-4.166-4.166-10.919-4.166-15.085,0L39.156,261.344C13.912,286.588,0.007,320.14,0,356.964
			c-0.006,34.51,14.082,68.053,38.293,92.645c58.148,59.065,143.284,50.156,191.509,0.287l255-263.813
			C502.344,167.948,512,144.063,512,118.094C512,60.587,461.574,14.637,402.617,22.138z"/>
			</g>
		</g>
	</svg>)
};

export const DownloadSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512" fill={fill ? fill : ""}>
		<g>
			<path d="m423.04 216.42c-10.47-10.33-24.33-16.02-39.04-16.02-14.85 0-28.81 5.78-39.31 16.29l-32.69 32.68v-193.37c0-30.88-25.12-56-56-56s-56 25.12-56 56v193.37l-32.19-32.19c-10.5-10.5-25.09-16.51-40.05-16.51h-.19c-14.94.05-28.84 5.84-39.15 16.29-10.33 10.47-16.02 24.33-16.02 39.04 0 14.85 5.78 28.81 16.29 39.31l134.78 134.79c8.97 8.97 20.75 13.45 32.53 13.45s23.56-4.48 32.53-13.45l134.29-134.29c10.54-10.54 16.56-25.21 16.51-40.24-.05-14.94-5.84-28.84-16.29-39.15z" />
			<path d="m496 512h-24c-8.836 0-16-7.164-16-16s7.164-16 16-16h24c8.836 0 16 7.164 16 16s-7.164 16-16 16z" />
			<path d="m40 512h-24c-8.836 0-16-7.164-16-16s7.164-16 16-16h24c8.836 0 16 7.164 16 16s-7.164 16-16 16z" />
			<path d="m416 512h-320c-8.836 0-16-7.164-16-16s7.164-16 16-16h320c8.836 0 16 7.164 16 16s-7.164 16-16 16z" />
		</g>
	</svg>)
};

export const EyeSvg = ({ className, size = 24, fill, type = true }) => {
	/////////////////////////////////////////////
	if (type) return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 469.333 469.333" fill={fill ? fill : ""}>
		<g>
			<g>
				<g>
					<path d="M234.667,170.667c-35.307,0-64,28.693-64,64s28.693,64,64,64s64-28.693,64-64S269.973,170.667,234.667,170.667z" />
					<path d="M234.667,74.667C128,74.667,36.907,141.013,0,234.667c36.907,93.653,128,160,234.667,160
			c106.773,0,197.76-66.347,234.667-160C432.427,141.013,341.44,74.667,234.667,74.667z M234.667,341.333
			c-58.88,0-106.667-47.787-106.667-106.667S175.787,128,234.667,128s106.667,47.787,106.667,106.667
			S293.547,341.333,234.667,341.333z"/>
				</g>
			</g>
		</g>
	</svg>)
	else return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 469.44 469.44" fill={fill ? fill : ""}>
		<g>
			<g>
				<g>
					<path d="M231.147,160.373l67.2,67.2l0.32-3.52c0-35.307-28.693-64-64-64L231.147,160.373z" />
					<path d="M234.667,117.387c58.88,0,106.667,47.787,106.667,106.667c0,13.76-2.773,26.88-7.573,38.933l62.4,62.4
				c32.213-26.88,57.6-61.653,73.28-101.333c-37.013-93.653-128-160-234.773-160c-29.867,0-58.453,5.333-85.013,14.933l46.08,45.973
				C207.787,120.267,220.907,117.387,234.667,117.387z"/>
					<path d="M21.333,59.253l48.64,48.64l9.707,9.707C44.48,145.12,16.64,181.707,0,224.053c36.907,93.653,128,160,234.667,160
				c33.067,0,64.64-6.4,93.547-18.027l9.067,9.067l62.187,62.293l27.2-27.093L48.533,32.053L21.333,59.253z M139.307,177.12
				l32.96,32.96c-0.96,4.587-1.6,9.173-1.6,13.973c0,35.307,28.693,64,64,64c4.8,0,9.387-0.64,13.867-1.6l32.96,32.96
				c-14.187,7.04-29.973,11.307-46.827,11.307C175.787,330.72,128,282.933,128,224.053C128,207.2,132.267,191.413,139.307,177.12z"
					/>
				</g>
			</g>
		</g>
	</svg>)
};

export const BackSvg = ({ className, size = 24, fill }) => {
	const isRTL = useSelector(state => state.sign.isRTL);
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className} ${isRTL ? "rot180" : ""}`} x="0" y="0"
		viewBox="0 0 493.356 493.356" fill={fill ? fill : ""}>
		<g>
			<path d="M490.498,239.278l-109.632-99.929c-3.046-2.474-6.376-2.95-9.993-1.427c-3.613,1.525-5.427,4.283-5.427,8.282v63.954H9.136
		c-2.666,0-4.856,0.855-6.567,2.568C0.859,214.438,0,216.628,0,219.292v54.816c0,2.663,0.855,4.853,2.568,6.563
		c1.715,1.712,3.905,2.567,6.567,2.567h356.313v63.953c0,3.812,1.817,6.57,5.428,8.278c3.62,1.529,6.95,0.951,9.996-1.708
		l109.632-101.077c1.903-1.902,2.852-4.182,2.852-6.849C493.356,243.367,492.401,241.181,490.498,239.278z"/>
		</g>
	</svg>)
};

/** Report flag (filled; colour it with a class like the other menu icons). */
export const FlagSvg = ({ className, size = 24, fill }) => (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
	className={`icons ${className}`} viewBox="0 0 24 24" fill={fill ? fill : ""} aria-hidden="true">
	<path d="M5 2a1 1 0 0 1 1 1v.3h12.2a1 1 0 0 1 .8 1.6L16.4 8.5 19 12.1a1 1 0 0 1-.8 1.6H6V21a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Z" />
</svg>);
export const MoreSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 477.867 477.867" fill={fill ? fill : ""}>
		<g>
			<g>
				<circle cx="68.267" cy="238.933" r="68.267" />
			</g>
		</g>
		<g>
			<g>
				<circle cx="238.933" cy="238.933" r="68.267" />
			</g>
		</g>
		<g>
			<g>
				<circle cx="409.6" cy="238.933" r="68.267" />
			</g>
		</g>
	</svg>)
};

export const DeleteSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512" fill={fill ? fill : ""}>
		<g>
			<path d="m424 64h-88v-16c0-26.51-21.49-48-48-48h-64c-26.51 0-48 21.49-48 48v16h-88c-22.091 0-40 17.909-40 40v32c0 8.837 7.163 16 16 16h384c8.837 0 16-7.163 16-16v-32c0-22.091-17.909-40-40-40zm-216-16c0-8.82 7.18-16 16-16h64c8.82 0 16 7.18 16 16v16h-96z" />
			<path d="m78.364 184c-2.855 0-5.13 2.386-4.994 5.238l13.2 277.042c1.22 25.64 22.28 45.72 47.94 45.72h242.98c25.66 0 46.72-20.08 47.94-45.72l13.2-277.042c.136-2.852-2.139-5.238-4.994-5.238zm241.636 40c0-8.84 7.16-16 16-16s16 7.16 16 16v208c0 8.84-7.16 16-16 16s-16-7.16-16-16zm-80 0c0-8.84 7.16-16 16-16s16 7.16 16 16v208c0 8.84-7.16 16-16 16s-16-7.16-16-16zm-80 0c0-8.84 7.16-16 16-16s16 7.16 16 16v208c0 8.84-7.16 16-16 16s-16-7.16-16-16z" />
		</g>
	</svg>)
};

export const CopySvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 699.428 699.428" fill={fill ? fill : ""}>
		<g>
			<g id="_x33__31_">
				<g>
					<path d="M502.714,0.678C500.004,0.678,240.428,0,240.428,0C194.178,0,153,42.425,153,87.429l-25.267,0.59
				c-46.228,0-84.019,41.834-84.019,86.838V612c0,45.004,41.179,87.428,87.429,87.428H459c46.249,0,87.428-42.424,87.428-87.428
				h21.857c46.25,0,87.429-42.424,87.429-87.428v-349.19L502.714,0.678z M459,655.715H131.143c-22.95,0-43.714-21.441-43.714-43.715
				V174.857c0-32.523,26.753-43.714,65.571-43.714v393.429C153,569.576,194.178,612,240.428,612c0,0,236.975-0.24,262.482-0.24
				C502.91,638.295,485.513,655.715,459,655.715z M502.714,459.24H306c-12.065,0-21.857-9.77-21.857-21.836
				c0-12.064,9.792-21.834,21.857-21.834h196.714c12.065,0,21.857,9.77,21.857,21.834
				C524.571,449.471,514.779,459.24,502.714,459.24z M502.714,350.064H306c-12.065,0-21.857-9.771-21.857-21.835
				c0-12.065,9.792-21.835,21.857-21.835h196.714c12.065,0,21.857,9.77,21.857,21.835
				C524.571,340.272,514.779,350.064,502.714,350.064z M546.428,174.857c-23.277,0-43.714-21.004-43.714-43.714
				c0,0,0-44.283,0-86.751v-0.044L612,174.857H546.428z"/>
				</g>
			</g>
		</g>
	</svg>)
};

export const SharedSvg = ({ size = 24, className, fill, active = false, ...props }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size}
		height={size} x="0" y="0" viewBox="0 0 512.000000 512.000000"
		className={`icons ${className}`}
		aria-pressed={active ? "true" : "false"}
		{...props}>
		<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)">
			<path d="M1923 4899 c-40 -12 -1240 -1154 -1267 -1206 -21 -42 -18 -108 8
		  -147 21 -33 1192 -1152 1231 -1178 40 -26 129 -21 172 10 62 44 63 52 63 456
		  l0 366 813 0 c878 0 920 -2 1080 -54 382 -126 672 -449 753 -839 8 -40 18
		  -121 23 -180 8 -115 18 -139 75 -181 20 -16 42 -21 86 -21 63 0 95 16 134 69
		  20 26 21 40 21 304 0 183 -5 302 -13 352 -64 366 -219 667 -472 920 -135 134
		  -259 223 -435 309 -147 73 -239 106 -402 143 -95 21 -119 22 -878 27 l-780 6
		  -5 377 c-5 363 -6 378 -26 405 -41 54 -118 81 -181 62z"/>
			<path d="M95 3186 c-42 -18 -83 -69 -91 -112 -12 -65 3 -543 20 -633 67 -355
		  218 -643 466 -891 227 -226 507 -378 835 -451 98 -22 118 -23 880 -28 l780 -6
		  5 -375 c4 -273 8 -381 17 -397 19 -32 61 -62 104 -73 85 -23 68 -37 726 591
		  361 345 616 595 627 616 21 42 18 108 -8 148 -21 33 -1192 1152 -1231 1177
		  -40 26 -129 21 -172 -10 -62 -44 -63 -52 -63 -456 l0 -366 -812 0 c-485 0
		  -841 4 -883 10 -430 62 -787 358 -920 765 -31 95 -43 163 -54 299 -8 114 -19
		  138 -73 179 -33 25 -113 32 -153 13z"/>
		</g>
	</svg>)
};

export const ErrorSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 451.74 451.74" fill={fill ? fill : ""}>
		<path fill="#D7443E" d="M446.324,367.381L262.857,41.692c-15.644-28.444-58.311-28.444-73.956,0L5.435,367.381
	c-15.644,28.444,4.267,64,36.978,64h365.511C442.057,429.959,461.968,395.825,446.324,367.381z"/>
		<path fill="#FFFFFF" d="M225.879,63.025l183.467,325.689H42.413L225.879,63.025L225.879,63.025z" />
		<g>
			<path fill="#3F4448" d="M196.013,212.359l11.378,75.378c1.422,8.533,8.533,15.644,18.489,15.644l0,0
		c8.533,0,17.067-7.111,18.489-15.644l11.378-75.378c2.844-18.489-11.378-34.133-29.867-34.133l0,0
		C207.39,178.225,194.59,193.87,196.013,212.359z"/>
			<circle fill="#3F4448" cx="225.879" cy="336.092" r="17.067" />
		</g>
	</svg>)
};

export const LeaveSvg = ({ className, size = 24, fill }) => {
	const isRTL = useSelector(state => state.sign.isRTL);
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className} ${isRTL ? "rev" : ""}`} x="0" y="0"
		viewBox="0 0 480.008 480.008" fill={fill ? fill : ""}>
		<g transform="matrix(-1,0,0,1,480.00799560546875,0)">
			<path d="M475.328,116.683l-96-96c-4.576-4.576-11.456-5.952-17.44-3.456S352,25.547,352,32.011v48h-16  c-185.568,0-336,150.432-336,336v32c0,8.832,7.168,16,16,16h64c8.832,0,16-7.168,16-16v-32c0-132.544,107.456-240,240-240h16v48  c0,6.464,3.904,12.32,9.888,14.784c5.984,2.496,12.864,1.12,17.44-3.456l96-96C481.568,133.067,481.568,122.955,475.328,116.683z" />
		</g>
	</svg>)
};

export const SendSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0"
		viewBox="0 0 485.725 485.725" fill={fill ? fill : ""}>
		<g>
			<g>
				<path d="M459.835,196.758L73.531,9.826C48.085-2.507,17.46,8.123,5.126,33.569c-6.289,12.975-6.815,28-1.449,41.384
			l60.348,150.818h421.7C481.285,213.048,471.972,202.611,459.835,196.758z"/>
			</g>
		</g>
		<g>
			<g>
				<path d="M64.025,259.904L3.677,410.756c-10.472,26.337,2.389,56.177,28.726,66.65c5.963,2.371,12.319,3.603,18.736,3.631
			c7.754,0,15.408-1.75,22.391-5.12l386.304-187c12.137-5.854,21.451-16.291,25.89-29.013H64.025z"/>
			</g>
		</g>
	</svg>)
};

export const BusinessSvg = ({ className, size = 24, fill }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 512 512" fill={fill ? fill : ""}>
		<path d="M216.948,10a6,6,0,0,0-6,6V39.534h12V16A6,6,0,0,0,216.948,10Z" />
		<path d="M390.508,175.067a6,6,0,0,0-6,6v16.649h12V181.067A6,6,0,0,0,390.508,175.067Z" />
		<path d="M115.788,126.615a6,6,0,0,0-12,0v9.794h12Z" />
		<path d="M364.976,304.559h51.065V224.271H364.976Zm14.481-65.842H399.41a6,6,0,0,1,0,12H379.457a6,6,0,0,1,0-12Zm0,22.525H399.41a6,6,0,0,1,0,12H379.457a6,6,0,0,1,0-12Zm0,22.525H399.41a6,6,0,0,1,0,12H379.457a6,6,0,0,1,0-12Z" />
		<rect x="381.061" y="204.536" width="18.894" height="7.736" />
		<polygon points="121.416 143.508 98.159 143.508 98.159 167.526 121.416 156.082 121.416 143.508" />
		<rect x="175.167" y="46.005" width="76.101" height="21.659" />
		<path d="M262,363.552a188.863,188.863,0,0,1,82.944,21.536,246.63,246.63,0,0,0,10.807-68.529H262Z" />
		<path d="M268.548,79.665H157.887V304.559H268.548Zm-22.9,208.625H180.79a6,6,0,0,1,0-12h64.856a6,6,0,1,1,0,12Zm0-34.067H180.79a6,6,0,0,1,0-12h64.856a6,6,0,1,1,0,12Zm0-34.068H180.79a6,6,0,0,1,0-12h64.856a6,6,0,0,1,0,12Zm0-34.067H180.79a6,6,0,0,1,0-12h64.856a6,6,0,0,1,0,12Zm0-34.067H180.79a6,6,0,0,1,0-12h64.856a6,6,0,0,1,0,12Zm0-34.068H180.79a6,6,0,0,1,0-12h64.856a6,6,0,0,1,0,12Z" />
		<path d="M280.548,304.559h72.428V108.634H280.548ZM295.1,130.409h41.816a6,6,0,0,1,0,12H295.1a6,6,0,0,1,0-12Zm0,33.381h41.816a6,6,0,0,1,0,12H295.1a6,6,0,0,1,0-12Zm0,33.38h41.816a6,6,0,0,1,0,12H295.1a6,6,0,0,1,0-12Zm0,33.381h41.816a6,6,0,0,1,0,12H295.1a6,6,0,0,1,0-12Zm0,33.381h41.816a6,6,0,1,1,0,12H295.1a6,6,0,0,1,0-12Z" />
		<path d="M156.426,391.348a257.621,257.621,0,0,1-12.191-74.789H76.67A178.561,178.561,0,0,0,116.7,423.534,191.08,191.08,0,0,1,156.426,391.348Z" />
		<path d="M428.041,259.3v45.259h7.3A177.988,177.988,0,0,0,428.041,259.3Z" />
		<path d="M387.409,432.61a177.156,177.156,0,0,0-35.894-29.9c-13.672,35.232-35.546,64.316-64.135,84.539A179.321,179.321,0,0,0,387.409,432.61Z" />
		<path d="M395.321,423.509a178.562,178.562,0,0,0,40.009-106.95H367.765a257.767,257.767,0,0,1-12.128,74.6A189.1,189.1,0,0,1,395.321,423.509Z" />
		<path d="M250,363.581V316.559H156.249a246.536,246.536,0,0,0,10.873,68.733A191.023,191.023,0,0,1,250,363.581Z" />
		<path d="M224.62,487.249c-28.54-20.188-50.388-49.209-64.065-84.359a179.066,179.066,0,0,0-35.946,29.74A179.327,179.327,0,0,0,224.62,487.249Z" />
		<path d="M145.887,157.413,76.559,191.529v113.03h69.328ZM129.375,285.322H94.118a6,6,0,0,1,0-12h35.257a6,6,0,0,1,0,12Zm0-22.851H94.118a6,6,0,0,1,0-12h35.257a6,6,0,0,1,0,12Zm0-22.852H94.118a6,6,0,1,1,0-12h35.257a6,6,0,0,1,0,12Zm0-22.851H94.118a6,6,0,1,1,0-12h35.257a6,6,0,0,1,0,12Z" />
		<path d="M340.994,396.6A176.961,176.961,0,0,0,262,375.554V488.617C298.249,469.979,325.457,437.723,340.994,396.6Z" />
		<path d="M250,375.591a179.108,179.108,0,0,0-78.919,21.194c15.549,41.036,42.726,73.223,78.919,91.832Z" />
	</svg>)
};

export const AudioSvg = ({ className, size = 24, type = true, anim = false }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 384 384">
		<g>
			<g>
				{type ?
					<g>
						<path className={anim ? "anim" : null} d="M288,192c0-37.653-21.76-70.187-53.333-85.867v171.84C266.24,262.187,288,229.653,288,192z" />
						<polygon points="0,128 0,256 85.333,256 192,362.667 192,21.333 85.333,128" />
						<path className={anim ? "anim" : null} d="M234.667,4.907V48.96C296.32,67.307,341.333,124.373,341.333,192S296.32,316.693,234.667,335.04v44.053
				C320.107,359.68,384,283.413,384,192S320.107,24.32,234.667,4.907z"/>
					</g> :
					<g>
						<path d="M288,192c0-37.653-21.76-70.187-53.333-85.867v47.147l52.373,52.373C287.68,201.173,288,196.587,288,192z" />
						<path d="M341.333,192c0,20.053-4.373,38.933-11.52,56.32l32.32,32.32C376,254.08,384,224,384,192
				c0-91.307-63.893-167.68-149.333-187.093V48.96C296.32,67.307,341.333,124.373,341.333,192z"/>
						<polygon points="192,21.333 147.413,65.92 192,110.507 			" />
						<path d="M27.2,0L0,27.2L100.8,128H0v128h85.333L192,362.667V219.2l90.773,90.773c-14.293,10.987-30.4,19.84-48.107,25.173V379.2
				c29.333-6.72,56.107-20.16,78.613-38.613L356.8,384l27.2-27.2l-192-192L27.2,0z"/>
					</g>}
			</g>
		</g>
	</svg>)
};

export const MinLogoSvg = ({ className, size = 40 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons MTR ${className}`} x="0" y="0" viewBox="192 70 450 450">
		<path className="cls-1" d="M317.86,182.83V162.55c0-18.57,13.42-30.73,33.54-30.73s33.39,12.17,33.39,30.73v20.28c0,18.57-13.26,30.74-33.39,30.74S317.86,201.4,317.86,182.83Z" />
		<path className="cls-1" d="M440.78,305.06h0a23.85,23.85,0,0,0-2.32-2.92L395,247.32a59.89,59.89,0,0,1-4.71-7.31c-2.77-4.78-7.23-6.81-13.15-6.81H330.38a12.52,12.52,0,0,0-12.52,12.52V450.94a12.52,12.52,0,0,0,12.52,12.52h28a12.52,12.52,0,0,0,12.52-12.52V304.41a2.43,2.43,0,0,1,4.23-1.64l26,28.51h0a23.78,23.78,0,1,0,39.67-26.21Z" />
		<path className="cls-2" d="M490.49,213.57c-20.13,0-33.39-12.17-33.39-30.74V162.55c0-18.57,13.26-30.73,33.39-30.73S524,144,524,162.55v20.28C524,201.4,510.61,213.57,490.49,213.57Z" />
		<path className="cls-3" d="M401.11,305.06h0a23.85,23.85,0,0,1,2.32-2.92l43.48-54.81a59.89,59.89,0,0,0,4.71-7.31c2.77-4.78,7.23-6.81,13.15-6.81h46.74A12.52,12.52,0,0,1,524,245.72V450.94a12.52,12.52,0,0,1-12.52,12.52h-28A12.52,12.52,0,0,1,471,450.94V304.41a2.43,2.43,0,0,0-4.23-1.64l-26,28.51h0a23.78,23.78,0,1,1-39.67-26.21Z" />
	</svg>)
};

export const MainLogoSvg = ({ className, width = 120, height = 40, isArabic = false }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}
		className={`icons MTR ${className}`} x="0" y="0" viewBox={isArabic ? "0 0 112.9 37" : "188 172 500 250"}>
		{isArabic ? <>
			<path className="cls-1" d="M11.6,8.4h3.8l.3.4V28.7C15.5,36.8,10.8,39.6,4,40H1.4L0,38.2V36.3L.2,36c7.2,1,11-1.4,11.1-7.7V8.7Z" transform="translate(0 -3)" />
			<path className="cls-1" d="M59.9,15.2a41.8,41.8,0,0,0-2.6-3.4,1,1,0,0,0-.9-.4h-4a.9.9,0,0,0-1,1V24.5a1.1,1.1,0,0,1-1.1,1.1H41.1V15.2c-.6-4.6-3.5-7.1-8.7-7.4S22,11.2,21.7,18.5v.2c.2,6.5,3.4,10,9.2,10.8h5.6c-.4,5.8-4.5,7.4-10.7,6.6a.5.5,0,0,0-.4.2h-.2c0,.1-.1.1-.1.2v1.3a.3.3,0,0,0,.1.2l1.4,1.8a.5.5,0,0,0,.4.2c7.1.1,13.2-1.4,14.1-10.5H53.9a2,2,0,0,0,1.9-2V17.3c0-.1,0-.2.1-.2a.1.1,0,0,1,.2,0l2.2,2.5,2.5-3.3ZM36.6,25.6H31.7c-4-.5-5.8-3-5.5-7.5S28.1,12,32,11.8s4.3,1.3,4.6,4Z" transform="translate(0 -3)" />
			<path className="cls-2" d="M68.4,7.8c0,1.1-1.2,2-2.7,2S63,8.9,63,7.8V5c0-1.1,1.2-2,2.7-2s2.7.9,2.7,2V7.8Z" transform="translate(0 -3)" />
			<path className="cls-2" d="M80.6,35.9A2.6,2.6,0,1,1,78,33.3,2.6,2.6,0,0,1,80.6,35.9Z" transform="translate(0 -3)" />
			<path className="cls-2" d="M86,35.9a2.6,2.6,0,1,1-2.6-2.6A2.6,2.6,0,0,1,86,35.9Z" transform="translate(0 -3)" />
			<path className="cls-2" d="M102.6,7.9c-4.8.2-8.5,1.9-9,7.7h0V24A1.6,1.6,0,0,1,92,25.6H83.6a.4.4,0,0,1-.4-.4V8.9a.4.4,0,0,0-.1-.3H78.9a.4.4,0,0,0-.1.3V24a1.6,1.6,0,0,1-1.6,1.6H70a1.5,1.5,0,0,1-1.5-1.5V12.7a1.3,1.3,0,0,0-1.4-1.3H63.4a1.2,1.2,0,0,0-1,.6l-.5.7-1.8,2.4c-.1.1-.2.2-.1.3l1,3.8a.4.4,0,0,0,.7.2l2-2.2H64V27.3a2.1,2.1,0,0,0,2.2,2.1H79.4a2.9,2.9,0,0,0,2.3-1c.2-.2.5-.2.6,0l.7.9H93.8a3.9,3.9,0,0,0,2.7-1,.3.3,0,0,1,.5,0,9.1,9.1,0,0,0,6.5,2.4h0c6.1-.9,9.3-5,9.4-12.3h0c-.5-5.9-3.4-9.4-8.7-10.4Zm.3,19a6.3,6.3,0,0,1-4.7-2c-.1,0-.1-.1-.1-.2V15.9h0c.3-2.5,1.6-3.9,4.4-4.1h.1c3.5.2,5.3,2.5,5.8,6.5h0c.3,5.5-1.6,8.3-5.5,8.7Z" transform="translate(0 -3)" />
			<path className="cls-1" d="M57.5,7.8c0,1.1-1.2,2-2.7,2s-2.7-.9-2.7-2V5c0-1.1,1.2-2,2.7-2s2.7.9,2.7,2V7.8Z" transform="translate(0 -3)" />
			<path className="cls-3" d="M59.9,15.2l-1.5,2.1a1.8,1.8,0,0,0-.1,2.3,1.9,1.9,0,0,0,2.6.5l.3-.2.7-.7a1.6,1.6,0,0,0,.2-1.2,2.5,2.5,0,0,0-.4-.7Z" transform="translate(0 -3)" />
		</> : <>
			<path className="cls-1" d="M245.74,345.49v7c0,12.31,8.82,20.44,22.76,20.44,10,0,17.41-3.72,20-10,1.39-3,2.79-4.88,6.5-4.88h16c3.95,0,6.27,1.86,6,5.57-3,20.43-21.83,32.74-48.53,32.74-30.65,0-50.62-18.11-50.62-45.74V320.41c0-27.63,19.74-45.74,49.92-45.74,29.72,0,49.46,18.11,49.46,45.74v18.81q0,6.27-6.27,6.27Zm0-27.17v5.8h43.65v-5.8c0-12.31-8.59-20.2-21.59-20.2C254.56,298.12,245.74,306,245.74,318.32Z" />
			<path className="cls-1" d="M355.56,345.49v7c0,12.31,8.82,20.44,22.75,20.44,10,0,17.41-3.72,20-10,1.4-3,2.79-4.88,6.5-4.88h16c3.95,0,6.27,1.86,6,5.57-3,20.43-21.83,32.74-48.53,32.74-30.65,0-50.62-18.11-50.62-45.74V320.41c0-27.63,19.74-45.74,49.92-45.74,29.72,0,49.46,18.11,49.46,45.74v18.81q0,6.27-6.27,6.27Zm0-27.17v5.8h43.65v-5.8c0-12.31-8.59-20.2-21.6-20.2C364.38,298.12,355.56,306,355.56,318.32Z" />
			<path className="cls-1" d="M478.86,302.3v52.24c0,8.36,5.34,13.24,13.47,13.24h5.8c3.95,0,6.27,2.32,6.27,6.27v13.24c0,3.95-2.32,6.27-6.27,6.27h-13C464.7,393.55,451,381,451,361.74V302.3H437.53c-3.95,0-6.27-2.09-6.27-6.27V283.26c0-3.72,2.09-5.81,5.81-5.81h7.43c5.34,0,8.36-3,8.36-8.59V253.53c0-3.95,2.32-6.27,6.27-6.27h13.47c4.18,0,6.27,2.32,6.27,6.27v23.91h20.66c3.95,0,6.27,2.32,6.27,6.27V296c0,4.18-2.32,6.27-6.27,6.27Z" />
			<path className="cls-1" d="M512.76,350.59V320.41c0-27.63,20-45.74,49.92-45.74s49.69,18.11,49.69,45.74v30.19c0,27.63-19.74,45.74-49.69,45.74S512.76,378.23,512.76,350.59Zm71.75,0V320.41c0-12.07-8.59-20-21.83-20s-22.06,7.89-22.06,20v30.19c0,12.07,8.82,20,22.06,20S584.51,362.67,584.51,350.59Z" />
			<path className="cls-1" d="M622.58,350.59V320.41c0-27.63,20-45.74,49.92-45.74s49.69,18.11,49.69,45.74v30.19c0,27.63-19.74,45.74-49.69,45.74S622.58,378.23,622.58,350.59Zm71.75,0V320.41c0-12.07-8.59-20-21.83-20s-22.06,7.89-22.06,20v30.19c0,12.07,8.82,20,22.06,20S694.33,362.67,694.33,350.59Z" />
			<path className="cls-1" d="M802.3,281.16v16c0,3.71-2.32,6.27-6.27,6.27-20.9,0-31.11,11.15-31.11,28.1v55.73c0,3.95-2.09,6.27-6.27,6.27H743.32c-3.95,0-6.27-2.32-6.27-6.27V283.72c0-3.95,2.32-6.27,6.27-6.27h15.33c4.18,0,6.27,2.32,6.27,6.27v13.93h1.86c4.41-14.63,13.7-22.06,29-22.76C800,274.43,802.3,277,802.3,281.16Z" />
			<path className="cls-1" d="M81,229.31V217.24c0-11.05,8-18.29,20-18.29s19.87,7.24,19.87,18.29v12.07c0,11.05-7.89,18.29-19.87,18.29S81,240.36,81,229.31Z" />
			<path className="cls-1" d="M154.13,302.06h0a14.2,14.2,0,0,0-1.38-1.74l-25.88-32.63a35.64,35.64,0,0,1-2.81-4.35c-1.65-2.85-4.31-4.05-7.82-4.05H88.43A7.45,7.45,0,0,0,81,266.74V388.89a7.45,7.45,0,0,0,7.45,7.45h16.64a7.45,7.45,0,0,0,7.45-7.45V301.67a1.45,1.45,0,0,1,2.52-1l15.48,17h0a14.15,14.15,0,1,0,23.61-15.6Z" />
			<path className="cls-2" d="M183.72,247.6c-12,0-19.87-7.24-19.87-18.29V217.24c0-11.05,7.89-18.29,19.87-18.29s20,7.24,20,18.29v12.07C203.69,240.36,195.7,247.6,183.72,247.6Z" />
			<path className="cls-3" d="M130.53,302.06h0a14.2,14.2,0,0,1,1.38-1.74l25.88-32.63a35.64,35.64,0,0,0,2.81-4.35c1.65-2.85,4.31-4.05,7.82-4.05h27.82a7.45,7.45,0,0,1,7.45,7.45V388.89a7.45,7.45,0,0,1-7.45,7.45H179.59a7.45,7.45,0,0,1-7.45-7.45V301.67a1.45,1.45,0,0,0-2.52-1l-15.48,17h0a14.15,14.15,0,1,1-23.61-15.6Z" />
		</>}
	</svg>)
};

export const HumberSvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons list ${className}`} x="0" y="0" viewBox="0 0 512 512">
		<line className="Rib1" x1="30" y1="42" x2="480" y2="42" strokeWidth="60px" strokeLinecap="round" strokeLinejoin="round" />
		<path className="hide" fill="#267b77" d="M295.385,288.821H32.821C14.69,288.821,0,274.13,0,256s14.69-32.821,32.821-32.821h262.564
		c18.13,0,32.821,14.69,32.821,32.821S313.515,288.821,295.385,288.821z"/>
		<path className="hide" d="M479.18,288.821h-52.513c-18.13,0-32.821-14.69-32.821-32.821s14.69-32.821,32.821-32.821h52.513c18.13,0,32.82,14.69,32.82,32.821S497.31,288.821,479.18,288.821z" />
		<line className="Rib2" x1="30" y1="460" x2="480" y2="460" strokeWidth="60px" strokeLinecap="round" strokeLinejoin="round" />
	</svg>)
};
/** Crossed swords: post battles. */
export const BattleSvg = ({ className, size = 24 }) => {
	const sword = "M21 3v3.6L10.2 17.4l-3.6-3.6L17.4 3Z M5.1 15.3l3.6 3.6-1.3 1.3-1.1-1.1-2.1 2.1-1.2-1.2 2.1-2.1-1.1-1.1Z";
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 24 24">
		<path d={sword} />
		<path d={sword} transform="matrix(-1 0 0 1 24 0)" />
	</svg>)
};
/** A location pin with a person inside: Nearby. */
export const NearbySvg = ({ className, size = 24 }) => {
	/////////////////////////////////////////////
	return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
		className={`icons ${className}`} x="0" y="0" viewBox="0 0 24 24">
		<path fillRule="evenodd" d="M12 1.5a8 8 0 0 0-8 8c0 5.6 6.6 11.9 7.3 12.6a1 1 0 0 0 1.4 0c.7-.7 7.3-7 7.3-12.6a8 8 0 0 0-8-8Zm0 4a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 6.5c2.3 0 4.2 1.2 4.6 2.9a.8.8 0 0 1-.4.9 9 9 0 0 1-8.4 0 .8.8 0 0 1-.4-.9c.4-1.7 2.3-2.9 4.6-2.9Z" />
	</svg>)
};
/** Outline icons for the post card and comments; they draw with `currentColor`. */
const LineIcon = ({ className = "", size = 24, filled = false, children }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
		className={`icons line ${className}`} fill={filled ? "currentColor" : "none"} stroke="currentColor"
		strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		{children}
	</svg>
);

export const CommentLineSvg = (props) => (<LineIcon {...props}>
	<path d="M21 12a8 8 0 0 1-8 8H6l-3 3V12a8 8 0 0 1 8-8h2a8 8 0 0 1 8 8Z" />
</LineIcon>);

export const ShareLineSvg = (props) => (<LineIcon {...props}>
	<path d="m17 2 4 4-4 4" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
	<path d="m7 22-4-4 4-4" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
</LineIcon>);

/** Bookmark; `filled` when the post is saved. */
export const SaveLineSvg = (props) => (<LineIcon {...props}>
	<path d="M6 3h12v18l-6-4-6 4z" />
</LineIcon>);

export const ImageLineSvg = (props) => (<LineIcon {...props}>
	<rect x="3" y="5" width="18" height="14" rx="2" /><circle cx="9" cy="10" r="2" />
	<path d="m21 16-5-5-9 8" />
</LineIcon>);

export const MicLineSvg = (props) => (<LineIcon {...props}>
	<rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v3" />
</LineIcon>);

/** "↩ replying to" arrow. */
export const ReplyBackSvg = (props) => (<LineIcon {...props}>
	<path d="M9 14 4 9l5-5" /><path d="M20 20v-7a4 4 0 0 0-4-4H4" />
</LineIcon>);

/** Pen on a line: quote / write about. */
export const QuoteLineSvg = (props) => (<LineIcon {...props}>
	<path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
</LineIcon>);

export const LinkLineSvg = (props) => (<LineIcon {...props}>
	<path d="M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7" />
	<path d="M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7" />
</LineIcon>);

export const GroupLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="9" cy="8" r="3.5" /><path d="M2.5 20a6.5 6.5 0 0 1 13 0" />
	<path d="M16 4.5a3.5 3.5 0 0 1 0 7M18 14.5a6.5 6.5 0 0 1 3.5 5.5" />
</LineIcon>);

/** Box with an arrow out: hand to another app. */
export const ExportLineSvg = (props) => (<LineIcon {...props}>
	<path d="M12 3v12M7.5 7.5 12 3l4.5 4.5" /><path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7" />
</LineIcon>);

export const CheckLineSvg = (props) => (<LineIcon {...props}>
	<path d="m5 12 5 5L20 7" />
</LineIcon>);

export const GlobeLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
</LineIcon>);

export const AtLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="12" cy="12" r="4" /><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8" />
</LineIcon>);

export const HashLineSvg = (props) => (<LineIcon {...props}>
	<path d="M4 9h16M4 15h16M10 3 8 21M16 3l-2 18" />
</LineIcon>);

export const ChevronDownLineSvg = (props) => (<LineIcon {...props}>
	<path d="m6 9 6 6 6-6" />
</LineIcon>);

/** Outline icons for the direct chat. */
export const PinLineSvg = (props) => (<LineIcon {...props}>
	<path d="M9 4h6l-1 6 3 3H7l3-3z" /><path d="M12 13v8" />
</LineIcon>);

export const ForwardLineSvg = (props) => (<LineIcon {...props}>
	<path d="m15 14 5-5-5-5" /><path d="M4 20v-7a4 4 0 0 1 4-4h12" />
</LineIcon>);

export const CopyLineSvg = (props) => (<LineIcon {...props}>
	<rect x="9" y="9" width="12" height="12" rx="2" /><path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" />
</LineIcon>);

export const InfoLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="12" cy="12" r="9" /><path d="M12 16v-5M12 8h.01" />
</LineIcon>);

export const TrashLineSvg = (props) => (<LineIcon {...props}>
	<path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" />
</LineIcon>);

export const DotsLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="5" cy="12" r="1" /><circle cx="12" cy="12" r="1" /><circle cx="19" cy="12" r="1" />
</LineIcon>);

/** A game controller (games in a chat). */
export const GameLineSvg = (props) => (<LineIcon {...props}>
	<path d="M7 7h10a5 5 0 0 1 4.9 6l-.6 3a3 3 0 0 1-5.2 1.4L14.5 16h-5l-1.6 1.4A3 3 0 0 1 2.7 16l-.6-3A5 5 0 0 1 7 7Z" /><path d="M7.5 10.5v3M6 12h3M15.5 11h.01M17.5 13h.01" />
</LineIcon>);

export const PlusLineSvg = (props) => (<LineIcon {...props}>
	<path d="M12 5v14M5 12h14" />
</LineIcon>);

export const SmileLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="12" cy="12" r="9" /><path d="M8 14a5 5 0 0 0 8 0M9 9h.01M15 9h.01" />
</LineIcon>);

/** Paper plane; mirrored in RTL by its parent. */
export const SendLineSvg = (props) => (<LineIcon {...props}>
	<path d="M21 3 10 14" /><path d="m21 3-7 18-4-7-7-4z" />
</LineIcon>);

export const CheckAllLineSvg = (props) => (<LineIcon {...props}>
	<path d="m2 12 5 5L17 7" /><path d="m12 16 1 1L23 7" />
</LineIcon>);

export const ClockLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />
</LineIcon>);

export const FlagLineSvg = (props) => (<LineIcon {...props}>
	<path d="M5 21V4h12l-2.5 4.5L17 13H5" />
</LineIcon>);

/** A draw offer in a game: two equal halves. */
export const DrawLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="12" cy="12" r="9" /><path d="M8 10h8M8 14h8" />
</LineIcon>);

export const AlertLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="12" cy="12" r="9" /><path d="M12 7v6M12 16.5h.01" />
</LineIcon>);

export const FileLineSvg = (props) => (<LineIcon {...props}>
	<path d="M14 3H6v18h12V7z" /><path d="M14 3v4h4" />
</LineIcon>);

export const SearchLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="11" cy="11" r="7" /><path d="m20 20-4-4" />
</LineIcon>);

export const CloseLineSvg = (props) => (<LineIcon {...props}>
	<path d="M6 6l12 12M18 6 6 18" />
</LineIcon>);

/** Chevron pointing back (mirrored in RTL by its parent). */
export const BackLineSvg = (props) => (<LineIcon {...props}>
	<path d="m15 5-7 7 7 7" />
</LineIcon>);

export const PlayLineSvg = (props) => (<LineIcon {...props} filled>
	<path d="M8 5v14l11-7z" />
</LineIcon>);

export const PauseLineSvg = (props) => (<LineIcon {...props} filled>
	<path d="M7 5h3v14H7zM14 5h3v14h-3z" />
</LineIcon>);

/** Points to the end of the line; flip it in RTL. */
export const ChevronEndLineSvg = (props) => (<LineIcon {...props}>
	<path d="m9 6 6 6-6 6" />
</LineIcon>);

export const EditLineSvg = (props) => (<LineIcon {...props}>
	<path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4Z" /><path d="m14.5 5.5 3 3" />
</LineIcon>);

export const BriefcaseLineSvg = (props) => (<LineIcon {...props}>
	<rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18" />
</LineIcon>);

export const MapPinLineSvg = (props) => (<LineIcon {...props}>
	<path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21Z" /><circle cx="12" cy="9.5" r="2.5" />
</LineIcon>);

export const CakeLineSvg = (props) => (<LineIcon {...props}>
	<path d="M4 21V13a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8M3 21h18M4 16c2.7 1.3 5.3-1.3 8 0s5.3 1.3 8 0" />
	<path d="M12 11V8M12 5.5 12 4" />
</LineIcon>);

export const TranslateLineSvg = (props) => (<LineIcon {...props}>
	<path d="M4 5h9M8.5 3v2M11 5c-1 4-3.5 7-7 8.5M6 9c1.2 2 3 3.5 5 4.5" /><path d="m12 21 4.5-10 4.5 10M13.8 17h5.4" />
</LineIcon>);

export const PhoneLineSvg = (props) => (<LineIcon {...props}>
	<path d="M5 3h3.5l1.5 5-2.2 1.4a11 11 0 0 0 6.8 6.8L16 14l5 1.5V19a2 2 0 0 1-2 2A16 16 0 0 1 3 5a2 2 0 0 1 2-2Z" />
</LineIcon>);

export const CalendarLineSvg = (props) => (<LineIcon {...props}>
	<rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" />
</LineIcon>);

export const SchoolLineSvg = (props) => (<LineIcon {...props}>
	<path d="m2 9 10-5 10 5-10 5Z" /><path d="M6 11v5c3 2.5 9 2.5 12 0v-5M22 9v6" />
</LineIcon>);

export const AwardLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="12" cy="9" r="6" /><path d="m8.5 14-1.5 7 5-3 5 3-1.5-7" />
</LineIcon>);

export const LockLineSvg = (props) => (<LineIcon {...props}>
	<rect x="4" y="10" width="16" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 8 0v3" />
</LineIcon>);

export const ExternalLineSvg = (props) => (<LineIcon {...props}>
	<path d="M14 4h6v6M20 4l-9 9" /><path d="M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" />
</LineIcon>);

/** Muting someone: a speaker with a slash. */
export const VolumeOffSvg = ({ className, size = 24 }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" className={`icons ${className}`} aria-hidden="true">
		<path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.8 8.8 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06a8.99 8.99 0 0 0 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4 9.91 6.09 12 8.18V4z" />
	</svg>
);

/** Unmuting someone: a speaker with sound. */
export const VolumeOnSvg = ({ className, size = 24 }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" className={`icons ${className}`} aria-hidden="true">
		<path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
	</svg>
);

export const MusicLineSvg = (props) => (<LineIcon {...props}>
	<path d="M9 18V5l11-2v13" /><circle cx="6" cy="18" r="3" /><circle cx="17" cy="16" r="3" />
</LineIcon>);

export const ScissorsLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="6" cy="6" r="3" /><circle cx="6" cy="18" r="3" /><path d="M20 4 8.1 15.9M14.5 14.5 20 20M8.1 8.1 12 12" />
</LineIcon>);

export const UploadLineSvg = (props) => (<LineIcon {...props}>
	<path d="M12 15V4M7 9l5-5 5 5" /><path d="M4 15v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4" />
</LineIcon>);

export const StopLineSvg = (props) => (<LineIcon {...props} filled>
	<rect x="6" y="6" width="12" height="12" rx="2" />
</LineIcon>);

/** Filters: a big and a small spark. */
export const SparkleLineSvg = (props) => (<LineIcon {...props}>
	<path d="M10 3.5 11.8 8.2 16.5 10 11.8 11.8 10 16.5 8.2 11.8 3.5 10 8.2 8.2Z" /><path d="M18 14v6M15 17h6" />
</LineIcon>);

/** Adjust: three sliders. */
export const TuneLineSvg = (props) => (<LineIcon {...props}>
	<path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12" /><circle cx="16" cy="6" r="2" /><circle cx="10" cy="12" r="2" /><circle cx="18" cy="18" r="2" />
</LineIcon>);

/** Business pages: a shop front with an awning. */
export const StoreLineSvg = (props) => (<LineIcon {...props}>
	<path d="M4 10v10h16V10" /><path d="M3 4h18l-1.5 6a2.5 2.5 0 0 1-4.5 0 2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1-4.5 0Z" /><path d="M10 20v-5h4v5" />
</LineIcon>);

/** A rating star; `filled` for a chosen one. */
export const StarLineSvg = (props) => (<LineIcon {...props}>
	<path d="m12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9Z" />
</LineIcon>);

/** Directions: a navigation arrow. */
export const DirectionsLineSvg = (props) => (<LineIcon {...props}>
	<path d="M3 11 21 3l-8 18-2-8Z" />
</LineIcon>);

/** WhatsApp: a speech bubble with a handset. */
export const WhatsappLineSvg = (props) => (<LineIcon {...props}>
	<path d="M3.5 20.5 5 16a8.5 8.5 0 1 1 3 3Z" /><path d="M9 8.5c0 3.5 3 6.5 6.5 6.5l1-1.6-2-1-1 .8a4 4 0 0 1-2.2-2.2l.8-1-1-2Z" />
</LineIcon>);

/** Insights: rising bars. */
export const ChartLineSvg = (props) => (<LineIcon {...props}>
	<path d="M4 20h16" /><path d="M7 16v-4M12 16V8M17 16V5" />
</LineIcon>);

/** Verification: a shield with a tick. */
export const ShieldCheckLineSvg = (props) => (<LineIcon {...props}>
	<path d="M12 3 5 6v5c0 4.5 3 8.3 7 10 4-1.7 7-5.5 7-10V6Z" /><path d="m9 12 2 2 4-4" />
</LineIcon>);

/** Messages to the future: an hourglass (filled, for the side menu and notifications). */
export const HourglassSvg = ({ className, size = 24 }) => (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
	className={`icons ${className}`} viewBox="0 0 24 24">
	<path fillRule="evenodd" d="M6 2h12a1 1 0 1 1 0 2h-1v2.6a5 5 0 0 1-1.9 3.9L13.2 12l1.9 1.5a5 5 0 0 1 1.9 3.9V20h1a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2h1v-2.6a5 5 0 0 1 1.9-3.9l1.9-1.5-1.9-1.5A5 5 0 0 1 7 6.6V4H6a1 1 0 0 1 0-2Zm3 2v2.6a3 3 0 0 0 1.1 2.3L12 10.4l1.9-1.5A3 3 0 0 0 15 6.6V4H9Zm3 9.6-1.9 1.5A3 3 0 0 0 9 17.4V18h6v-.6a3 3 0 0 0-1.1-2.3L12 13.6Z" />
</svg>);

/** Messages to the future, as a line icon. */
export const HourglassLineSvg = (props) => (<LineIcon {...props}>
	<path d="M6 3h12M6 21h12" /><path d="M8 3v3.5a4 4 0 0 0 1.6 3.2L12 12l2.4-2.3A4 4 0 0 0 16 6.5V3" /><path d="M8 21v-3.5a4 4 0 0 1 1.6-3.2L12 12l2.4 2.3a4 4 0 0 1 1.6 3.2V21" />
</LineIcon>);

/** A video camera. */
export const VideoLineSvg = (props) => (<LineIcon {...props}>
	<rect x="3" y="6" width="13" height="12" rx="3" /><path d="m16 10 5-3v10l-5-3" />
</LineIcon>);

/** An open lock (a message to the future that was opened). */
export const UnlockLineSvg = (props) => (<LineIcon {...props}>
	<rect x="4" y="10" width="16" height="11" rx="2" /><path d="M8 10V7a4 4 0 0 1 7.5-2" />
</LineIcon>);

/** A story: a ring around a dot. */
export const StoryLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="12" cy="12" r="9" strokeDasharray="4 2.5" /><circle cx="12" cy="12" r="4.5" />
</LineIcon>);

/** A reminder bell. */
export const BellLineSvg = (props) => (<LineIcon {...props}>
	<path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15Z" /><path d="M10 20.5a2 2 0 0 0 4 0" />
</LineIcon>);

/** An announcements channel: a megaphone. */
export const MegaphoneLineSvg = (props) => (<LineIcon {...props}>
	<path d="M3 10v4a1 1 0 0 0 1 1h3l6 4V5L7 9H4a1 1 0 0 0-1 1Z" /><path d="M17 9a4 4 0 0 1 0 6" /><path d="M7 15l1 5h2.5l-1-5" />
</LineIcon>);

/** A muted channel: the bell with a slash. */
export const BellOffLineSvg = (props) => (<LineIcon {...props}>
	<path d="M8.5 5.2A6 6 0 0 1 18 11v5l.5.7M6 11v5l-1.5 2H16" /><path d="M10 20.5a2 2 0 0 0 4 0" /><path d="M3 3l18 18" />
</LineIcon>);

/** A like on an answered question; pass `filled` once liked. */
export const HeartLineSvg = (props) => (<LineIcon {...props}>
	<path d="M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7a4.3 4.3 0 0 1 7.5 2.8C19.5 15.4 12 20 12 20Z" />
</LineIcon>);

/** Inviting people to a team. */
export const UserPlusLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="9" cy="8" r="4" /><path d="M2.5 20a6.5 6.5 0 0 1 13 0" /><path d="M19 8v6M16 11h6" />
</LineIcon>);

/** A microphone with a stroke through it: muted. */
export const MicOffLineSvg = (props) => (<LineIcon {...props}>
	<path d="M15 9.5V6a3 3 0 0 0-5.7-1.3M9 9v2a3 3 0 0 0 4.6 2.5M5 11a7 7 0 0 0 11.2 5.6M19 11a7 7 0 0 1-.6 2.8M12 18v3M3 3l18 18" />
</LineIcon>);

/** A video camera with a stroke through it: camera off. */
export const VideoOffLineSvg = (props) => (<LineIcon {...props}>
	<path d="M10 6h3a3 3 0 0 1 3 3v3m0 3a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V9a3 3 0 0 1 2-2.8M16 10l5-3v10l-3-1.8M3 3l18 18" />
</LineIcon>);

/** A handset turned down: hang up / decline. */
export const PhoneOffLineSvg = (props) => (<LineIcon {...props} filled>
	<path d="M3.2 13.6c4.9-4.8 12.7-4.8 17.6 0 .5.5.5 1.2.1 1.7l-1.6 1.9a1.2 1.2 0 0 1-1.5.3l-2.6-1.3a1.2 1.2 0 0 1-.6-1.1l.1-1.6a9.4 9.4 0 0 0-5.4 0l.1 1.6c0 .5-.2.9-.6 1.1l-2.6 1.3a1.2 1.2 0 0 1-1.5-.3l-1.6-1.9a1.2 1.2 0 0 1 .1-1.7Z" />
</LineIcon>);

/** A raised hand: asking to speak in a room. */
export const HandLineSvg = (props) => (<LineIcon {...props}>
	<path d="M8 13V5.5a1.5 1.5 0 0 1 3 0V11m0-6.5V4a1.5 1.5 0 0 1 3 0v7m0-5.5a1.5 1.5 0 0 1 3 0V12m0-3.5a1.5 1.5 0 0 1 3 0V15a7 7 0 0 1-7 7h-1.2a6 6 0 0 1-4.6-2.2L3.6 15.4a1.6 1.6 0 0 1 2.4-2.1L8 15" />
</LineIcon>);

/** Headphones: back to the listeners. */
export const HeadphonesLineSvg = (props) => (<LineIcon {...props}>
	<path d="M4 15v-3a8 8 0 0 1 16 0v3" /><rect x="3" y="14" width="5" height="7" rx="2" /><rect x="16" y="14" width="5" height="7" rx="2" />
</LineIcon>);

/** A person with a minus: remove. */
export const UserMinusLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="9" cy="8" r="4" /><path d="M2 21a7 7 0 0 1 14 0M16 11h6" />
</LineIcon>);

/** A filled heart: hearts on a live. */
export const HeartFilledSvg = (props) => (<LineIcon {...props} filled>
	<path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8 3.6 4.5 7.1 4.5c2 0 3.6 1.1 4.9 2.8 1.3-1.7 2.9-2.8 4.9-2.8 3.5 0 5.6 3.5 4.4 6.8-1.8 4.6-9.3 9.2-9.3 9.2Z" />
</LineIcon>);

/** An eye: people watching. */
export const EyeLineSvg = (props) => (<LineIcon {...props}>
	<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z" /><circle cx="12" cy="12" r="3" />
</LineIcon>);

/** Radio waves around a dot: going live. */
export const BroadcastLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="12" cy="12" r="2" /><path d="M8.5 15.5a5 5 0 0 1 0-7M15.5 8.5a5 5 0 0 1 0 7M5.6 18.4a9 9 0 0 1 0-12.8M18.4 5.6a9 9 0 0 1 0 12.8" />
</LineIcon>);

/** A microphone on a stand with sound waves: audio rooms (side menu). */
export const AudioRoomsSvg = ({ className, size = 24 }) => (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
	className={`icons ${className}`} x="0" y="0" viewBox="0 0 24 24">
	<path d="M12 2a3.5 3.5 0 0 0-3.5 3.5v5a3.5 3.5 0 0 0 7 0v-5A3.5 3.5 0 0 0 12 2Z" />
	<path d="M6.2 9.5a1 1 0 0 1 1 1 4.8 4.8 0 0 0 9.6 0 1 1 0 1 1 2 0 6.8 6.8 0 0 1-5.8 6.7V20h2.5a1 1 0 1 1 0 2H8.5a1 1 0 1 1 0-2H11v-2.8a6.8 6.8 0 0 1-5.8-6.7 1 1 0 0 1 1-1Z" />
	<path d="M2.6 6.2a1 1 0 0 1 1.4.3 7.5 7.5 0 0 1 0 8 1 1 0 1 1-1.7-1 5.5 5.5 0 0 0 0-6 1 1 0 0 1 .3-1.3ZM21.4 6.2a1 1 0 0 1 .3 1.3 5.5 5.5 0 0 0 0 6 1 1 0 1 1-1.7 1 7.5 7.5 0 0 1 0-8 1 1 0 0 1 1.4-.3Z" />
</svg>);

/** An envelope: e-mail. */
export const MailLineSvg = (props) => (<LineIcon {...props}>
	<rect x="3" y="5" width="18" height="14" rx="3" /><path d="m4 7 8 6 8-6" />
</LineIcon>);

/** A key: the account's password. */
export const KeyLineSvg = (props) => (<LineIcon {...props}>
	<circle cx="8" cy="15" r="4" /><path d="m10.8 12.2 8.7-8.7M16 7l2.5 2.5M18.5 4.5 21 7" />
</LineIcon>);

/** Two arrows in a circle: send again. */
export const RefreshLineSvg = (props) => (<LineIcon {...props}>
	<path d="M20 11a8 8 0 0 0-14.3-4.6L4 8.5M4 4v4.5h4.5M4 13a8 8 0 0 0 14.3 4.6L20 15.5M20 20v-4.5h-4.5" />
</LineIcon>);

/** A speech bubble with lines: a text message. */
export const MessageLineSvg = (props) => (<LineIcon {...props}>
	<path d="M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-9l-5 4v-4H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z" /><path d="M7.5 9.5h9M7.5 12.5h6" />
</LineIcon>);

/** Google's "G", in its four colours (brand mark: never recoloured). */
export const GoogleSvg = ({ className = "", size = 24 }) => (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
	className={`icons brand ${className}`} viewBox="0 0 24 24" aria-hidden="true">
	<path fill="#4285F4" d="M22.5 12.3c0-.8-.1-1.5-.2-2.2H12v4.2h5.9a5 5 0 0 1-2.2 3.3v2.7h3.6c2-1.9 3.2-4.7 3.2-8z" />
	<path fill="#34A853" d="M12 23c3 0 5.5-1 7.3-2.7l-3.6-2.7c-1 .7-2.2 1-3.7 1-2.9 0-5.3-1.9-6.2-4.5H2.1v2.8A11 11 0 0 0 12 23z" />
	<path fill="#FBBC05" d="M5.8 14.1a6.6 6.6 0 0 1 0-4.2V7.1H2.1a11 11 0 0 0 0 9.8z" />
	<path fill="#EA4335" d="M12 5.4c1.6 0 3 .6 4.2 1.6l3.1-3.1A11 11 0 0 0 2.1 7.1l3.7 2.8C6.7 7.3 9.1 5.4 12 5.4z" />
</svg>);

/** Apple's logo, in the text colour. */
export const AppleSvg = ({ className = "", size = 24 }) => (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
	className={`icons brand ${className}`} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
	<path d="M16.4 12.6c0-2.4 2-3.6 2.1-3.7a4.6 4.6 0 0 0-3.6-2c-1.5-.2-3 .9-3.7.9-.8 0-2-.9-3.2-.8A4.8 4.8 0 0 0 4 9.4c-1.7 3-.4 7.4 1.2 9.8.8 1.2 1.8 2.5 3 2.4 1.2 0 1.7-.8 3.2-.8s1.9.8 3.2.8c1.3 0 2.1-1.2 2.9-2.4.9-1.3 1.3-2.6 1.3-2.7 0 0-2.4-1-2.4-3.9zM14 5.4c.7-.8 1.1-1.9 1-3-1 0-2.1.7-2.8 1.5-.6.7-1.2 1.8-1 2.9 1 .1 2.1-.6 2.8-1.4z" />
</svg>);

/** WhatsApp's filled logo, in the text colour. */
export const WhatsappSvg = ({ className = "", size = 24 }) => (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
	className={`icons brand ${className}`} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
	<path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.3-.5 0-1 .2-3.3-.7a11.6 11.6 0 0 1-4.6-4.1c-.4-.6-1-1.6-1-3s.8-2.1 1-2.4c.3-.3.6-.4.8-.4h.6c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .6l-.4.6-.4.4c-.1.2-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.4 2.4 1.5.3.1.5.1.6-.1l.9-1c.2-.3.4-.2.7-.1l1.9.9c.3.1.5.2.5.3.1.2.1.8-.1 1.4z" />
</svg>);
